import * as t from "https://cdn.fibbl.com/model-viewer/fibbl-modelviewer.js";
var e = {
        998: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, "@keyframes fade-in{0%,10%{opacity:0}100%{opacity:1}}@keyframes fade-out{0%{opacity:1}100%{opacity:0}}div.in-transition{animation:fade-out .1s linear forwards}div:is(.minified,.expanded-root):not(.in-transition){animation:fade-in .3s linear}div.expanded-root{height:100%;width:100%;box-sizing:border-box;margin:0;border:none}div.expanded-root x-fibbl-close-button{display:initial}div.expanded-root #expand-button{display:none !important}x-fibbl-close-button,#expand-button,x-fibbl-expand-button{--close-button-size: clamp(20px, 5%, 35px);--close-button-margin: calc(var(--close-button-size, 35px) / 2);margin:var(--close-button-margin);width:var(--close-button-size);height:var(--close-button-size);position:absolute;top:0;right:0;cursor:pointer;z-index:10;color:#000;display:none;overscroll-behavior:none}x-fibbl-close-button:hover,#expand-button:hover,x-fibbl-expand-button:hover{transform:scale(1.1)}:host{display:block;width:100%;height:100%;box-sizing:border-box}#root{position:relative;width:100%;height:100%;box-sizing:border-box;background:rgba(0,0,0,.8);color:#fff;font-size:32px;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;opacity:1;transition:opacity .5s}x-fibbl-spinner{height:3em;width:3em;margin-bottom:1em}x-fibbl-close-button{display:block;color:inherit;--size: 35px}", ""]);
            const s = a
        },
        3955: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, "#product-block{max-width:90%;position:absolute;top:0;left:0;z-index:2;margin:calc(var(--close-button-size, 35px) / 2);display:flex;flex-direction:column;gap:.5em}.mobile #product-block{font-size:14px;right:0;width:calc(100% - 2*calc(var(--close-button-size, 35px) / 2));top:unset;max-width:unset;bottom:0}#switching-spinner{position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);width:4em;height:4em;color:#e7e7e7;z-index:3}#product-info,#product-switcher{max-width:100%;font-size:var(--dynamic-font-size);background:#fff;padding:5px;border-radius:16px;--child-border-radius: 11px;box-sizing:border-box;gap:1em;overflow:hidden}.mobile #product-info,.mobile #product-switcher{font-size:inherit}#product-info img,#product-switcher img{width:100%;aspect-ratio:1;object-fit:contain;border-radius:var(--child-border-radius)}#product-switcher{display:flex;align-items:center;justify-content:start;height:3.5em;overflow:hidden;width:min-content}.mobile #product-switcher{margin:0 auto;overflow:auto}.mobile #product-switcher img{flex:0 0 auto}#product-switcher img{min-width:0;width:unset;flex:1 1 0;max-height:100%;cursor:pointer}#product-switcher img.selected{box-shadow:0 0 1px 1px gray}#product-info{display:grid;height:calc(5em + 10px);width:25em;grid-template-columns:5em 1fr 4em;align-items:center}.mobile #product-info{width:100%}#product-info #text{display:flex;flex-direction:column;gap:.5em;overflow:hidden}#product-info #text #product-title{font-weight:600;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}#product-info a{all:unset;display:flex;align-items:center;justify-content:center;text-align:center;cursor:pointer;height:2.5em;font-weight:600;background:#162023;color:#fff;border-radius:var(--child-border-radius);line-height:1}#product-info a svg{font-size:2em}#product-info #sale-price{display:none;font-weight:600;color:#fa4b65}#product-info.sale #sale-price{display:initial}#product-info.sale #product-price{text-decoration:line-through;margin-left:.5em}#tips{box-sizing:border-box;position:absolute;bottom:0;width:100%;font-size:var(--dynamic-font-size);gap:min(2em,2vw);height:3em;background:linear-gradient(to top, rgba(0, 0, 0, 0.6666666667), transparent);z-index:3;color:#fff;display:flex;align-items:center;justify-content:center}#tips__content{display:flex;gap:inherit}#tips__content>*{overflow:hidden;max-height:100%;padding:0 .1em;display:flex;align-items:center}#tips__content>* x-fibbl-sun-icon,#tips__content>* x-fibbl-swipe-icon{font-size:1.5em;margin-right:.5em}#tips x-fibbl-close-button{display:none}#tips x-fibbl-powered-by{position:absolute;top:100%;right:0;font-size:1.8em;margin-top:.5em}:host{display:block;width:100%;height:100%;box-sizing:border-box;contain:strict;overflow:hidden;font-family:system-ui,-apple-system;-webkit-font-smoothing:antialiased}#root{display:flex;justify-content:center;align-items:center;box-sizing:border-box;width:100%;height:100%;color:#000;--video-width: min(75vw, 75vh);--video-height: min(75vw, 75vh);--video-aspect-ratio: 1 / 1;--video-aspect-ratio-value: 1;--svg-shadow: drop-shadow(0 0 3px rgba(128, 128, 128, 0.5));--svg-hover-shadow: drop-shadow(0 0 3px rgba(0, 0, 0, 0.5));--svg-active-shadow: drop-shadow(0 0 3px white);--svg-active-color: #3b3939;--svg-color: white;--close-button-size: clamp(20px, 5%, 35px);--close-button-margin: calc(var(--close-button-size, 35px) / 2);--dynamic-font-size: min(16px, calc(var(--video-width) / 50), 2vw)}#root:not(.ready),#root.error-root{--svg-color: currentColor;--svg-shadow: none}#root:not(.ready) #tips,#root.error-root #tips{display:none}#dark_layer{position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.6)}@keyframes fadeIn{from{opacity:0}to{opacity:1}}x-fibbl-glasses-vto{transition:opacity .5s;opacity:0;z-index:1;cursor:grab}x-fibbl-glasses-vto:active{cursor:grabbing}#root.ready x-fibbl-glasses-vto{opacity:initial}.mobile x-fibbl-glasses-vto::part(canvas){object-fit:cover}#content{position:relative;height:var(--video-height);width:auto;aspect-ratio:var(--video-aspect-ratio);max-height:min(90%,90vw/var(--video-aspect-ratio-value));max-width:90vw;flex:0 0 auto;z-index:1;animation:fadeIn 0.3s both;transition:width 0.3s,height 0.3s,aspect-ratio 0.3s}#content.mobile{max-width:none;max-height:none;aspect-ratio:auto;width:100%;height:100%;--close-button-size: 35px}#content.third-party #tips,#content.third-party x-fibbl-slider{display:none}x-fibbl-loading-cube{width:100%;height:100%;position:relative;background:#fff;z-index:5;transition:opacity .3s,visibility 0s .3s}#root.ready x-fibbl-loading-cube{position:absolute;visibility:hidden;opacity:0;z-index:-1}.error:not([style*=display])~x-fibbl-loading-cube{display:none}.error{width:100%;height:100%;position:relative;background:#fff;z-index:5;display:flex;text-align:center;flex-direction:column;justify-content:center;align-items:center;overflow:hidden;min-height:fit-content;box-sizing:border-box;padding-top:calc(var(--close-button-size)*2);font-size:min(16px,2vh,2vw)}.mobile .error h2{margin:auto 0}.mobile .error p,.mobile .error x-fibbl-qr-code{display:none}.error h2{margin:0;font-weight:600;font-size:1.8em;padding:0 .5em}.error p{margin-top:auto;font-size:1.2em}.error x-fibbl-qr-code{flex:1 1 auto;margin:1em;max-height:50%}.error x-fibbl-powered-by{margin-top:auto;margin-bottom:10px;font-size:min(36px,3em)}x-fibbl-slider{position:absolute;bottom:50%;transform:translateY(50%);right:0;margin:calc(var(--close-button-size, 35px) / 2);width:var(--close-button-size);height:clamp(min(150px,100% - var(--close-button-size)*1.5),30%,300px);z-index:2}#main-close-button{--close-button-size: clamp(20px, 5%, 35px);--close-button-margin: calc(var(--close-button-size, 35px) / 2);margin:var(--close-button-margin);width:var(--close-button-size);height:var(--close-button-size);position:absolute;top:0;right:0;cursor:pointer;z-index:10;--close-button-size: inherit;z-index:10}#main-close-button::part(path){filter:var(--svg-shadow);stroke:var(--svg-color)}#root.ready:not(.error-root) #main-close-button::part(path){stroke-width:4px}#main-close-button:hover{transform:scale(1.1)}#main-close-button:hover::part(path){filter:var(--svg-hover-shadow)}#main-close-button:active::part(path){stroke:var(--svg-active-color);filter:var(--svg-active-shadow)}.footwear-vto{all:unset;display:block;width:100%;height:100%;box-sizing:border-box;background:#fff}canvas.footwear-vto{object-fit:cover}", ""]);
            const s = a
        },
        9247: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, ":host{display:block;width:25px;height:100%;margin:2em}#root{--track-width: 5px;--thumb-scale: 4;width:100%;padding:calc(var(--track-width)*var(--thumb-scale)/2) 0;height:100%;display:flex;justify-content:center;box-sizing:border-box;position:relative;user-select:none;touch-action:none}#root.active #thumb{border:1px solid #add8e6}#track{cursor:pointer;background:#fff;width:var(--track-width);height:100%;border-radius:100vw;display:flex;justify-content:center;position:relative;box-shadow:0 0 2px #d3d3d3}#thumb{width:calc(var(--track-width)*var(--thumb-scale));height:calc(var(--track-width)*var(--thumb-scale));border-radius:100vw;background:#fff;position:absolute;transform:translateY(50%);bottom:100%;box-shadow:0px 3px 1px -2px rgba(0,0,0,.2),0px 2px 2px rgba(0,0,0,.14),0px 1px 5px rgba(0,0,0,.12);z-index:1}", ""]);
            const s = a
        },
        781: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, "@keyframes fade-in{0%,10%{opacity:0}100%{opacity:1}}@keyframes fade-out{0%{opacity:1}100%{opacity:0}}div.in-transition{animation:fade-out .1s linear forwards}div:is(.minified,.expanded-root):not(.in-transition){animation:fade-in .3s linear}div.expanded-root{height:100%;width:100%;box-sizing:border-box;margin:0;border:none}div.expanded-root x-fibbl-close-button{display:initial}div.expanded-root #expand-button{display:none !important}x-fibbl-close-button,#expand-button,x-fibbl-expand-button{--close-button-size: clamp(20px, 5%, 35px);--close-button-margin: calc(var(--close-button-size, 35px) / 2);margin:var(--close-button-margin);width:var(--close-button-size);height:var(--close-button-size);position:absolute;top:0;right:0;cursor:pointer;z-index:10;color:#000;display:none;overscroll-behavior:none}x-fibbl-close-button:hover,#expand-button:hover,x-fibbl-expand-button:hover{transform:scale(1.1)}:host(.x-fibbl-modal-window){width:100%;height:100%;display:flex !important;justify-content:center;align-items:center;background:#fff}:host(.x-fibbl-modal-window)>x-fibbl-close-button{display:initial}:host(.x-fibbl-modal-window)>fibbl-qr-code{width:70%;height:70%}", ""]);
            const s = a
        },
        4285: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, ":host{display:inline-block}svg{stroke:currentColor;width:100%;height:100%}path{stroke-width:3px;vector-effect:non-scaling-stroke;stroke-linejoin:round;stroke-linecap:round}", ""]);
            const s = a
        },
        1061: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, ":host{display:inline-block}svg{stroke:currentColor;fill:currentColor;width:100%;height:100%}path{stroke-width:2px;vector-effect:non-scaling-stroke}", ""]);
            const s = a
        },
        7670: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, "iframe{all:unset;display:block;height:100%;width:100%;box-sizing:border-box}x-fibbl-close-button{--close-button-size: 35px}x-fibbl-close-button.white{color:#fff}x-fibbl-close-button.white::part(path){filter:drop-shadow(0 0 3px rgba(128, 128, 128, 0.5));stroke-width:4px}", ""]);
            const s = a
        },
        7623: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, ":host{display:block;box-sizing:border-box;width:100%;height:100%}.root{font-family:system-ui,-apple-system;-webkit-font-smoothing:antialiased;position:relative;z-index:0;width:100%;height:100%;box-sizing:border-box;display:flex;align-items:center;flex-direction:column;justify-content:space-around;margin:0 auto;font-weight:200;text-align:center;color:#000;--container-size: 520px;font-size:clamp(12px,var(--container-size)/20,20px);--desired-first-frame-size: 80px;--cube-size: calc(var(--desired-first-frame-size) * 0.6123724356957945 * 2);--spinner-color: #b9bcbd}x-fibbl-spinner{width:var(--cube-size);height:var(--cube-size);color:var(--spinner-color)}x-fibbl-simple-spinner{width:calc(var(--cube-size)*.7);height:calc(var(--cube-size)*.7);color:var(--spinner-color)}.cube-with-phrase{--additional-padding: calc((var(--cube-size) - var(--desired-first-frame-size)) / 2);margin:auto 0;height:calc(120px + var(--additional-padding));width:200px;box-sizing:content-box;padding-bottom:var(--additional-padding);display:flex;flex-direction:column;align-items:center}.loading-phrase{white-space:nowrap;color:var(--spinner-color);font-size:16px;line-height:1em;font-weight:normal;margin-top:auto}x-fibbl-powered-by{position:absolute;bottom:0;margin-left:auto;margin-right:auto}", ""]);
            const s = a
        },
        652: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, ".x-fibbl-modal-window{position:fixed;top:0;left:0;z-index:9007199254740991;overscroll-behavior:none;box-sizing:border-box}", ""]);
            const s = a
        },
        7837: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, "html,body{max-height:100% !important;max-width:100% !important;overflow:hidden !important;box-sizing:border-box !important}", ""]);
            const s = a
        },
        3588: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, ":host{display:inline-block;margin-bottom:10px;font-size:24px;line-height:1}x-fibbl-and,#vyking-logo,#art-labs-logo{display:none}#root{font-size:var(--x-fibbl-powered-by-font-size, inherit);display:flex;gap:.35em;align-items:center}x-fibbl-powered-by-phrase{font-size:.3em}#logos{display:flex;align-items:center;gap:.4em}:host([data-with-art-labs=true]) #root,:host([data-with-vyking=true]) #root{flex-direction:column;gap:.2em}:host([data-with-art-labs=true]) x-fibbl-and,:host([data-with-vyking=true]) x-fibbl-and{display:initial;font-size:.6em}:host([data-with-vyking=true]) #vyking-logo{display:initial;height:.7em}:host([data-with-art-labs=true]) #art-labs-logo{display:initial;height:1em}", ""]);
            const s = a
        },
        726: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, ":host{display:inline-block;box-sizing:border-box}.root{--root-size: 200px;--size: calc(var(--root-size) * 0.5);--half-size: calc(var(--size) / 2);width:100%;height:100%;display:flex;justify-content:center;align-items:center;overflow:hidden;contain:strict}.root *{transform-style:preserve-3d;width:calc(var(--size) + .5px);height:calc(var(--size) + .5px)}@keyframes new-rotate{0%{transform:rotateZ(0deg)}33%{transform:rotateY(90deg) rotateX(90deg) rotateZ(-1turn)}33.0001%{transform:rotateY(90deg) rotateX(90deg)}66%{transform:rotateZ(-90deg) rotateY(90deg) rotateY(90deg) rotateX(90deg) rotateZ(1turn)}66.0001%{transform:rotateZ(-90deg) rotateY(90deg) rotateY(90deg) rotateX(90deg)}100%{transform:rotateY(90deg) rotateX(90deg) rotateZ(-90deg) rotateY(90deg) rotateY(90deg) rotateX(90deg) rotateZ(1turn)}}.cube{--base-x-rotation: -35.264deg;--base-transfrom: rotateX(var(--base-x-rotation)) rotateY(45deg);transform-style:preserve-3d;transform:var(--base-transfrom)}.cube *{position:absolute}.wrapper{z-index:0;animation:new-rotate 2s ease;animation-delay:.1s;--base-y-rotation: 45deg;animation-iteration-count:1;transform-style:preserve-3d;transition:transform .5s;transform-origin:50% 50%;position:relative}.wrapper .top{transform:rotateX(90deg) translateZ(var(--half-size));transform-origin:50% 50%}.wrapper .bottom{transform:rotateX(-90deg) translateZ(var(--half-size));transform-origin:50% 50%}.wrapper .front{transform:rotateY(0deg) translateZ(var(--half-size));transform-origin:50% 50%}.wrapper .back{transform:rotateY(-180deg) translateZ(var(--half-size));transform-origin:50% 50%}.wrapper .left{transform:rotateY(-90deg) translateZ(var(--half-size));transform-origin:50% 50%}.wrapper .right{transform:rotateY(90deg) translateZ(var(--half-size));transform-origin:50% 50%}.wrapper>*{display:block;outline:1px solid rgba(0,0,0,0);backface-visibility:hidden;width:calc(var(--size) + 1px);height:calc(var(--size) + 1px);color:currentColor}.wrapper>*:not(svg){box-sizing:border-box;background-color:currentColor}", ""]);
            const s = a
        },
        4918: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, ":host{display:block;position:absolute;box-sizing:border-box;font-family:system-ui,-apple-system;-webkit-font-smoothing:antialiased;z-index:9007199254740990;top:0;left:0;font-size:14px;overflow:hidden}:host([data-enabled=true]){width:100%;height:100%}:host(:not([data-enabled=true])){width:0;height:0;opacity:0}#root{position:relative;height:100%}fibbl-model-viewer{transition:opacity .3s;opacity:0}.loaded fibbl-model-viewer{opacity:1}fibbl-model-viewer.hidden{opacity:0}#loading{position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);font-weight:400;font-size:18px;color:#e7e7e7;text-shadow:0 0 2px #000;display:flex;align-items:center;gap:.5em}#loading x-fibbl-spinner{height:2em;width:2em}.loaded #loading{display:none}", ""]);
            const s = a
        },
        2318: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, ":host{position:absolute;top:0;left:50%;transform:translateX(-50%);margin-top:1em;z-index:9007199254740991;font-family:system-ui,-apple-system;-webkit-font-smoothing:antialiased;font-size:14px}#root{padding:1px;background:#d9d5dc;border-radius:50px;display:grid;grid-template-columns:1fr 1fr}#root button{all:unset;display:inline-block;border-radius:50px;padding:0.5em 0.5em;cursor:pointer;text-align:center}#root button.active{color:#2196F3;font-weight: 700;background:#ffffff}", ""]);
            const s = a
        },
        5342: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, "@keyframes fade-in{0%,10%{opacity:0}100%{opacity:1}}@keyframes fade-out{0%{opacity:1}100%{opacity:0}}div.in-transition{animation:fade-out .1s linear forwards}div:is(.minified,.expanded-root):not(.in-transition){animation:fade-in .3s linear}div.expanded-root{height:100%;width:100%;box-sizing:border-box;margin:0;border:none}div.expanded-root x-fibbl-close-button{display:initial}div.expanded-root #expand-button{display:none !important}x-fibbl-close-button,#expand-button,x-fibbl-expand-button{--close-button-size: clamp(20px, 5%, 35px);--close-button-margin: calc(var(--close-button-size, 35px) / 2);margin:var(--close-button-margin);width:var(--close-button-size);height:var(--close-button-size);position:absolute;top:0;right:0;cursor:pointer;z-index:10;color:#000;display:none;overscroll-behavior:none}x-fibbl-close-button:hover,#expand-button:hover,x-fibbl-expand-button:hover{transform:scale(1.1)}@keyframes fade-in{0%,10%{opacity:0}100%{opacity:1}}@keyframes fade-out{0%{opacity:1}100%{opacity:0}}div.in-transition{animation:fade-out .1s linear forwards}div:is(.minified,.expanded-root):not(.in-transition){animation:fade-in .3s linear}div.expanded-root{height:100%;width:100%;box-sizing:border-box;margin:0;border:none}div.expanded-root x-fibbl-close-button{display:initial}div.expanded-root #expand-button{display:none !important}x-fibbl-close-button,#expand-button,x-fibbl-expand-button{--close-button-size: clamp(20px, 5%, 35px);--close-button-margin: calc(var(--close-button-size, 35px) / 2);margin:var(--close-button-margin);width:var(--close-button-size);height:var(--close-button-size);position:absolute;top:0;right:0;cursor:pointer;z-index:10;color:#000;display:none;overscroll-behavior:none}x-fibbl-close-button:hover,#expand-button:hover,x-fibbl-expand-button:hover{transform:scale(1.1)}#more{--close-button-size: clamp(20px, 5%, 35px);--close-button-margin: calc(var(--close-button-size, 35px) / 2);position:absolute;box-sizing:border-box;bottom:0;right:0;font-size:12px;display:flex;align-items:end;margin-right:var(--close-button-margin);margin-bottom:var(--close-button-margin);flex-direction:column;gap:1em;z-index:2;width:max-content;--button-size: 3.5em;--icon-size: 2em;--button-margin: 1em;--transition-time: 0.5s;--main-color: #162023}#more #more-button{all:unset;box-sizing:border-box;cursor:pointer;position:relative;width:var(--button-size);height:var(--button-size);background:var(--main-color);border-radius:1000px;display:flex;align-items:center;justify-content:center;z-index:2}#more #more-button>*{box-sizing:border-box;position:absolute;width:calc(var(--icon-size) - 2px);height:2px;background:#fff}#more #more-button>*#vertical{width:2px;height:calc(var(--icon-size) - 2px)}#more .action-button{all:unset;box-sizing:border-box;display:flex;justify-content:end;font-weight:600;padding-bottom:var(--button-margin)}#more .action-button .inner-button-wrapper{border-radius:1000px;cursor:pointer;max-width:100%;display:inline-flex;flex-direction:row-reverse;align-items:center;justify-content:end}#more .action-button .inner-button-wrapper span{box-sizing:border-box;overflow:hidden;white-space:nowrap;margin:0 .5em}#more .action-button .inner-button-wrapper:active{text-shadow:0 0 1px var(--main-color)}#more .action-button .icon{box-sizing:border-box;border-radius:1000px;padding:calc((var(--button-size) - var(--icon-size))/2);color:#fff;background:var(--main-color);z-index:1}#more .action-button .icon::part(svg){font-size:var(--icon-size)}#more .action-button{position:absolute;opacity:0;z-index:-1;transition-property:max-width,bottom,opacity;transition-duration:var(--transition-time);transition-delay:var(--transition-time);bottom:0;pointer-events:none}#more .action-button .inner-button-wrapper{max-width:var(--button-size);transition-property:max-width;transition-duration:var(--transition-time);transition-delay:0s}#more #more-button>*{transition:transform;transition-duration:var(--transition-time);transition-delay:var(--transition-time)}#more.open #more-button>*{transition-delay:0s}#more.open #more-button #vertical{transform:rotate(270deg)}#more.open #more-button #horizontal{transform:rotate(180deg)}#more.open .action-button{z-index:1;opacity:1;transition-delay:0s;pointer-events:initial}#more.open .action-button .inner-button-wrapper{max-width:100%;transition-delay:var(--transition-time)}#more.open .action-button:nth-of-type(1){bottom:calc(100% + (var(--button-size) + var(--button-margin))*0)}#more.open .action-button:nth-of-type(2){bottom:calc(100% + (var(--button-size) + var(--button-margin))*1)}@keyframes fade-in{0%,10%{opacity:0}100%{opacity:1}}@keyframes fade-out{0%{opacity:1}100%{opacity:0}}div.in-transition{animation:fade-out .1s linear forwards}div:is(.minified,.expanded-root):not(.in-transition){animation:fade-in .3s linear}div.expanded-root{height:100%;width:100%;box-sizing:border-box;margin:0;border:none}div.expanded-root x-fibbl-close-button{display:initial}div.expanded-root #expand-button{display:none !important}x-fibbl-close-button,#expand-button,x-fibbl-expand-button{--close-button-size: clamp(20px, 5%, 35px);--close-button-margin: calc(var(--close-button-size, 35px) / 2);margin:var(--close-button-margin);width:var(--close-button-size);height:var(--close-button-size);position:absolute;top:0;right:0;cursor:pointer;z-index:10;color:#000;display:none;overscroll-behavior:none}x-fibbl-close-button:hover,#expand-button:hover,x-fibbl-expand-button:hover{transform:scale(1.1)}#light-controls{display:none;align-items:center;font-size:20px;gap:.5em;color:#162023}:host([data-_is-expanded]) #light-controls,.expanded-root #light-controls{display:flex}#light-controls .light-button{width:1.6em;height:1.6em;border-radius:100em;border:1px solid currentColor;position:relative;display:flex;align-items:center;justify-content:center;cursor:pointer}#light-controls .light-button>span{display:inline-block;position:absolute;box-sizing:border-box;background:currentColor}#light-controls .light-button>span:first-child{height:2px;width:50%}#light-controls .light-button>span:nth-child(2){width:2px;height:50%}#light-controls .light-button:hover>*{transform:scale(1.1)}#light-controls .light-button:active{box-shadow:0 0 1px 1px currentColor}#light-controls .light-button.disabled{pointer-events:none;color:gray}#light-controls x-fibbl-icon-reset{cursor:pointer}#light-controls x-fibbl-icon-reset:hover{transform:scale(1.1)}#light-controls x-fibbl-icon-sun,#light-controls x-fibbl-icon-reset{font-size:1.1em}:host{display:block;box-sizing:border-box;width:100%;height:100%;contain:strict;overflow:hidden;font-family:system-ui,-apple-system;-webkit-font-smoothing:antialiased}:host(fibbl-model-viewer){background:#fff}.root{contain:strict;position:relative;width:100%;height:100%;overflow:hidden}.root.loaded.shown #expand-button{display:initial}.root.loaded.shown x-fibbl-loading-cube,.root.loaded.shown #progress-bar{display:none}.root.loaded.shown x-fibbl-model-viewer{opacity:initial}.root:not(.loaded.shown) #top-block,.root:not(.loaded.shown) #more{display:none}x-fibbl-model-viewer{flex:1 1 0;transition:opacity .5s;opacity:0}#progress-bar{--progress: 0%;--color: rgba(0, 0, 0, 0.4);position:absolute;top:0;height:5px;width:100%;z-index:2;background:linear-gradient(to right, var(--color) 0%, var(--color) var(--progress), transparent var(--progress));opacity:1;transition:opacity .5s}x-fibbl-loading-cube{position:absolute;top:0;left:0;width:100%;height:100%;box-sizing:border-box;z-index:1;background:rgba(0,0,0,0)}#top-block{position:absolute;top:calc(var(--close-button-size, 35px)/2);left:50%;transform:translateX(-50%);display:flex;flex-direction:column;gap:2em;align-items:center;z-index:2;width:max-content;max-width:calc(100% - (var(--close-button-size, 35px)/2 + clamp(20px,5%,35px))*2)}#hint{box-sizing:border-box;font-size:12px;font-weight:600;text-align:center}:host(:not(.x-fibbl-modal-window,[data-_show-more])) #more{display:none}", ""]);
            const s = a
        },
        5794: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(8081),
                n = o.n(i),
                r = o(3645),
                a = o.n(r)()(n());
            a.push([t.id, ":host{display:block;box-sizing:border-box;width:100%;height:100%;contain:strict;overflow:hidden;font-family:system-ui,-apple-system;-webkit-font-smoothing:antialiased}@media(hover: hover){:host(:hover) .root:not(.mobile) #overlay{opacity:1}:host(:hover) .root:not(.mobile) #see-button{opacity:0}}.root{position:relative;width:100%;height:100%;overflow:hidden;box-sizing:border-box;display:flex;justify-content:center;align-items:center;--size: 200px;--margin: clamp(10px, calc(var(--size) / 40), 20px);font-size:clamp(8px,var(--size)/20,24px);cursor:pointer;--transition-time: 0.5s}.background{background-repeat:no-repeat;background-size:contain;background-position:center;filter:blur(3px);width:100%;height:100%}#overlay{color:#fff;opacity:0;position:absolute;z-index:2;top:0;left:0;width:100%;height:100%;box-sizing:border-box;display:flex;justify-content:center;align-items:center;flex-direction:column;background:rgba(0,0,0,.6);padding:var(--margin);transition:var(--transition-time) opacity}#overlay h3{all:unset;font-weight:600;font-size:1.2em;margin-bottom:calc(var(--margin)*1.5)}button{position:absolute;padding:1em 3em;background:#000;font-size:.8em;font-weight:600;color:#fff;border:none;transition:var(--transition-time) opacity}.message{font-size:.9em;text-align:center;margin-bottom:var(--margin);max-width:25em}x-fibbl-qr-code{width:auto;height:auto;max-width:min(300px,100%);max-height:300px;aspect-ratio:1;flex:1 1 0;min-height:0}#bvto{display:flex;flex:0 0 auto;flex-direction:column;align-items:center;text-align:center}#bvto p{font-size:.9em;margin:var(--margin) 0}#bvto button{position:unset;background:#fff;color:#000;cursor:pointer;border-radius:.5em}#bvto button:hover{transform:scale(1.1)}#bvto button:active{color:#fff;background:#000}", ""]);
            const s = a
        },
        3645: t => {
            t.exports = function(t) {
                var e = [];
                return e.toString = function() {
                    return this.map((function(e) {
                        var o = "",
                            i = void 0 !== e[5];
                        return e[4] && (o += "@supports (".concat(e[4], ") {")), e[2] && (o += "@media ".concat(e[2], " {")), i && (o += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), o += t(e), i && (o += "}"), e[2] && (o += "}"), e[4] && (o += "}"), o
                    })).join("")
                }, e.i = function(t, o, i, n, r) {
                    "string" == typeof t && (t = [
                        [null, t, void 0]
                    ]);
                    var a = {};
                    if (i)
                        for (var s = 0; s < this.length; s++) {
                            var l = this[s][0];
                            null != l && (a[l] = !0)
                        }
                    for (var d = 0; d < t.length; d++) {
                        var c = [].concat(t[d]);
                        i && a[c[0]] || (void 0 !== r && (void 0 === c[5] || (c[1] = "@layer".concat(c[5].length > 0 ? " ".concat(c[5]) : "", " {").concat(c[1], "}")), c[5] = r), o && (c[2] ? (c[1] = "@media ".concat(c[2], " {").concat(c[1], "}"), c[2] = o) : c[2] = o), n && (c[4] ? (c[1] = "@supports (".concat(c[4], ") {").concat(c[1], "}"), c[4] = n) : c[4] = "".concat(n)), e.push(c))
                    }
                }, e
            }
        },
        8081: t => {
            t.exports = function(t) {
                return t[1]
            }
        },
        5987: t => {
            var e = {
                single_source_shortest_paths: function(t, o, i) {
                    var n = {},
                        r = {};
                    r[o] = 0;
                    var a, s, l, d, c, h, p, u = e.PriorityQueue.make();
                    for (u.push(o, 0); !u.empty();)
                        for (l in s = (a = u.pop()).value, d = a.cost, c = t[s] || {}) c.hasOwnProperty(l) && (h = d + c[l], p = r[l], (void 0 === r[l] || p > h) && (r[l] = h, u.push(l, h), n[l] = s));
                    if (void 0 !== i && void 0 === r[i]) {
                        var m = ["Could not find a path from ", o, " to ", i, "."].join("");
                        throw new Error(m)
                    }
                    return n
                },
                extract_shortest_path_from_predecessor_list: function(t, e) {
                    for (var o = [], i = e; i;) o.push(i), t[i], i = t[i];
                    return o.reverse(), o
                },
                find_path: function(t, o, i) {
                    var n = e.single_source_shortest_paths(t, o, i);
                    return e.extract_shortest_path_from_predecessor_list(n, i)
                },
                PriorityQueue: {
                    make: function(t) {
                        var o, i = e.PriorityQueue,
                            n = {};
                        for (o in t = t || {}, i) i.hasOwnProperty(o) && (n[o] = i[o]);
                        return n.queue = [], n.sorter = t.sorter || i.default_sorter, n
                    },
                    default_sorter: function(t, e) {
                        return t.cost - e.cost
                    },
                    push: function(t, e) {
                        var o = {
                            value: t,
                            cost: e
                        };
                        this.queue.push(o), this.queue.sort(this.sorter)
                    },
                    pop: function() {
                        return this.queue.shift()
                    },
                    empty: function() {
                        return 0 === this.queue.length
                    }
                }
            };
            t.exports = e
        },
        2378: t => {
            t.exports = function(t) {
                for (var e = [], o = t.length, i = 0; i < o; i++) {
                    var n = t.charCodeAt(i);
                    if (n >= 55296 && n <= 56319 && o > i + 1) {
                        var r = t.charCodeAt(i + 1);
                        r >= 56320 && r <= 57343 && (n = 1024 * (n - 55296) + r - 56320 + 65536, i += 1)
                    }
                    n < 128 ? e.push(n) : n < 2048 ? (e.push(n >> 6 | 192), e.push(63 & n | 128)) : n < 55296 || n >= 57344 && n < 65536 ? (e.push(n >> 12 | 224), e.push(n >> 6 & 63 | 128), e.push(63 & n | 128)) : n >= 65536 && n <= 1114111 ? (e.push(n >> 18 | 240), e.push(n >> 12 & 63 | 128), e.push(n >> 6 & 63 | 128), e.push(63 & n | 128)) : e.push(239, 191, 189)
                }
                return new Uint8Array(e).buffer
            }
        },
        9485: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = '<svg viewBox="0 0 100 100" part="svg"> <path part="path" d="M 10 10 L 90 90 z M 90 10 L 10 90"/> </svg> '
        },
        3687: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = '<div class="root" id="root"> <div class="cube-with-phrase"> <x-fibbl-spinner></x-fibbl-spinner> <div class="loading-phrase"></div> </div> <x-fibbl-powered-by></x-fibbl-powered-by> </div> '
        },
        2195: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = '<svg height="1em" viewBox="0 0 177 224" fill="currentColor" xmlns="http://www.w3.org/2000/svg"> <path d="M77.3601 197.702C48.8916 197.702 29.3969 177.901 29.3969 152.221C29.3969 133.657 42.0839 121.901 55.3899 115.094C56.6276 114.475 56.9371 114.475 57.8654 115.403L117.897 180.685C118.825 181.613 118.825 182.541 117.897 183.47C105.519 193.37 92.5227 197.702 77.3601 197.702ZM74.2657 26.2984C90.9755 26.2984 104.281 36.8177 104.281 49.5028C104.281 69.6133 82.3112 78.5856 66.8392 83.2265C65.9108 83.5359 65.292 83.8453 64.3636 82.9171C50.1294 69.6133 43.6311 60.0221 43.6311 49.5028C43.6311 36.8177 56.9371 26.2984 74.2657 26.2984ZM175.453 220.906C176.381 220.906 177 220.287 177 219.359V193.061C177 192.133 176.381 191.514 175.453 191.514C168.645 191.823 167.098 190.276 161.837 185.945L156.886 181.923C155.958 181.304 156.267 180.376 156.886 179.448C163.385 168.309 166.479 151.602 166.479 142.32V115.403C166.479 114.475 165.86 113.856 164.932 113.856H138.629C137.701 113.856 137.082 114.475 137.082 115.403V142.32C137.082 147.271 136.154 151.912 134.916 155.624C134.607 156.862 133.678 157.79 132.75 156.862L83.8584 103.956C82.9301 102.718 83.549 101.481 84.4773 101.171C105.519 94.0553 132.131 80.7514 132.131 49.5028C132.131 24.1326 108.614 0 74.2657 0C38.3706 0 15.7815 22.5856 15.7815 49.5028C15.7815 64.9724 20.4231 75.1823 37.1329 92.8177C38.3706 94.0553 38.3706 95.6022 36.514 96.5304C18.8759 106.74 0 124.376 0 155.315C0 189.967 25.0647 224 77.3601 224C102.115 224 123.776 214.409 137.701 203.89C138.939 202.961 139.248 203.271 139.867 203.89C151.316 215.337 161.837 220.906 175.453 220.906Z"/> </svg> '
        },
        5701: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = '<svg height="1em" viewBox="0 0 670 224" fill="currentColor" xmlns="http://www.w3.org/2000/svg"> <path d="M655.083 138.749C653.122 138.72 651.176 139.085 649.358 139.82C647.54 140.555 645.887 141.647 644.498 143.03C643.108 144.414 642.008 146.061 641.264 147.876C640.521 149.69 640.147 151.636 640.166 153.597C640.166 161.953 646.723 168.369 655.011 168.369C663.366 168.369 670 161.953 670 153.597C670.018 151.636 669.645 149.69 668.901 147.876C668.157 146.061 667.058 144.414 665.668 143.03C664.278 141.647 662.626 140.555 660.808 139.82C658.99 139.085 657.043 138.72 655.083 138.749ZM655.011 165.343C648.382 165.343 643.478 160.371 643.478 153.597C643.478 146.823 648.382 141.846 655.083 141.846C661.712 141.846 666.611 146.818 666.611 153.597C666.611 160.375 661.712 165.343 655.011 165.343Z"/> <path d="M661.421 150.714C661.421 147.684 659.475 145.523 655.8 145.523H649.605V160.873H652.99V155.973H654.782L658.368 160.873H662.55L658.368 155.323C660.632 154.386 661.421 152.727 661.421 150.714ZM655.657 153.019H652.967V148.535H655.657C657.1 148.535 658.037 149.329 658.037 150.777C658.037 152.225 657.1 153.019 655.657 153.019Z"/> <path d="M278.349 55.9988V63.0328V168.037H300.742V121.578H360.383V102.381H300.742V75.1911H365.444V55.9988H284.395H278.349Z"/> <path d="M400.656 95.4639H378.271V168.037H400.656V95.4639Z"/> <path d="M401.866 55.9988H377.057V81.4137H401.866V55.9988Z"/> <path d="M628.898 55.9988H606.514V167.956H628.898V55.9988Z"/> <path d="M462.122 80.943C450.338 80.943 442.565 84.2336 437.496 89.7882H435.82V55.9988H413.453V167.961H433.713L435.838 161.563H438.079C443.135 166.593 450.737 169.557 462.117 169.557C489.374 169.557 501.718 149.719 501.718 125.25C501.718 100.781 490.714 80.943 462.122 80.943ZM456.483 151.673C445.443 151.673 439.033 146.876 435.82 139.636C435.383 138.635 435.007 137.608 434.695 136.561L434.6 136.247C433.98 134.05 433.573 131.798 433.386 129.522C433.386 129.262 433.336 128.998 433.319 128.738C433.238 127.586 433.18 126.42 433.18 125.227C433.18 124.035 433.238 122.892 433.323 121.753C433.323 121.497 433.368 121.246 433.39 120.995C433.493 119.883 433.628 118.781 433.838 117.718C434.047 116.564 434.318 115.422 434.65 114.298C434.662 114.267 434.673 114.235 434.681 114.203C435.002 113.135 435.388 112.086 435.838 111.065C439.092 103.713 445.573 98.8217 456.501 98.8217C473.314 98.8217 479.809 110.653 479.809 125.25C479.809 139.847 472.538 151.673 456.501 151.673H456.483Z"/> <path d="M558.168 80.943C546.384 80.943 538.612 84.2336 533.542 89.7882H531.866V55.9988H509.481V167.961H529.741L531.866 161.563H534.129C539.185 166.593 546.787 169.557 558.168 169.557C585.424 169.557 597.769 149.719 597.769 125.25C597.769 100.781 586.729 80.943 558.168 80.943ZM552.529 151.673C541.489 151.673 535.08 146.876 531.866 139.636C531.429 138.635 531.053 137.608 530.741 136.561L530.647 136.247C530.026 134.05 529.619 131.798 529.432 129.522C529.41 129.262 529.383 128.998 529.365 128.738C529.28 127.586 529.226 126.42 529.226 125.227C529.226 124.035 529.284 122.892 529.369 121.753C529.369 121.497 529.414 121.246 529.437 120.995C529.54 119.883 529.674 118.781 529.885 117.718C530.096 116.572 530.368 115.437 530.7 114.32C530.7 114.289 530.7 114.257 530.732 114.226C531.052 113.157 531.439 112.109 531.888 111.088C535.142 103.735 541.624 98.8441 552.552 98.8441C569.364 98.8441 575.859 110.675 575.859 125.272C575.859 139.869 568.567 151.673 552.529 151.673Z"/> <path d="M96.9738 0L0 55.9989V167.997L96.9738 223.996V111.998L169.663 70.0221V98.0238L121.218 125.999L121.187 154.018L145.346 140.067L145.463 139.999L169.591 126.066V154.063L121.187 182.015L121.218 209.999L193.952 167.997L193.948 55.9989L96.9738 0Z"/> </svg> '
        },
        4044: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = '<svg height="1em" viewBox="0 0 657 117" fill="currentColor" xmlns="http://www.w3.org/2000/svg"> <path d="M0.6 90.36C0.6 90.744 0.856001 91 1.24 91H12.12C12.504 91 12.76 90.744 12.76 90.36V55.8C12.76 55.416 13.016 55.16 13.4 55.16H38.616C52.696 55.16 64.728 43.512 64.728 28.28C64.728 13.048 52.696 0.887993 38.616 0.887993H1.24C0.856001 0.887993 0.6 1.144 0.6 1.52799V90.36ZM37.08 11.768C45.144 11.768 52.568 19.448 52.568 28.28C52.568 37.112 45.144 44.28 37.08 44.28H13.4C13.016 44.28 12.76 44.024 12.76 43.64V12.408C12.76 12.024 13.016 11.768 13.4 11.768H37.08ZM132.596 58.616C132.596 38.648 120.82 24.952 100.852 24.952C80.756 24.952 69.108 38.52 69.108 58.616C69.108 78.584 80.756 92.28 100.852 92.28C120.82 92.28 132.596 78.584 132.596 58.616ZM120.436 58.616C120.436 71.928 113.14 81.4 100.852 81.4C88.692 81.4 81.268 71.928 81.268 58.616C81.268 45.304 88.692 35.832 100.852 35.832C113.14 35.832 120.436 45.304 120.436 58.616ZM214.05 91C214.434 91 214.69 90.744 214.818 90.36L230.05 26.872C230.178 26.36 229.666 26.232 229.282 26.232H218.402C218.018 26.232 217.89 26.488 217.762 26.872L206.626 78.328C206.498 78.968 205.474 78.968 205.346 78.328L192.674 26.872C192.546 26.488 192.418 26.232 192.034 26.232H176.29C175.906 26.232 175.778 26.488 175.65 26.872L162.978 78.328C162.85 78.968 161.826 78.968 161.698 78.328L150.562 26.872C150.434 26.488 150.306 26.232 149.922 26.232H139.042C138.658 26.232 138.146 26.36 138.274 26.872L153.506 90.36C153.634 90.744 153.89 91 154.274 91H170.53C170.914 91 171.042 90.744 171.17 90.36L183.458 39.288C183.586 38.648 184.61 38.648 184.738 39.288L197.154 90.36C197.282 90.744 197.41 91 197.794 91H214.05ZM297.039 62.968C297.423 62.968 297.807 62.584 297.935 62.2C298.191 61.176 298.319 59.896 298.319 58.616C298.319 38.648 287.055 24.952 267.087 24.952C247.247 24.952 235.983 38.52 235.983 58.616C235.983 78.584 247.887 92.28 267.087 92.28C281.551 92.28 292.943 84.984 296.271 72.44C296.399 71.928 296.015 71.8 295.631 71.8H284.239C283.855 71.8 283.599 71.928 283.343 72.44C280.655 77.56 276.175 81.4 267.087 81.4C255.695 81.4 248.911 72.952 248.911 63.608C248.911 63.224 249.167 62.968 249.551 62.968H297.039ZM285.007 52.728C285.007 53.112 284.751 53.368 284.367 53.368H249.551C249.295 53.368 248.911 53.112 248.911 52.728C248.911 46.712 254.671 35.832 267.087 35.832C279.759 35.832 285.007 45.432 285.007 52.728ZM347.806 35.832C348.19 35.832 348.446 35.576 348.446 35.192V25.592C348.446 25.208 348.19 24.952 347.806 24.952H341.278C334.878 24.952 330.142 28.408 325.79 32.76C325.406 33.144 324.638 33.4 324.382 32.632L323.102 26.872C322.974 26.488 322.846 26.232 322.462 26.232H312.862C312.478 26.232 312.222 26.488 312.222 26.872V90.36C312.222 90.744 312.478 91 312.862 91H323.742C324.126 91 324.382 90.744 324.382 90.36V55.16C324.382 45.176 330.526 35.832 341.278 35.832H347.806ZM413.414 62.968C413.798 62.968 414.182 62.584 414.31 62.2C414.566 61.176 414.694 59.896 414.694 58.616C414.694 38.648 403.43 24.952 383.462 24.952C363.622 24.952 352.358 38.52 352.358 58.616C352.358 78.584 364.262 92.28 383.462 92.28C397.926 92.28 409.318 84.984 412.646 72.44C412.774 71.928 412.39 71.8 412.006 71.8H400.614C400.23 71.8 399.974 71.928 399.718 72.44C397.03 77.56 392.55 81.4 383.462 81.4C372.07 81.4 365.286 72.952 365.286 63.608C365.286 63.224 365.542 62.968 365.926 62.968H413.414ZM401.382 52.728C401.382 53.112 401.126 53.368 400.742 53.368H365.926C365.67 53.368 365.286 53.112 365.286 52.728C365.286 46.712 371.046 35.832 383.462 35.832C396.134 35.832 401.382 45.432 401.382 52.728ZM485.301 91C485.685 91 485.941 90.744 485.941 90.36V1.52799C485.941 1.144 485.685 0.887993 485.301 0.887993H474.421C474.037 0.887993 473.781 1.144 473.781 1.52799V31.992C473.781 32.504 473.141 33.016 472.501 32.248C470.965 30.456 463.157 24.952 454.197 24.952C435.509 24.952 423.733 38.648 423.733 58.616C423.733 78.584 435.509 92.28 454.197 92.28C460.597 92.28 469.045 88.44 472.501 84.984C472.885 84.6 473.525 84.472 473.781 85.24L475.061 90.36C475.189 90.744 475.317 91 475.701 91H485.301ZM435.893 58.616C435.893 45.304 443.189 35.832 455.477 35.832C467.125 35.832 473.781 45.304 473.781 58.616C473.781 71.928 467.125 81.4 455.477 81.4C443.189 81.4 435.893 71.928 435.893 58.616ZM540.712 91C541.096 91 541.224 90.744 541.352 90.36L542.632 85.24C542.888 84.472 543.528 84.6 543.912 84.984C547.368 88.44 555.816 92.28 562.216 92.28C580.904 92.28 592.68 78.584 592.68 58.616C592.68 38.648 580.904 24.952 562.216 24.952C553.256 24.952 545.448 30.456 543.912 32.248C543.272 33.016 542.632 32.504 542.632 31.992V1.52799C542.632 1.144 542.376 0.887993 541.992 0.887993H531.112C530.728 0.887993 530.472 1.144 530.472 1.52799V90.36C530.472 90.744 530.728 91 531.112 91H540.712ZM580.52 58.616C580.52 71.928 573.224 81.4 560.936 81.4C549.288 81.4 542.632 71.928 542.632 58.616C542.632 45.304 549.288 35.832 560.936 35.832C573.224 35.832 580.52 45.304 580.52 58.616ZM595.738 115.704C595.738 116.088 595.994 116.344 596.378 116.344H613.018C623.386 116.344 627.354 112.504 630.938 102.136L656.538 26.872C656.666 26.488 656.282 26.232 655.898 26.232H644.25C643.866 26.232 643.738 26.488 643.61 26.872L626.714 78.328C626.458 79.096 625.69 79.096 625.434 78.328L608.666 26.872C608.538 26.488 608.41 26.232 608.026 26.232H596.378C595.994 26.232 595.482 26.36 595.61 26.872L618.394 93.816C620.698 100.6 618.394 105.464 610.842 105.464H596.378C595.994 105.464 595.738 105.72 595.738 106.104V115.704Z"/> </svg> '
        },
        7875: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(7091),
                n = o.n(i),
                r = new URL(o(4224), o.b),
                a = new URL(o(4266), o.b);
            const s = '<div id="root"> <x-fibbl-powered-by-phrase></x-fibbl-powered-by-phrase> <div id="logos"> <x-fibbl-logo></x-fibbl-logo> <x-fibbl-and></x-fibbl-and> <img src="' + n()(r) + '" alt="Vyking Logo" id="vyking-logo" loading="lazy"/> <img src="' + n()(a) + '" alt="ArtLabs Logo" id="art-labs-logo" loading="lazy"/> </div> </div> '
        },
        5741: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = '<div class="root"> <div class="cube"> <div class="wrapper"> <div class="top"></div> <div class="right"></div> <div class="bottom"></div> <div class="left"></div> <svg class="front" viewBox="0 0 100 100" fill="currentColor"> <path d="M 75,0 L 75,25 25,25 25,50 75,50 75,75 25,75 25,100 100,100 100,0 "></path> </svg> <div class="back"></div> </div> </div> </div> '
        },
        20: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = '<style>:host{display:inline-block;box-sizing:border-box;width:100px;height:100px}</style> <svg viewBox="0 0 200 200" preserveAspectRatio="xMidYMid meet" fill="currentColor" style="width:100%;height:100%;transform:translate3d(0,0,0)"> <path style="display:block" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100,100)" d=" M-1.5,-268.75 C-1.5,-268.75 -239,-136 -239,-136 C-239,-136 -232.375,131.875 -232.375,131.875 C-232.375,131.875 -1.75,275.375 -1.75,275.375 C-1.75,275.375 -1.75,3.25 -1.75,3.25 C-1.75,3.25 179.75,-103.5 179.75,-103.5 C179.75,-103.5 178.375,-33.5 178.375,-33.5 C178.375,-33.5 60.375,38 60.375,38 C60.375,38 60.375,104.125 60.375,104.125 C60.375,104.125 177.375,32.25 177.375,32.25 C177.375,32.25 177.375,101 177.375,101 C177.375,101 59.75,173.375 59.75,173.375 C59.75,173.375 59.25,238.25 59.25,238.25 C59.25,238.25 230.125,131.75 230.125,131.75 C230.125,131.75 236.375,-136 236.375,-136 C236.375,-136 -1.5,-268.75 -1.5,-268.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100,100)" d=" M-2.75,-269.25 C-2.75,-269.25 -239.75,-134.5 -239.75,-134.5 C-239.75,-134.5 -231.5,131.75 -231.5,131.75 C-231.5,131.75 -0.5,274.5 -0.5,274.5 C-0.5,274.5 -2,3.75 -2,3.75 C-2,3.75 178.875,-103.75 178.875,-103.75 C178.875,-103.75 178.5,-34 178.5,-34 C178.5,-34 60.375,38.625 60.375,38.625 C60.375,38.625 60.375,104.5 60.375,104.5 C60.375,104.5 176.75,31.75 176.75,31.75 C176.75,31.75 177.125,100.25 177.125,100.25 C177.125,100.25 60.25,173.375 60.25,173.375 C60.25,173.375 60.375,237.75 60.375,237.75 C60.375,237.75 230.75,130.25 230.75,130.25 C230.75,130.25 235.75,-136.625 235.75,-136.625 C235.75,-136.625 -2.75,-269.25 -2.75,-269.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100,100)" d=" M-6.25,-269.75 C-6.25,-269.75 -243,-130 -243,-130 C-243,-130 -228.875,135 -228.875,135 C-228.875,135 3.625,276.75 3.625,276.75 C3.625,276.75 -4.5,8.5 -4.5,8.5 C-4.5,8.5 176.25,-105.125 176.25,-105.125 C176.25,-105.125 177.125,-35.625 177.125,-35.625 C177.125,-35.625 59.5,40 59.5,40 C59.5,40 60.5,105 60.5,105 C60.5,105 177.75,29.875 177.75,29.875 C177.75,29.875 178.75,97.5 178.75,97.5 C178.75,97.5 62,173.75 62,173.75 C62,173.75 64.25,237.375 64.25,237.375 C64.25,237.375 234,125.25 234,125.25 C234,125.25 233,-139.25 233,-139.25 C233,-139.25 -6.25,-269.75 -6.25,-269.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100,100)" d=" M-13.5,-272.5 C-13.5,-272.5 -248,-119.5 -248,-119.5 C-248,-119.5 -222.875,138.625 -222.875,138.625 C-222.875,138.625 10.5,277.5 10.5,277.5 C10.5,277.5 -8,15.75 -8,15.75 C-8,15.75 170.75,-106.75 170.75,-106.75 C170.75,-106.75 174.75,-39 174.75,-39 C174.75,-39 58.25,43 58.25,43 C58.25,43 62.25,106.5 62.25,106.5 C62.25,106.5 178,25 178,25 C178,25 181.5,92.25 181.5,92.25 C181.5,92.25 66.75,173.5 66.75,173.5 C66.75,173.5 70.25,235.5 70.25,235.5 C70.25,235.5 238.75,115.75 238.75,115.75 C238.75,115.75 227,-144.25 227,-144.25 C227,-144.25 -13.5,-272.5 -13.5,-272.5z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100,100)" d=" M-24.75,-275 C-24.75,-275 -255.25,-103.5 -255.25,-103.5 C-255.25,-103.5 -213.5,145 -213.5,145 C-213.5,145 22,279.5 22,279.5 C22,279.5 -13.25,27.75 -13.25,27.75 C-13.25,27.75 162.5,-108.5 162.5,-108.5 C162.5,-108.5 170.75,-43.5 170.75,-43.5 C170.75,-43.5 56,47.5 56,47.5 C56,47.5 64.375,108.5 64.375,108.5 C64.375,108.5 177.5,19 177.5,19 C177.5,19 186,83.25 186,83.25 C186,83.25 72.75,173.5 72.75,173.5 C72.75,173.5 81,232.75 81,232.75 C81,232.75 245.5,100.5 245.5,100.5 C245.5,100.5 218.25,-150.75 218.25,-150.75 C218.25,-150.75 -24.75,-275 -24.75,-275z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100,100)" d=" M-42,-276.5 C-42,-276.5 -264.25,-80.5 -264.25,-80.5 C-264.25,-80.5 -199,151.75 -199,151.75 C-199,151.75 39,279.75 39,279.75 C39,279.75 -19.75,45.5 -19.75,45.5 C-19.75,45.5 150.5,-110.25 150.5,-110.25 C150.5,-110.25 164.75,-48.5 164.75,-48.5 C164.75,-48.5 54,54.75 54,54.75 C54,54.75 67.75,111.5 67.75,111.5 C67.75,111.5 176.75,10.25 176.75,10.25 C176.75,10.25 190.5,69.5 190.5,69.5 C190.5,69.5 82.25,172.75 82.25,172.75 C82.25,172.75 96,227.5 96,227.5 C96,227.5 255,78.25 255,78.25 C255,78.25 204,-159 204,-159 C204,-159 -42,-276.5 -42,-276.5z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.07499694824219,100)" d=" M-67,-275.5 C-67,-275.5 -274.75,-47.5 -274.75,-47.5 C-274.75,-47.5 -178,158.75 -178,158.75 C-178,158.75 63.75,277.5 63.75,277.5 C63.75,277.5 -25.5,70.25 -25.5,70.25 C-25.5,70.25 132.75,-110.25 132.75,-110.25 C132.75,-110.25 155,-55 155,-55 C155,-55 52.25,64 52.25,64 C52.25,64 73.5,114.75 73.5,114.75 C73.5,114.75 175,-2.75 175,-2.75 C175,-2.75 196.75,50.75 196.75,50.75 C196.75,50.75 96.5,168.5 96.5,168.5 C96.5,168.5 117,218 117,218 C117,218 264.25,46 264.25,46 C264.25,46 183,-167 183,-167 C183,-167 -67,-275.5 -67,-275.5z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.07499694824219,100)" d=" M-103.25,-268.25 C-103.25,-268.25 -280.75,-0.75 -280.75,-0.75 C-280.75,-0.75 -147.25,162 -147.25,162 C-147.25,162 98.75,267.5 98.75,267.5 C98.75,267.5 -27.75,106 -27.75,106 C-27.75,106 108.75,-104.75 108.75,-104.75 C108.75,-104.75 140.75,-60.5 140.75,-60.5 C140.75,-60.5 52.75,77.75 52.75,77.75 C52.75,77.75 83,118 83,118 C83,118 170.25,-18.5 170.25,-18.5 C170.25,-18.5 202.25,25 202.25,25 C202.25,25 115.75,160.25 115.75,160.25 C115.75,160.25 144.75,199.25 144.75,199.25 C144.75,199.25 272,0 272,0 C272,0 152.25,-170.75 152.25,-170.75 C152.25,-170.75 -103.25,-268.25 -103.25,-268.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.07499694824219,100)" d=" M-154.25,-243 C-154.25,-243 -277.75,64.5 -277.75,64.5 C-277.75,64.5 -106.25,152.5 -106.25,152.5 C-106.25,152.5 142.75,238.75 142.75,238.75 C142.75,238.75 -18.75,154.25 -18.75,154.25 C-18.75,154.25 77,-86.75 77,-86.75 C77,-86.75 120,-61.25 120,-61.25 C120,-61.25 58.5,96.5 58.5,96.5 C58.5,96.5 99.25,118.75 99.25,118.75 C99.25,118.75 160.25,-37.5 160.25,-37.5 C160.25,-37.5 202.25,-13 202.25,-13 C202.25,-13 142,142 142,142 C142,142 180.5,163.25 180.5,163.25 C180.5,163.25 270.5,-63.5 270.5,-63.5 C270.5,-63.5 107.75,-164 107.75,-164 C107.75,-164 -154.25,-243 -154.25,-243z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.07499694824219,100)" d=" M-21.75,-199.75 C-21.75,-199.75 -220.5,-177.25 -220.5,-177.25 C-220.5,-177.25 -246.75,149 -246.75,149 C-246.75,149 19.75,210.75 19.75,210.75 C19.75,210.75 41.25,-42.5 41.25,-42.5 C41.25,-42.5 92.25,-49.5 92.25,-49.5 C92.25,-49.5 78.75,117.5 78.75,117.5 C78.75,117.5 126,109 126,109 C126,109 139.75,-56.25 139.75,-56.25 C139.75,-56.25 189.25,-62.75 189.25,-62.75 C189.25,-62.75 175.75,100 175.75,100 C175.75,100 221.75,92 221.75,92 C221.75,92 242.75,-149.5 242.75,-149.5 C242.75,-149.5 -21.75,-199.75 -21.75,-199.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.07499694824219,100)" d=" M141.75,-235.25 C141.75,-235.25 -129,-233.875 -129,-233.875 C-129,-233.875 -276,-8.375 -276,-8.375 C-276,-8.375 -140.5,228.75 -140.5,228.75 C-140.5,228.75 128.75,239.75 128.75,239.75 C128.75,239.75 31.5,58.25 31.5,58.25 C31.5,58.25 68.75,-2.25 68.75,-2.25 C68.75,-2.25 133.5,118.75 133.5,118.75 C133.5,118.75 167.25,61.75 167.25,61.75 C167.25,61.75 102.75,-58.75 102.75,-58.75 C102.75,-58.75 139,-118 139,-118 C139,-118 202,2.75 202,2.75 C202,2.75 235.25,-52.75 235.25,-52.75 C235.25,-52.75 141.75,-235.25 141.75,-235.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.07499694824219,100)" d=" M-1.25,-274.25 C-1.25,-274.25 -233,-134.75 -233,-134.75 C-233,-134.75 -238.75,138.25 -238.75,138.25 C-238.75,138.25 -1.5,265 -1.5,265 C-1.5,265 236.5,137.75 236.5,137.75 C236.5,137.75 235.25,69 235.25,69 C235.25,69 177.25,36.5 177.25,36.5 C177.25,36.5 174,-101.5 174,-101.5 C174,-101.5 118.75,-134.5 118.75,-134.5 C118.75,-134.5 120.25,3.5 120.25,3.5 C120.25,3.5 59.5,-31.75 59.5,-31.75 C59.5,-31.75 57.75,-170.5 57.75,-170.5 C57.75,-170.5 -1.75,-205.5 -1.75,-205.5 C-1.75,-205.5 -1.25,-274.25 -1.25,-274.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.07499694824219,100)" d=" M124.5,-238 C124.5,-238 60.25,-236.5 60.25,-236.5 C60.25,-236.5 98,-178.75 98,-178.75 C98,-178.75 -36,-175.25 -36,-175.25 C-36,-175.25 -0.5,-118.25 -0.5,-118.25 C-0.5,-118.25 133.375,-123.125 133.375,-123.125 C133.375,-123.125 172.375,-62 172.375,-62 C172.375,-62 38.25,-56.25 38.25,-56.25 C38.25,-56.25 75.75,3.75 75.75,3.75 C75.75,3.75 3.75,6.5 3.75,6.5 C3.75,6.5 -143.25,-232.5 -143.25,-232.5 C-143.25,-232.5 -270.25,4.5 -270.25,4.5 C-270.25,4.5 -130.5,242.75 -130.5,242.75 C-130.5,242.75 135.25,224.75 135.25,224.75 C135.25,224.75 274.5,-5.5 274.5,-5.5 C274.5,-5.5 124.5,-238 124.5,-238z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.07499694824219,100)" d=" M-45.625,-275.875 C-45.625,-275.875 -75.625,-239.25 -75.625,-239.25 C-75.625,-239.25 -0.625,-204.25 -0.625,-204.25 C-0.625,-204.25 -62,-125.5 -62,-125.5 C-62,-125.5 11.25,-91.25 11.25,-91.25 C11.25,-91.25 71.5,-171 71.5,-171 C71.5,-171 148.25,-134.75 148.25,-134.75 C148.25,-134.75 90.5,-54.25 90.5,-54.25 C90.5,-54.25 165.25,-18.75 165.25,-18.75 C165.25,-18.75 135.25,24.25 135.25,24.25 C135.25,24.25 -171.5,-120.5 -171.5,-120.5 C-171.5,-120.5 -253.75,137.25 -253.75,137.25 C-253.75,137.25 43.25,278.75 43.25,278.75 C43.25,278.75 158.5,113.25 158.5,113.25 C158.5,113.25 249.5,-137.5 249.5,-137.5 C249.5,-137.5 -45.625,-275.875 -45.625,-275.875z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-134.75,-253 C-134.75,-253 -189,8 -189,8 C-189,8 -195.25,207.5 -195.25,207.5 C-195.25,207.5 132.25,253.5 132.25,253.5 C132.25,253.5 197,-9 197,-9 C197,-9 -142,-58 -142,-58 C-142,-58 -138,-207.5 -138,-207.5 C-138,-207.5 -54.75,-195.25 -54.75,-195.25 C-54.75,-195.25 -53.75,-97.5 -53.75,-97.5 C-53.75,-97.5 27.25,-85.75 27.25,-85.75 C27.25,-85.75 25.5,-183.5 25.5,-183.5 C25.5,-183.5 109.75,-171.25 109.75,-171.25 C109.75,-171.25 113.5,-73.25 113.5,-73.25 C113.5,-73.25 194.75,-61.75 194.75,-61.75 C194.75,-61.75 188.75,-205.5 188.75,-205.5 C188.75,-205.5 -134.75,-253 -134.75,-253z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M133.75,-239.25 C133.75,-239.25 -183.25,-223.25 -183.25,-223.25 C-183.25,-223.25 -217.5,41.75 -217.5,41.75 C-217.5,41.75 -140.5,243.5 -140.5,243.5 C-140.5,243.5 178.75,220.75 178.75,220.75 C178.75,220.75 224.75,-44.75 224.75,-44.75 C224.75,-44.75 -104.25,-25.5 -104.25,-25.5 C-104.25,-25.5 -165.5,-176.25 -165.5,-176.25 C-165.5,-176.25 -83.25,-181.25 -83.25,-181.25 C-83.25,-181.25 -41.25,-83.5 -41.25,-83.5 C-41.25,-83.5 39,-87.25 39,-87.25 C39,-87.25 -5,-185 -5,-185 C-5,-185 77,-189.5 77,-189.5 C77,-189.5 122.5,-92.25 122.5,-92.25 C122.5,-92.25 201.25,-96.5 201.25,-96.5 C201.25,-96.5 133.75,-239.25 133.75,-239.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M89.25,-256 C89.25,-256 -209.5,-196.75 -209.5,-196.75 C-209.5,-196.75 -229.75,70.375 -229.75,70.375 C-229.75,70.375 -95.875,261.125 -95.875,261.125 C-95.875,261.125 203,192.75 203,192.75 C203,192.75 236,-74 236,-74 C236,-74 -71.5,-8.75 -71.5,-8.75 C-71.5,-8.75 -177.5,-152 -177.5,-152 C-177.5,-152 -99.75,-168.25 -99.75,-168.25 C-99.75,-168.25 -28.75,-75.75 -28.75,-75.75 C-28.75,-75.75 46,-91 46,-91 C46,-91 -26.5,-183 -26.5,-183 C-26.5,-183 51,-198.25 51,-198.25 C51,-198.25 124.25,-107.25 124.25,-107.25 C124.25,-107.25 197.5,-122.5 197.5,-122.5 C197.5,-122.5 89.25,-256 89.25,-256z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M57,-263.5 C57,-263.5 -223.5,-176.25 -223.5,-176.25 C-223.5,-176.25 -234.25,92 -234.25,92 C-234.25,92 -62,269.25 -62,269.25 C-62,269.25 215.5,171.25 215.5,171.25 C215.5,171.25 239.25,-96.5 239.25,-96.5 C239.25,-96.5 -47.75,-1.25 -47.75,-1.25 C-47.75,-1.25 -182.5,-134.75 -182.5,-134.75 C-182.5,-134.75 -109.5,-158 -109.5,-158 C-109.5,-158 -19.25,-71.75 -19.25,-71.75 C-19.25,-71.75 50,-95 50,-95 C50,-95 -40,-179.75 -40,-179.75 C-40,-179.75 31.75,-202.25 31.75,-202.25 C31.75,-202.25 123,-118.25 123,-118.25 C123,-118.25 191.25,-140.75 191.25,-140.75 C191.25,-140.75 57,-263.5 57,-263.5z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M33,-267.5 C33,-267.5 -231.5,-159.75 -231.5,-159.75 C-231.5,-159.75 -234.75,108 -234.75,108 C-234.75,108 -37.5,273 -37.5,273 C-37.5,273 222.75,155.25 222.75,155.25 C222.75,155.25 239,-112.25 239,-112.25 C239,-112.25 -29,2.25 -29,2.25 C-29,2.25 -183.75,-122 -183.75,-122 C-183.75,-122 -115.25,-150 -115.25,-150 C-115.25,-150 -12.5,-70.25 -12.5,-70.25 C-12.5,-70.25 52.5,-98.25 52.5,-98.25 C52.5,-98.25 -50,-176.25 -50,-176.25 C-50,-176.25 18.25,-204.5 18.25,-204.5 C18.25,-204.5 121.75,-126.5 121.75,-126.5 C121.75,-126.5 184.75,-153.5 184.75,-153.5 C184.75,-153.5 33,-267.5 33,-267.5z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M16.25,-268 C16.25,-268 -235.75,-148.75 -235.75,-148.75 C-235.75,-148.75 -234.25,119.5 -234.25,119.5 C-234.25,119.5 -21,274.25 -21,274.25 C-21,274.25 226.5,144 226.5,144 C226.5,144 237.75,-123.25 237.75,-123.25 C237.75,-123.25 -16.25,3.5 -16.25,3.5 C-16.25,3.5 -184.25,-112.75 -184.25,-112.75 C-184.25,-112.75 -118.5,-144.25 -118.5,-144.25 C-118.5,-144.25 -7.5,-69.5 -7.5,-69.5 C-7.5,-69.5 54.25,-100 54.25,-100 C54.25,-100 -56.25,-173.75 -56.25,-173.75 C-56.25,-173.75 8,-205 8,-205 C8,-205 120,-132.25 120,-132.25 C120,-132.25 179.5,-162.25 179.5,-162.25 C179.5,-162.25 16.25,-268 16.25,-268z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M5.5,-268.5 C5.5,-268.5 -238.75,-141.75 -238.75,-141.75 C-238.75,-141.75 -233.75,126.75 -233.75,126.75 C-233.75,126.75 -9.75,275 -9.75,275 C-9.75,275 228.25,136.5 228.25,136.5 C228.25,136.5 236.5,-131.5 236.5,-131.5 C236.5,-131.5 -8.125,3.875 -8.125,3.875 C-8.125,3.875 -183.875,-106.875 -183.875,-106.875 C-183.875,-106.875 -120.75,-141 -120.75,-141 C-120.75,-141 -4.375,-69.125 -4.375,-69.125 C-4.375,-69.125 54.875,-102.25 54.875,-102.25 C54.875,-102.25 -61.25,-172 -61.25,-172 C-61.25,-172 1.75,-205.25 1.75,-205.25 C1.75,-205.25 118,-136 118,-136 C118,-136 176,-167.25 176,-167.25 C176,-167.25 5.5,-268.5 5.5,-268.5z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-0.25,-269.25 C-0.25,-269.25 -239.25,-137.25 -239.25,-137.25 C-239.25,-137.25 -233.5,130.25 -233.5,130.25 C-233.5,130.25 -4.25,275.25 -4.25,275.25 C-4.25,275.25 229,133 229,133 C229,133 235.75,-135.25 235.75,-135.25 C235.75,-135.25 -3.75,3.75 -3.75,3.75 C-3.75,3.75 -183.75,-104.5 -183.75,-104.5 C-183.75,-104.5 -121.25,-139.75 -121.25,-139.75 C-121.25,-139.75 -2.5,-69.75 -2.5,-69.75 C-2.5,-69.75 55.5,-102.75 55.5,-102.75 C55.5,-102.75 -62.25,-171.5 -62.25,-171.5 C-62.25,-171.5 -1.25,-205.25 -1.25,-205.25 C-1.25,-205.25 117.25,-137.75 117.25,-137.75 C117.25,-137.75 174,-170.5 174,-170.5 C174,-170.5 -0.25,-269.25 -0.25,-269.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-1.75,-268.75 C-1.75,-268.75 -239.625,-136.5 -239.625,-136.5 C-239.625,-136.5 -232.5,131.875 -232.5,131.875 C-232.5,131.875 -2.125,275.125 -2.125,275.125 C-2.125,275.125 228.875,131.75 228.875,131.75 C228.875,131.75 235.25,-135.875 235.25,-135.875 C235.25,-135.875 -2,4 -2,4 C-2,4 -184,-103 -184,-103 C-184,-103 -122.125,-137.625 -122.125,-137.625 C-122.125,-137.625 -1.75,-69.25 -1.75,-69.25 C-1.75,-69.25 56.375,-103.125 56.375,-103.125 C56.375,-103.125 -63.625,-170.375 -63.625,-170.375 C-63.625,-170.375 -2.875,-205.25 -2.875,-205.25 C-2.875,-205.25 116.75,-138.25 116.75,-138.25 C116.75,-138.25 173.125,-171.125 173.125,-171.125 C173.125,-171.125 -1.75,-268.75 -1.75,-268.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-1,-268.75 C-1,-268.75 -239.75,-136.75 -239.75,-136.75 C-239.75,-136.75 -233,131.25 -233,131.25 C-233,131.25 -2.5,275.5 -2.5,275.5 C-2.5,275.5 229.5,132.5 229.5,132.5 C229.5,132.5 235.25,-136.25 235.25,-136.25 C235.25,-136.25 -3.5,4 -3.5,4 C-3.5,4 -184.25,-103.25 -184.25,-103.25 C-184.25,-103.25 -122.375,-138.125 -122.375,-138.125 C-122.375,-138.125 -2.875,-69.125 -2.875,-69.125 C-2.875,-69.125 55.625,-102.875 55.625,-102.875 C55.625,-102.875 -63.5,-170.75 -63.5,-170.75 C-63.5,-170.75 -2.5,-205 -2.5,-205 C-2.5,-205 116.75,-138 116.75,-138 C116.75,-138 173.5,-171.25 173.5,-171.25 C173.5,-171.25 -1,-268.75 -1,-268.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M1.25,-268.75 C1.25,-268.75 -240.5,-138.5 -240.5,-138.5 C-240.5,-138.5 -231.75,130.25 -231.75,130.25 C-231.75,130.25 -5.5,275 -5.5,275 C-5.5,275 230.125,133.5 230.125,133.5 C230.125,133.5 234.75,-134.875 234.75,-134.875 C234.75,-134.875 -7.5,4.25 -7.5,4.25 C-7.5,4.25 -186,-104.25 -186,-104.25 C-186,-104.25 -122.75,-138.875 -122.75,-138.875 C-122.75,-138.875 -5.5,-69.125 -5.5,-69.125 C-5.5,-69.125 53.625,-102.625 53.625,-102.625 C53.625,-102.625 -63.5,-171.25 -63.5,-171.25 C-63.5,-171.25 -1.5,-205 -1.5,-205 C-1.5,-205 115.875,-137.75 115.875,-137.75 C115.875,-137.75 173.875,-170.125 173.875,-170.125 C173.875,-170.125 1.25,-268.75 1.25,-268.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M6.5,-269 C6.5,-269 -241.75,-140.25 -241.75,-140.25 C-241.75,-140.25 -229.5,128.25 -229.5,128.25 C-229.5,128.25 -10.5,275 -10.5,275 C-10.5,275 231.75,135.25 231.75,135.25 C231.75,135.25 233,-133 233,-133 C233,-133 -15.75,3.75 -15.75,3.75 C-15.75,3.75 -189.25,-105.25 -189.25,-105.25 C-189.25,-105.25 -124.5,-140 -124.5,-140 C-124.5,-140 -10,-69.5 -10,-69.5 C-10,-69.5 50.5,-102.25 50.5,-102.25 C50.5,-102.25 -63,-172 -63,-172 C-63,-172 -0.25,-205.25 -0.25,-205.25 C-0.25,-205.25 115,-136.75 115,-136.75 C115,-136.75 173.5,-169 173.5,-169 C173.5,-169 6.5,-269 6.5,-269z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M13.25,-268.875 C13.25,-268.875 -242.5,-142.625 -242.5,-142.625 C-242.5,-142.625 -226.375,124.75 -226.375,124.75 C-226.375,124.75 -18,275.375 -18,275.375 C-18,275.375 233.25,138.5 233.25,138.5 C233.25,138.5 230.25,-130.375 230.25,-130.375 C230.25,-130.375 -29.375,3.875 -29.375,3.875 C-29.375,3.875 -192.875,-107.625 -192.875,-107.625 C-192.875,-107.625 -126,-141.375 -126,-141.375 C-126,-141.375 -17.625,-69 -17.625,-69 C-17.625,-69 45.5,-101.5 45.5,-101.5 C45.5,-101.5 -62.75,-172.125 -62.75,-172.125 C-62.75,-172.125 2.375,-205.125 2.375,-205.125 C2.375,-205.125 112,-135 112,-135 C112,-135 172.875,-166.5 172.875,-166.5 C172.875,-166.5 13.25,-268.875 13.25,-268.875z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M24,-268.5 C24,-268.5 -243.5,-146.625 -243.5,-146.625 C-243.5,-146.625 -220.75,120 -220.75,120 C-220.75,120 -29.125,275 -29.125,275 C-29.125,275 235.375,143.25 235.375,143.25 C235.375,143.25 225.375,-125.625 225.375,-125.625 C225.375,-125.625 -47.375,4.25 -47.375,4.25 C-47.375,4.25 -198.375,-110.75 -198.375,-110.75 C-198.375,-110.75 -128.125,-143.25 -128.125,-143.25 C-128.125,-143.25 -28.5,-69 -28.5,-69 C-28.5,-69 37.5,-100.25 37.5,-100.25 C37.5,-100.25 -62.5,-173.125 -62.5,-173.125 C-62.5,-173.125 6.5,-205.125 6.5,-205.125 C6.5,-205.125 108.375,-132.75 108.375,-132.75 C108.375,-132.75 171.875,-163.5 171.875,-163.5 C171.875,-163.5 24,-268.5 24,-268.5z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M38.875,-268.625 C38.875,-268.625 -243.75,-152.5 -243.75,-152.5 C-243.75,-152.5 -211.25,112.875 -211.25,112.875 C-211.25,112.875 -43.875,274.5 -43.875,274.5 C-43.875,274.5 236.875,149.75 236.875,149.75 C236.875,149.75 216.625,-118.875 216.625,-118.875 C216.625,-118.875 -73.125,5 -73.125,5 C-73.125,5 -203.875,-115.5 -203.875,-115.5 C-203.875,-115.5 -130.625,-146 -130.625,-146 C-130.625,-146 -43.25,-68 -43.25,-68 C-43.25,-68 26.75,-98.375 26.75,-98.375 C26.75,-98.375 -60.75,-174.375 -60.75,-174.375 C-60.75,-174.375 11.875,-204.75 11.875,-204.75 C11.875,-204.75 101.25,-129.25 101.25,-129.25 C101.25,-129.25 169.5,-158.375 169.5,-158.375 C169.5,-158.375 38.875,-268.625 38.875,-268.625z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M58.25,-268.25 C58.25,-268.25 -240.25,-160.625 -240.25,-160.625 C-240.25,-160.625 -195.25,102.75 -195.25,102.75 C-195.25,102.75 -64.375,273.5 -64.375,273.5 C-64.375,273.5 235.25,158.875 235.25,158.875 C235.25,158.875 201.25,-108.625 201.25,-108.625 C201.25,-108.625 -108.125,5.875 -108.125,5.875 C-108.125,5.875 -209.875,-121.375 -209.875,-121.375 C-209.875,-121.375 -132.5,-150 -132.5,-150 C-132.5,-150 -64,-67.625 -64,-67.625 C-64,-67.625 11,-95.125 11,-95.125 C11,-95.125 -58.625,-175.75 -58.625,-175.75 C-58.625,-175.75 18.75,-204.125 18.75,-204.125 C18.75,-204.125 89.625,-123.875 89.625,-123.875 C89.625,-123.875 163.5,-151.125 163.5,-151.125 C163.5,-151.125 58.25,-268.25 58.25,-268.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M83.5,-267.125 C83.5,-267.125 -229.625,-172.75 -229.625,-172.75 C-229.625,-172.75 -166.625,85.5 -166.625,85.5 C-166.625,85.5 -88.875,269.75 -88.875,269.75 C-88.875,269.75 227.25,172.75 227.25,172.75 C227.25,172.75 173.125,-92.25 173.125,-92.25 C173.125,-92.25 -154.375,7.25 -154.375,7.25 C-154.375,7.25 -213,-129.875 -213,-129.875 C-213,-129.875 -131.875,-155.25 -131.875,-155.25 C-131.875,-155.25 -91.125,-65.75 -91.125,-65.75 C-91.125,-65.75 -12.625,-89.75 -12.625,-89.75 C-12.625,-89.75 -54.625,-177.625 -54.625,-177.625 C-54.625,-177.625 27.125,-203 27.125,-203 C27.125,-203 70.75,-114.625 70.75,-114.625 C70.75,-114.625 149.625,-139 149.625,-139 C149.625,-139 83.5,-267.125 83.5,-267.125z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M114,-262.75 C114,-262.75 -204,-192.125 -204,-192.125 C-204,-192.125 -205.75,-145.25 -205.75,-145.25 C-205.75,-145.25 -126,-162.875 -126,-162.875 C-126,-162.875 -127.375,-63.375 -127.375,-63.375 C-127.375,-63.375 -47.625,-80.25 -47.625,-80.25 C-47.625,-80.25 -47.625,-180.125 -47.625,-180.125 C-47.625,-180.125 35.5,-198.375 35.5,-198.375 C35.5,-198.375 36.625,-98.625 36.625,-98.625 C36.625,-98.625 117.875,-116 117.875,-116 C117.875,-116 118.875,-63 118.875,-63 C118.875,-63 -211.875,8.625 -211.875,8.625 C-211.875,8.625 -118.25,262.5 -118.25,262.5 C-118.25,262.5 202.75,194.875 202.75,194.875 C202.75,194.875 195.875,-9 195.875,-9 C195.875,-9 114,-262.75 114,-262.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M135.25,-239 C135.25,-239 -140.125,-231 -140.125,-231 C-140.125,-231 -172,-175.75 -172,-175.75 C-172,-175.75 -103.75,-177.375 -103.75,-177.375 C-103.75,-177.375 -170.75,-60.375 -170.75,-60.375 C-170.75,-60.375 -103.875,-60.75 -103.875,-60.75 C-103.875,-60.75 -37.875,-179.25 -37.875,-179.25 C-37.875,-179.25 33.375,-180.625 33.375,-180.625 C33.375,-180.625 -31.625,-62.375 -31.625,-62.375 C-31.625,-62.375 38.625,-63 38.625,-63 C38.625,-63 3.75,0 3.75,0 C3.75,0 -274.625,1.5 -274.625,1.5 C-274.625,1.5 -135.75,231.375 -135.75,231.375 C-135.75,231.375 139.25,236 139.25,236 C139.25,236 262.875,-2.625 262.875,-2.625 C262.875,-2.625 135.25,-239 135.25,-239z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-3.125,-274.25 C-3.125,-274.25 -60.25,-239 -60.25,-239 C-60.25,-239 -60.75,-171.875 -60.75,-171.875 C-60.75,-171.875 -177.875,-101.5 -177.875,-101.5 C-177.875,-101.5 -178.75,-35.875 -178.75,-35.875 C-178.75,-35.875 -61.75,-104.875 -61.75,-104.875 C-61.75,-104.875 -61.875,-33.5 -61.875,-33.5 C-61.875,-33.5 -180.125,35.375 -180.125,35.375 C-180.125,35.375 -181.375,104.75 -181.375,104.75 C-181.375,104.75 -239.625,137.75 -239.625,137.75 C-239.625,137.75 -1.875,265.5 -1.875,265.5 C-1.875,265.5 235.5,138.25 235.5,138.25 C235.5,138.25 229.5,-134.875 229.5,-134.875 C229.5,-134.875 -3.125,-274.25 -3.125,-274.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-137.75,-235.25 C-137.75,-235.25 -36,-52.125 -36,-52.125 C-36,-52.125 -71.5,8.375 -71.5,8.375 C-71.5,8.375 -139.375,-114.75 -139.375,-114.75 C-139.375,-114.75 -172.125,-58.375 -172.125,-58.375 C-172.125,-58.375 -105,63.25 -105,63.25 C-105,63.25 -140.25,122.875 -140.25,122.875 C-140.25,122.875 -205.875,0 -205.875,0 C-205.875,0 -237.625,54.625 -237.625,54.625 C-237.625,54.625 -140.875,239.5 -140.875,239.5 C-140.875,239.5 129.875,228.125 129.875,228.125 C129.875,228.125 272.875,4.75 272.875,4.75 C272.875,4.75 133.5,-234 133.5,-234 C133.5,-234 -137.75,-235.25 -137.75,-235.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M167.125,-232.25 C167.125,-232.25 -101.625,-181.625 -101.625,-181.625 C-101.625,-181.625 -24.125,60.75 -24.125,60.75 C-24.125,60.75 -68.875,85.75 -68.875,85.75 C-68.875,85.75 -120.75,-74.875 -120.75,-74.875 C-120.75,-74.875 -161.625,-49.75 -161.625,-49.75 C-161.625,-49.75 -110.375,107.75 -110.375,107.75 C-110.375,107.75 -154.25,132.75 -154.25,132.75 C-154.25,132.75 -204.375,-25.25 -204.375,-25.25 C-204.375,-25.25 -243.625,-1.25 -243.625,-1.25 C-243.625,-1.25 -170.625,231.5 -170.625,231.5 C-170.625,231.5 91.625,171.25 91.625,171.25 C91.625,171.25 268.75,80.625 268.75,80.625 C268.75,80.625 167.125,-232.25 167.125,-232.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M188,-210.75 C188,-210.75 -6.5,-190.75 -6.5,-190.75 C-6.5,-190.75 -260.75,-113.25 -260.75,-113.25 C-260.75,-113.25 -74.75,-130.5 -74.75,-130.5 C-74.75,-130.5 -15.125,120.75 -15.125,120.75 C-15.125,120.75 -65.875,123.125 -65.875,123.125 C-65.875,123.125 -105.375,-41.5 -105.375,-41.5 C-105.375,-41.5 -152.125,-37.75 -152.125,-37.75 C-152.125,-37.75 -112.875,124.625 -112.875,124.625 C-112.875,124.625 -161.875,126.875 -161.875,126.875 C-161.875,126.875 -200.625,-33.875 -200.625,-33.875 C-200.625,-33.875 -246.125,-30.75 -246.125,-30.75 C-246.125,-30.75 -189.125,206.125 -189.125,206.125 C-189.125,206.125 3.5,201.75 3.5,201.75 C3.5,201.75 262.5,111.5 262.5,111.5 C262.5,111.5 188,-210.75 188,-210.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-7.25,-222 C-7.25,-222 -259,-127 -259,-127 C-259,-127 -53.5,-89.25 -53.5,-89.25 C-53.5,-89.25 -9.5,156.75 -9.5,156.75 C-9.5,156.75 -63.75,144 -63.75,144 C-63.75,144 -93.5,-16.25 -93.5,-16.25 C-93.5,-16.25 -144,-26.25 -144,-26.25 C-144,-26.25 -113.75,132.75 -113.75,132.75 C-113.75,132.75 -167.25,120.5 -167.25,120.5 C-167.25,120.5 -196.5,-36 -196.5,-36 C-196.5,-36 -245.75,-46 -245.75,-46 C-245.75,-46 -202.25,184.25 -202.25,184.25 C-202.25,184.25 4.5,233.25 4.5,233.25 C4.5,233.25 254.75,124.75 254.75,124.75 C254.75,124.75 203.25,-189 203.25,-189 C203.25,-189 -7.25,-222 -7.25,-222z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-7,-241.5 C-7,-241.5 -253.75,-133.25 -253.75,-133.25 C-253.75,-133.25 -36.75,-58.75 -36.75,-58.75 C-36.75,-58.75 -6,177.75 -6,177.75 C-6,177.75 -63,155.75 -63,155.75 C-63,155.75 -83.75,1.75 -83.75,1.75 C-83.75,1.75 -136.75,-16.25 -136.75,-16.25 C-136.75,-16.25 -115.5,136 -115.5,136 C-115.5,136 -170.75,115 -170.75,115 C-170.75,115 -193,-37 -193,-37 C-193,-37 -244,-55.5 -244,-55.5 C-244,-55.5 -212.5,167.25 -212.5,167.25 C-212.5,167.25 3,251.25 3,251.25 C3,251.25 248,130.5 248,130.5 C248,130.5 214,-172.5 214,-172.5 C214,-172.5 -7,-241.5 -7,-241.5z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-6,-252.75 C-6,-252.75 -249.5,-135.5 -249.5,-135.5 C-249.5,-135.5 -24.25,-36 -24.25,-36 C-24.25,-36 -3.75,191 -3.75,191 C-3.75,191 -62.25,163.25 -62.25,163.25 C-62.25,163.25 -77,15 -77,15 C-77,15 -131,-9.5 -131,-9.5 C-131,-9.5 -117.25,137.5 -117.25,137.5 C-117.25,137.5 -173.5,111 -173.5,111 C-173.5,111 -189.5,-35.5 -189.5,-35.5 C-189.5,-35.5 -242.75,-60.25 -242.75,-60.25 C-242.75,-60.25 -220,154.5 -220,154.5 C-220,154.5 1.25,262 1.25,262 C1.25,262 242,132.25 242,132.25 C242,132.25 222.25,-159.25 222.25,-159.25 C222.25,-159.25 -6,-252.75 -6,-252.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-4.25,-259.75 C-4.25,-259.75 -245.5,-136.75 -245.5,-136.75 C-245.5,-136.75 -14.75,-19.5 -14.75,-19.5 C-14.75,-19.5 -2.75,200.25 -2.75,200.25 C-2.75,200.25 -62.5,168.75 -62.5,168.75 C-62.5,168.75 -71.5,24.5 -71.5,24.5 C-71.5,24.5 -127.5,-4.25 -127.5,-4.25 C-127.5,-4.25 -117.25,139.75 -117.25,139.75 C-117.25,139.75 -176.25,107.75 -176.25,107.75 C-176.25,107.75 -186.75,-34.75 -186.75,-34.75 C-186.75,-34.75 -241.5,-63 -241.5,-63 C-241.5,-63 -225.25,145.5 -225.25,145.5 C-225.25,145.5 0,267.75 0,267.75 C0,267.75 237,133 237,133 C237,133 227.5,-150.5 227.5,-150.5 C227.5,-150.5 -4.25,-259.75 -4.25,-259.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-3.25,-264.25 C-3.25,-264.25 -243,-136.5 -243,-136.5 C-243,-136.5 -9.25,-8.75 -9.25,-8.75 C-9.25,-8.75 -2.25,206 -2.25,206 C-2.25,206 -62.5,171.5 -62.5,171.5 C-62.5,171.5 -67.75,31 -67.75,31 C-67.75,31 -124.25,-0.25 -124.25,-0.25 C-124.25,-0.25 -118.5,139.5 -118.5,139.5 C-118.5,139.5 -177.5,105.5 -177.5,105.5 C-177.5,105.5 -184.75,-33.75 -184.75,-33.75 C-184.75,-33.75 -239.25,-64.25 -239.25,-64.25 C-239.25,-64.25 -229.25,139 -229.25,139 C-229.25,139 -1.25,271.75 -1.25,271.75 C-1.25,271.75 233,132.5 233,132.5 C233,132.5 231.5,-143.5 231.5,-143.5 C231.5,-143.5 -3.25,-264.25 -3.25,-264.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-1.75,-266.5 C-1.75,-266.5 -241,-136.75 -241,-136.75 C-241,-136.75 -4.75,-1.25 -4.75,-1.25 C-4.75,-1.25 -1.75,208.5 -1.75,208.5 C-1.75,208.5 -62.75,172.5 -62.75,172.5 C-62.75,172.5 -65.5,35 -65.5,35 C-65.5,35 -122.75,1.75 -122.75,1.75 C-122.75,1.75 -118.75,139.5 -118.75,139.5 C-118.75,139.5 -178.25,104.25 -178.25,104.25 C-178.25,104.25 -182.75,-32.75 -182.75,-32.75 C-182.75,-32.75 -238.75,-65.25 -238.75,-65.25 C-238.75,-65.25 -232,134.75 -232,134.75 C-232,134.75 -1.5,273.75 -1.5,273.75 C-1.5,273.75 230.75,132.5 230.75,132.5 C230.75,132.5 233.5,-139.75 233.5,-139.75 C233.5,-139.75 -1.75,-266.5 -1.75,-266.5z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-2,-267.75 C-2,-267.75 -240,-136.75 -240,-136.75 C-240,-136.75 -2.25,2.5 -2.25,2.5 C-2.25,2.5 -2,210.5 -2,210.5 C-2,210.5 -62.75,174 -62.75,174 C-62.75,174 -64.75,38 -64.75,38 C-64.75,38 -121.75,3.5 -121.75,3.5 C-121.75,3.5 -119.5,139.25 -119.5,139.25 C-119.5,139.25 -178.5,102.5 -178.5,102.5 C-178.5,102.5 -182.5,-32.5 -182.5,-32.5 C-182.5,-32.5 -238.5,-66.25 -238.5,-66.25 C-238.5,-66.25 -232.75,133.25 -232.75,133.25 C-232.75,133.25 -2.75,275.25 -2.75,275.25 C-2.75,275.25 229.5,132 229.5,132 C229.5,132 235.5,-136.25 235.5,-136.25 C235.5,-136.25 -2,-267.75 -2,-267.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-2,-268.75 C-2,-268.75 -239.5,-136.5 -239.5,-136.5 C-239.5,-136.5 -1.75,3 -1.75,3 C-1.75,3 -1.25,211.5 -1.25,211.5 C-1.25,211.5 -62.5,174 -62.5,174 C-62.5,174 -63.75,38 -63.75,38 C-63.75,38 -121.5,4 -121.5,4 C-121.5,4 -119.25,139 -119.25,139 C-119.25,139 -178.75,102.75 -178.75,102.75 C-178.75,102.75 -182.25,-32.5 -182.25,-32.5 C-182.25,-32.5 -238,-65.5 -238,-65.5 C-238,-65.5 -233.5,131.75 -233.5,131.75 C-233.5,131.75 -2.5,275 -2.5,275 C-2.5,275 229.25,131.5 229.25,131.5 C229.25,131.5 235.75,-136.25 235.75,-136.25 C235.75,-136.25 -2,-268.75 -2,-268.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-2.25,-268.5 C-2.25,-268.5 -238.25,-136.25 -238.25,-136.25 C-238.25,-136.25 -2.25,3.25 -2.25,3.25 C-2.25,3.25 -1.5,211.5 -1.5,211.5 C-1.5,211.5 -62.5,174 -62.5,174 C-62.5,174 -63.75,38 -63.75,38 C-63.75,38 -121.5,3.5 -121.5,3.5 C-121.5,3.5 -119.5,139.25 -119.5,139.25 C-119.5,139.25 -178.75,103 -178.75,103 C-178.75,103 -182.25,-32.5 -182.25,-32.5 C-182.25,-32.5 -238,-66 -238,-66 C-238,-66 -233,131.75 -233,131.75 C-233,131.75 -2.25,275.25 -2.25,275.25 C-2.25,275.25 229,131.5 229,131.5 C229,131.5 235.25,-136.5 235.25,-136.5 C235.25,-136.5 -2.25,-268.5 -2.25,-268.5z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-2.25,-268.25 C-2.25,-268.25 -239.25,-136.25 -239.25,-136.25 C-239.25,-136.25 -1.5,3.75 -1.5,3.75 C-1.5,3.75 -2.25,211 -2.25,211 C-2.25,211 -62.75,174.25 -62.75,174.25 C-62.75,174.25 -64.75,37.75 -64.75,37.75 C-64.75,37.75 -121.75,4 -121.75,4 C-121.75,4 -119.75,139.25 -119.75,139.25 C-119.75,139.25 -179.25,102.75 -179.25,102.75 C-179.25,102.75 -182,-32.5 -182,-32.5 C-182,-32.5 -238.75,-66.5 -238.75,-66.5 C-238.75,-66.5 -234,132 -234,132 C-234,132 -2.25,275.5 -2.25,275.5 C-2.25,275.5 228.75,131.75 228.75,131.75 C228.75,131.75 235.5,-135.75 235.5,-135.75 C235.5,-135.75 -2.25,-268.25 -2.25,-268.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-2,-268.5 C-2,-268.5 -239,-136.75 -239,-136.75 C-239,-136.75 -1.5,4.75 -1.5,4.75 C-1.5,4.75 -2,212 -2,212 C-2,212 -63.25,174 -63.25,174 C-63.25,174 -64,38.5 -64,38.5 C-64,38.5 -121.25,3.75 -121.25,3.75 C-121.25,3.75 -119.75,139 -119.75,139 C-119.75,139 -179.25,102 -179.25,102 C-179.25,102 -182.5,-32.5 -182.5,-32.5 C-182.5,-32.5 -238.25,-66.5 -238.25,-66.5 C-238.25,-66.5 -234,131 -234,131 C-234,131 -2.5,276 -2.5,276 C-2.5,276 228.75,131.5 228.75,131.5 C228.75,131.5 236.25,-134.75 236.25,-134.75 C236.25,-134.75 -2,-268.5 -2,-268.5z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-1.25,-269.875 C-1.25,-269.875 -237.25,-136.25 -237.25,-136.25 C-237.25,-136.25 0.75,8.5 0.75,8.5 C0.75,8.5 -1.5,213.5 -1.5,213.5 C-1.5,213.5 -62.75,175.25 -62.75,175.25 C-62.75,175.25 -62.625,41.125 -62.625,41.125 C-62.625,41.125 -120.5,5.375 -120.5,5.375 C-120.5,5.375 -120.125,139.375 -120.125,139.375 C-120.125,139.375 -179.625,101.375 -179.625,101.375 C-179.625,101.375 -181.375,-32.125 -181.375,-32.125 C-181.375,-32.125 -237.125,-66.375 -237.125,-66.375 C-237.125,-66.375 -235.5,129.125 -235.5,129.125 C-235.5,129.125 -2.875,277 -2.875,277 C-2.875,277 227,131.5 227,131.5 C227,131.5 237.125,-132.875 237.125,-132.875 C237.125,-132.875 -1.25,-269.875 -1.25,-269.875z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-0.25,-271.5 C-0.25,-271.5 -235.25,-135.25 -235.25,-135.25 C-235.25,-135.25 5,15 5,15 C5,15 -1.25,216.5 -1.25,216.5 C-1.25,216.5 -62.75,177.25 -62.75,177.25 C-62.75,177.25 -60,45.25 -60,45.25 C-60,45.25 -118.5,8 -118.5,8 C-118.5,8 -120.25,139.25 -120.25,139.25 C-120.25,139.25 -180.5,100.25 -180.5,100.25 C-180.5,100.25 -180,-31.5 -180,-31.5 C-180,-31.5 -236.5,-67 -236.5,-67 C-236.5,-67 -237.25,125 -237.25,125 C-237.25,125 -3.75,278.5 -3.75,278.5 C-3.75,278.5 224.25,131 224.25,131 C224.25,131 239.5,-128.75 239.5,-128.75 C239.5,-128.75 -0.25,-271.5 -0.25,-271.5z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M1.25,-274.75 C1.25,-274.75 -231.25,-134.5 -231.25,-134.5 C-231.25,-134.5 11.75,26.75 11.75,26.75 C11.75,26.75 -1.25,221 -1.25,221 C-1.25,221 -63.25,179 -63.25,179 C-63.25,179 -56.5,50.75 -56.5,50.75 C-56.5,50.75 -115.25,11.75 -115.25,11.75 C-115.25,11.75 -121.5,139 -121.5,139 C-121.5,139 -182,97.75 -182,97.75 C-182,97.75 -177.25,-29.25 -177.25,-29.25 C-177.25,-29.25 -234.5,-68 -234.5,-68 C-234.5,-68 -241.75,118.5 -241.75,118.5 C-241.75,118.5 -5.75,280.75 -5.75,280.75 C-5.75,280.75 220.25,128.75 220.25,128.75 C220.25,128.75 243.75,-121.75 243.75,-121.75 C243.75,-121.75 1.25,-274.75 1.25,-274.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M4,-278.875 C4,-278.875 -225.25,-132.125 -225.25,-132.125 C-225.25,-132.125 21.375,42.875 21.375,42.875 C21.375,42.875 -1.5,227.125 -1.5,227.125 C-1.5,227.125 -63.875,181.625 -63.875,181.625 C-63.875,181.625 -51.25,61 -51.25,61 C-51.25,61 -110.375,18.25 -110.375,18.25 C-110.375,18.25 -122,139.375 -122,139.375 C-122,139.375 -183.75,94.75 -183.75,94.75 C-183.75,94.75 -173.75,-26.625 -173.75,-26.625 C-173.75,-26.625 -231.25,-68.375 -231.25,-68.375 C-231.25,-68.375 -247,109.25 -247,109.25 C-247,109.25 -9,283.75 -9,283.75 C-9,283.75 213,126.5 213,126.5 C213,126.5 248.5,-112 248.5,-112 C248.5,-112 4,-278.875 4,-278.875z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M8.875,-283.25 C8.875,-283.25 -215.875,-127.625 -215.875,-127.625 C-215.875,-127.625 34.5,64.625 34.5,64.625 C34.5,64.625 -2.125,234 -2.125,234 C-2.125,234 -65.375,185.5 -65.375,185.5 C-65.375,185.5 -43,73.375 -43,73.375 C-43,73.375 -103,26.625 -103,26.625 C-103,26.625 -123.75,138.75 -123.75,138.75 C-123.75,138.75 -186.375,89.5 -186.375,89.5 C-186.375,89.5 -167,-22.375 -167,-22.375 C-167,-22.375 -225.75,-67.625 -225.75,-67.625 C-225.75,-67.625 -254.125,96.625 -254.125,96.625 C-254.125,96.625 -13.875,286.25 -13.875,286.25 C-13.875,286.25 202.125,121.75 202.125,121.75 C202.125,121.75 255.875,-99 255.875,-99 C255.875,-99 8.875,-283.25 8.875,-283.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M17.25,-285.875 C17.25,-285.875 -199.625,-119 -199.625,-119 C-199.625,-119 52.625,93.875 52.625,93.875 C52.625,93.875 -4.125,241.75 -4.125,241.75 C-4.125,241.75 -67.125,187.875 -67.125,187.875 C-67.125,187.875 -32,90.5 -32,90.5 C-32,90.5 -92.25,38.875 -92.25,38.875 C-92.25,38.875 -126.375,137.25 -126.375,137.25 C-126.375,137.25 -189.25,83.875 -189.25,83.875 C-189.25,83.875 -156.875,-15.625 -156.875,-15.625 C-156.875,-15.625 -216.25,-66.625 -216.25,-66.625 C-216.25,-66.625 -263.625,79.625 -263.625,79.625 C-263.625,79.625 -22.25,286.75 -22.25,286.75 C-22.25,286.75 185.875,112.125 185.875,112.125 C185.875,112.125 265,-81 265,-81 C265,-81 17.25,-285.875 17.25,-285.875z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M32.75,-285 C32.75,-285 -172.125,-101.375 -172.125,-101.375 C-172.125,-101.375 77.5,133 77.5,133 C77.5,133 -9.625,248.125 -9.625,248.125 C-9.625,248.125 -71.125,190 -71.125,190 C-71.125,190 -16.75,112.875 -16.75,112.875 C-16.75,112.875 -76.125,56.5 -76.125,56.5 C-76.125,56.5 -130.125,135 -130.125,135 C-130.125,135 -191.875,76.25 -191.875,76.25 C-191.875,76.25 -139.75,-2.875 -139.75,-2.875 C-139.75,-2.875 -199,-59.5 -199,-59.5 C-199,-59.5 -274.875,57.875 -274.875,57.875 C-274.875,57.875 -37.75,282.375 -37.75,282.375 C-37.75,282.375 157.25,95.75 157.25,95.75 C157.25,95.75 275.25,-58.25 275.25,-58.25 C275.25,-58.25 32.75,-285 32.75,-285z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M63.375,-274.375 C63.375,-274.375 -105.875,-170.5 -105.875,-170.5 C-105.875,-170.5 -287,30.375 -287,30.375 C-287,30.375 -66.5,269.25 -66.5,269.25 C-66.5,269.25 -26,248.25 -26,248.25 C-26,248.25 -80.875,188.25 -80.875,188.25 C-80.875,188.25 4.375,142.125 4.375,142.125 C4.375,142.125 -50.25,82.125 -50.25,82.125 C-50.25,82.125 -134.875,129.875 -134.875,129.875 C-134.875,129.875 -192.125,67.375 -192.125,67.375 C-192.125,67.375 -108.625,18.25 -108.625,18.25 C-108.625,18.25 -164.5,-42.625 -164.5,-42.625 C-164.5,-42.625 -120.25,-69 -120.25,-69 C-120.25,-69 107.75,181.125 107.75,181.125 C107.75,181.125 283.75,-30 283.75,-30 C283.75,-30 63.375,-274.375 63.375,-274.375z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M131.25,-238.75 C131.25,-238.75 -135,-230.5 -135,-230.5 C-135,-230.5 -278.125,1.875 -278.125,1.875 C-278.125,1.875 -131.875,232.125 -131.875,232.125 C-131.875,232.125 -68.5,233.25 -68.5,233.25 C-68.5,233.25 -104,176.75 -104,176.75 C-104,176.75 29.375,177.625 29.375,177.625 C29.375,177.625 -5,121.125 -5,121.125 C-5,121.125 -139.5,120.75 -139.5,120.75 C-139.5,120.75 -177,60.75 -177,60.75 C-177,60.75 -42.75,59.75 -42.75,59.75 C-42.75,59.75 -79,0.875 -79,0.875 C-79,0.875 -7.75,0.375 -7.75,0.375 C-7.75,0.375 135,236.625 135,236.625 C135,236.625 266.875,-2.125 266.875,-2.125 C266.875,-2.125 131.25,-238.75 131.25,-238.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-1.125,-273.125 C-1.125,-273.125 -233.375,-133.625 -233.375,-133.625 C-233.375,-133.625 -239.375,139.25 -239.375,139.25 C-239.375,139.25 -180,170.75 -180,170.75 C-180,170.75 -121.5,138 -121.5,138 C-121.5,138 -1.75,202.5 -1.75,202.5 C-1.75,202.5 55,171.375 55,171.375 C55,171.375 -64.375,106.375 -64.375,106.375 C-64.375,106.375 -2.625,71.875 -2.625,71.875 C-2.625,71.875 117.125,138.125 117.125,138.125 C117.125,138.125 177.375,105.25 177.375,105.25 C177.375,105.25 235.375,138.375 235.375,138.375 C235.375,138.375 229,-134.75 229,-134.75 C229,-134.75 -1.125,-273.125 -1.125,-273.125z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-135.875,-237.75 C-135.875,-237.75 -271,-2 -271,-2 C-271,-2 -138.75,236.625 -138.75,236.625 C-138.75,236.625 -32.5,60.75 -32.5,60.75 C-32.5,60.75 37,60.75 37,60.75 C37,60.75 -33,177.75 -33,177.75 C-33,177.75 32,177.75 32,177.75 C32,177.75 104.125,60 104.125,60 C104.125,60 173,60.125 173,60.125 C173,60.125 101.125,176.25 101.125,176.25 C101.125,176.25 164.5,175.125 164.5,175.125 C164.5,175.125 274.25,2.125 274.25,2.125 C274.25,2.125 131.5,-229.625 131.5,-229.625 C131.5,-229.625 -135.875,-237.75 -135.875,-237.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-67.875,-273.625 C-67.875,-273.625 -287.25,-30.125 -287.25,-30.125 C-287.25,-30.125 -111.625,181.25 -111.625,181.25 C-111.625,181.25 59.625,-6.5 59.625,-6.5 C59.625,-6.5 104.375,18.5 104.375,18.5 C104.375,18.5 -8.625,142.375 -8.625,142.375 C-8.625,142.375 33.625,164.5 33.625,164.5 C33.625,164.5 145.125,41.875 145.125,41.875 C145.125,41.875 188.875,66.375 188.875,66.375 C188.875,66.375 78.25,187.125 78.25,187.125 C78.25,187.125 118,208.75 118,208.75 C118,208.75 283.625,29.75 283.625,29.75 C283.625,29.75 102.625,-170.25 102.625,-170.25 C102.625,-170.25 -67.875,-273.625 -67.875,-273.625z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-37.125,-284.75 C-37.125,-284.75 -279,-58.625 -279,-58.625 C-279,-58.625 -161,95.25 -161,95.25 C-161,95.25 27.125,276.875 27.125,276.875 C27.125,276.875 -81.625,133.375 -81.625,133.375 C-81.625,133.375 107.625,-45 107.625,-45 C107.625,-45 135,-3.5 135,-3.5 C135,-3.5 12.625,113.5 12.625,113.5 C12.625,113.5 39.625,150.5 39.625,150.5 C39.625,150.5 160.875,35.25 160.875,35.25 C160.875,35.25 188.25,75.125 188.25,75.125 C188.25,75.125 68.25,189.75 68.25,189.75 C68.25,189.75 94,225.25 94,225.25 C94,225.25 271.625,57.875 271.625,57.875 C271.625,57.875 168,-101.625 168,-101.625 C168,-101.625 -37.125,-284.75 -37.125,-284.75z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-21.125,-286.125 C-21.125,-286.125 -268.75,-82 -268.75,-82 C-268.75,-82 -188.5,112.75 -188.5,112.75 C-188.5,112.75 16.375,285.25 16.375,285.25 C16.375,285.25 -56.5,94.5 -56.5,94.5 C-56.5,94.5 134.75,-67.125 134.75,-67.125 C134.75,-67.125 152.375,-15.75 152.375,-15.75 C152.375,-15.75 27.875,90.5 27.875,90.5 C27.875,90.5 45.125,138 45.125,138 C45.125,138 168.125,32.625 168.125,32.625 C168.125,32.625 185.875,82.5 185.875,82.5 C185.875,82.5 63.875,188.25 63.875,188.25 C63.875,188.25 80,233.75 80,233.75 C80,233.75 259.75,79.875 259.75,79.875 C259.75,79.875 195.125,-119.75 195.125,-119.75 C195.125,-119.75 -21.125,-286.125 -21.125,-286.125z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-13,-283.25 C-13,-283.25 -259.25,-99.375 -259.25,-99.375 C-259.25,-99.375 -205.5,121.75 -205.5,121.75 C-205.5,121.75 8.25,284.75 8.25,284.75 C8.25,284.75 -38.5,64.5 -38.5,64.5 C-38.5,64.5 152.25,-81.625 152.25,-81.625 C152.25,-81.625 162.625,-23.125 162.625,-23.125 C162.625,-23.125 38.75,73.875 38.75,73.875 C38.75,73.875 49.875,128.125 49.875,128.125 C49.875,128.125 172.125,31.75 172.125,31.75 C172.125,31.75 182.875,89.625 182.875,89.625 C182.875,89.625 61.25,185.125 61.25,185.125 C61.25,185.125 72,236.875 72,236.875 C72,236.875 249.625,97.125 249.625,97.125 C249.625,97.125 211.625,-127.875 211.625,-127.875 C211.625,-127.875 -13,-283.25 -13,-283.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-8,-279.125 C-8,-279.125 -252.25,-113.375 -252.25,-113.375 C-252.25,-113.375 -216.375,126.875 -216.375,126.875 C-216.375,126.875 3.5,282.375 3.5,282.375 C3.5,282.375 -25.375,42.75 -25.375,42.75 C-25.375,42.75 162.75,-90.625 162.75,-90.625 C162.75,-90.625 168.625,-27.375 168.625,-27.375 C168.625,-27.375 47,60.5 47,60.5 C47,60.5 53.5,119.5 53.5,119.5 C53.5,119.5 174.375,31.75 174.375,31.75 C174.375,31.75 180.625,93.625 180.625,93.625 C180.625,93.625 60.5,181.625 60.5,181.625 C60.5,181.625 67.25,238.125 67.25,238.125 C67.25,238.125 242.5,109.625 242.5,109.625 C242.5,109.625 221.5,-132.25 221.5,-132.25 C221.5,-132.25 -8,-279.125 -8,-279.125z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-5.125,-275.25 C-5.125,-275.25 -246.75,-122.25 -246.75,-122.25 C-246.75,-122.25 -223.25,129.625 -223.25,129.625 C-223.25,129.625 0.75,280 0.75,280 C0.75,280 -15.875,27.375 -15.875,27.375 C-15.875,27.375 170.125,-96.125 170.125,-96.125 C170.125,-96.125 172.875,-30 172.875,-30 C172.875,-30 52.375,51.75 52.375,51.75 C52.375,51.75 55.75,113.5 55.75,113.5 C55.75,113.5 175.125,32.375 175.125,32.375 C175.125,32.375 178.75,96.875 178.75,96.875 C178.75,96.875 60.125,178.875 60.125,178.875 C60.125,178.875 63,238.5 63,238.5 C63,238.5 236.75,118.75 236.75,118.75 C236.75,118.75 227.875,-134.5 227.875,-134.5 C227.875,-134.5 -5.125,-275.25 -5.125,-275.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-3.375,-272.25 C-3.375,-272.25 -243.375,-129 -243.375,-129 C-243.375,-129 -227.75,130.875 -227.75,130.875 C-227.75,130.875 -0.75,277.5 -0.75,277.5 C-0.75,277.5 -9.25,16 -9.25,16 C-9.25,16 174.5,-99.5 174.5,-99.5 C174.5,-99.5 175.5,-32 175.5,-32 C175.5,-32 56,45.5 56,45.5 C56,45.5 57.5,109.25 57.5,109.25 C57.5,109.25 176.375,32.625 176.375,32.625 C176.375,32.625 177.25,99.125 177.25,99.125 C177.25,99.125 59.375,176.75 59.375,176.75 C59.375,176.75 61,238.875 61,238.875 C61,238.875 233,125.375 233,125.375 C233,125.375 232.125,-134.75 232.125,-134.75 C232.125,-134.75 -3.375,-272.25 -3.375,-272.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-2.875,-270 C-2.875,-270 -240.5,-133.375 -240.5,-133.375 C-240.5,-133.375 -230.25,131.75 -230.25,131.75 C-230.25,131.75 -2,276 -2,276 C-2,276 -4.75,9 -4.75,9 C-4.75,9 177.375,-101.375 177.375,-101.375 C177.375,-101.375 177.375,-32.625 177.375,-32.625 C177.375,-32.625 58.5,41.5 58.5,41.5 C58.5,41.5 59,106.375 59,106.375 C59,106.375 176.125,32.625 176.125,32.625 C176.125,32.625 176.75,100.375 176.75,100.375 C176.75,100.375 59,175.375 59,175.375 C59,175.375 59.75,238.125 59.75,238.125 C59.75,238.125 231.125,129.25 231.125,129.25 C231.125,129.25 234.5,-135.875 234.5,-135.875 C234.5,-135.875 -2.875,-270 -2.875,-270z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-2.25,-269 C-2.25,-269 -239.625,-135.375 -239.625,-135.375 C-239.625,-135.375 -231.875,132.125 -231.875,132.125 C-231.875,132.125 -2.375,275.375 -2.375,275.375 C-2.375,275.375 -2.5,4.625 -2.5,4.625 C-2.5,4.625 178.875,-102.75 178.875,-102.75 C178.875,-102.75 178.125,-33.375 178.125,-33.375 C178.125,-33.375 60,39.25 60,39.25 C60,39.25 59.25,104.375 59.25,104.375 C59.25,104.375 176.5,33.125 176.5,33.125 C176.5,33.125 176,101.25 176,101.25 C176,101.25 59.375,174.375 59.375,174.375 C59.375,174.375 59.5,238.125 59.5,238.125 C59.5,238.125 229.625,131.625 229.625,131.625 C229.625,131.625 235.375,-136.25 235.375,-136.25 C235.375,-136.25 -2.25,-269 -2.25,-269z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-2.125,-268.25 C-2.125,-268.25 -239.125,-136.375 -239.125,-136.375 C-239.125,-136.375 -232.375,132.25 -232.375,132.25 C-232.375,132.25 -2.125,274.875 -2.125,274.875 C-2.125,274.875 -2.25,3.75 -2.25,3.75 C-2.25,3.75 179.25,-102.875 179.25,-102.875 C179.25,-102.875 178.5,-32.875 178.5,-32.875 C178.5,-32.875 60.125,38.25 60.125,38.25 C60.125,38.25 60,104.625 60,104.625 C60,104.625 176.625,32.625 176.625,32.625 C176.625,32.625 176,101.25 176,101.25 C176,101.25 59.375,173.875 59.375,173.875 C59.375,173.875 58.875,238.25 58.875,238.25 C58.875,238.25 229.5,132.375 229.5,132.375 C229.5,132.375 236,-136.375 236,-136.375 C236,-136.375 -2.125,-268.25 -2.125,-268.25z"></path> <path style="display:none" transform="matrix(0.30000001192092896,0,0,0.30000001192092896,100.1500015258789,100)" d=" M-2,-268.625 C-2,-268.625 -239.25,-136 -239.25,-136 C-239.25,-136 -232.5,132.375 -232.5,132.375 C-232.5,132.375 -2.125,274.875 -2.125,274.875 C-2.125,274.875 -2.125,3.75 -2.125,3.75 C-2.125,3.75 179.5,-103.125 179.5,-103.125 C179.5,-103.125 178.875,-33.75 178.875,-33.75 C178.875,-33.75 60.625,37.875 60.625,37.875 C60.625,37.875 59.875,104.125 59.875,104.125 C59.875,104.125 176.875,32.875 176.875,32.875 C176.875,32.875 176.125,101.125 176.125,101.125 C176.125,101.125 59.5,174 59.5,174 C59.5,174 58.75,237.875 58.75,237.875 C58.75,237.875 229.5,132.5 229.5,132.5 C229.5,132.5 235.875,-136.125 235.875,-136.125 C235.875,-136.125 -2,-268.625 -2,-268.625z"></path> </svg> '
        },
        7229: (t, e, o) => {
            o.d(e, {
                Z: () => a
            });
            var i = o(7091),
                n = o.n(i),
                r = new URL(o(3195), o.b);
            const a = '<img src="' + n()(r) + '" style="width:100%;height:100%;display:block" alt="Loading..."/> '
        },
        7091: t => {
            t.exports = function(t, e) {
                return e || (e = {}), t ? (t = String(t.__esModule ? t.default : t), e.hash && (t += e.hash), e.maybeNeedQuotes && /[\t\n\f\r "'=<>`]/.test(t) ? '"'.concat(t, '"') : t) : t
            }
        },
        2592: (t, e, o) => {
            const i = o(7138),
                n = o(5115),
                r = o(6907),
                a = o(3776);

            function s(t, e, o, r, a) {
                const s = [].slice.call(arguments, 1),
                    l = s.length,
                    d = "function" == typeof s[l - 1];
                if (!d && !i()) throw new Error("Callback required as last argument");
                if (!d) {
                    if (l < 1) throw new Error("Too few arguments provided");
                    return 1 === l ? (o = e, e = r = void 0) : 2 !== l || e.getContext || (r = o, o = e, e = void 0), new Promise((function(i, a) {
                        try {
                            const a = n.create(o, r);
                            i(t(a, e, r))
                        } catch (t) {
                            a(t)
                        }
                    }))
                }
                if (l < 2) throw new Error("Too few arguments provided");
                2 === l ? (a = o, o = e, e = r = void 0) : 3 === l && (e.getContext && void 0 === a ? (a = r, r = void 0) : (a = r, r = o, o = e, e = void 0));
                try {
                    const i = n.create(o, r);
                    a(null, t(i, e, r))
                } catch (t) {
                    a(t)
                }
            }
            e.create = n.create, e.toCanvas = s.bind(null, r.render), e.toDataURL = s.bind(null, r.renderToDataURL), e.toString = s.bind(null, (function(t, e, o) {
                return a.render(t, o)
            }))
        },
        7138: t => {
            t.exports = function() {
                return "function" == typeof Promise && Promise.prototype && Promise.prototype.then
            }
        },
        1845: (t, e, o) => {
            const i = o(242).getSymbolSize;
            e.getRowColCoords = function(t) {
                if (1 === t) return [];
                const e = Math.floor(t / 7) + 2,
                    o = i(t),
                    n = 145 === o ? 26 : 2 * Math.ceil((o - 13) / (2 * e - 2)),
                    r = [o - 7];
                for (let t = 1; t < e - 1; t++) r[t] = r[t - 1] - n;
                return r.push(6), r.reverse()
            }, e.getPositions = function(t) {
                const o = [],
                    i = e.getRowColCoords(t),
                    n = i.length;
                for (let t = 0; t < n; t++)
                    for (let e = 0; e < n; e++) 0 === t && 0 === e || 0 === t && e === n - 1 || t === n - 1 && 0 === e || o.push([i[t], i[e]]);
                return o
            }
        },
        8260: (t, e, o) => {
            const i = o(6910),
                n = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", " ", "$", "%", "*", "+", "-", ".", "/", ":"];

            function r(t) {
                this.mode = i.ALPHANUMERIC, this.data = t
            }
            r.getBitsLength = function(t) {
                return 11 * Math.floor(t / 2) + t % 2 * 6
            }, r.prototype.getLength = function() {
                return this.data.length
            }, r.prototype.getBitsLength = function() {
                return r.getBitsLength(this.data.length)
            }, r.prototype.write = function(t) {
                let e;
                for (e = 0; e + 2 <= this.data.length; e += 2) {
                    let o = 45 * n.indexOf(this.data[e]);
                    o += n.indexOf(this.data[e + 1]), t.put(o, 11)
                }
                this.data.length % 2 && t.put(n.indexOf(this.data[e]), 6)
            }, t.exports = r
        },
        7245: t => {
            function e() {
                this.buffer = [], this.length = 0
            }
            e.prototype = {
                get: function(t) {
                    const e = Math.floor(t / 8);
                    return 1 == (this.buffer[e] >>> 7 - t % 8 & 1)
                },
                put: function(t, e) {
                    for (let o = 0; o < e; o++) this.putBit(1 == (t >>> e - o - 1 & 1))
                },
                getLengthInBits: function() {
                    return this.length
                },
                putBit: function(t) {
                    const e = Math.floor(this.length / 8);
                    this.buffer.length <= e && this.buffer.push(0), t && (this.buffer[e] |= 128 >>> this.length % 8), this.length++
                }
            }, t.exports = e
        },
        3280: t => {
            function e(t) {
                if (!t || t < 1) throw new Error("BitMatrix size must be defined and greater than 0");
                this.size = t, this.data = new Uint8Array(t * t), this.reservedBit = new Uint8Array(t * t)
            }
            e.prototype.set = function(t, e, o, i) {
                const n = t * this.size + e;
                this.data[n] = o, i && (this.reservedBit[n] = !0)
            }, e.prototype.get = function(t, e) {
                return this.data[t * this.size + e]
            }, e.prototype.xor = function(t, e, o) {
                this.data[t * this.size + e] ^= o
            }, e.prototype.isReserved = function(t, e) {
                return this.reservedBit[t * this.size + e]
            }, t.exports = e
        },
        3424: (t, e, o) => {
            const i = o(2378),
                n = o(6910);

            function r(t) {
                this.mode = n.BYTE, "string" == typeof t && (t = i(t)), this.data = new Uint8Array(t)
            }
            r.getBitsLength = function(t) {
                return 8 * t
            }, r.prototype.getLength = function() {
                return this.data.length
            }, r.prototype.getBitsLength = function() {
                return r.getBitsLength(this.data.length)
            }, r.prototype.write = function(t) {
                for (let e = 0, o = this.data.length; e < o; e++) t.put(this.data[e], 8)
            }, t.exports = r
        },
        5393: (t, e, o) => {
            const i = o(4908),
                n = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 1, 2, 2, 4, 1, 2, 4, 4, 2, 4, 4, 4, 2, 4, 6, 5, 2, 4, 6, 6, 2, 5, 8, 8, 4, 5, 8, 8, 4, 5, 8, 11, 4, 8, 10, 11, 4, 9, 12, 16, 4, 9, 16, 16, 6, 10, 12, 18, 6, 10, 17, 16, 6, 11, 16, 19, 6, 13, 18, 21, 7, 14, 21, 25, 8, 16, 20, 25, 8, 17, 23, 25, 9, 17, 23, 34, 9, 18, 25, 30, 10, 20, 27, 32, 12, 21, 29, 35, 12, 23, 34, 37, 12, 25, 34, 40, 13, 26, 35, 42, 14, 28, 38, 45, 15, 29, 40, 48, 16, 31, 43, 51, 17, 33, 45, 54, 18, 35, 48, 57, 19, 37, 51, 60, 19, 38, 53, 63, 20, 40, 56, 66, 21, 43, 59, 70, 22, 45, 62, 74, 24, 47, 65, 77, 25, 49, 68, 81],
                r = [7, 10, 13, 17, 10, 16, 22, 28, 15, 26, 36, 44, 20, 36, 52, 64, 26, 48, 72, 88, 36, 64, 96, 112, 40, 72, 108, 130, 48, 88, 132, 156, 60, 110, 160, 192, 72, 130, 192, 224, 80, 150, 224, 264, 96, 176, 260, 308, 104, 198, 288, 352, 120, 216, 320, 384, 132, 240, 360, 432, 144, 280, 408, 480, 168, 308, 448, 532, 180, 338, 504, 588, 196, 364, 546, 650, 224, 416, 600, 700, 224, 442, 644, 750, 252, 476, 690, 816, 270, 504, 750, 900, 300, 560, 810, 960, 312, 588, 870, 1050, 336, 644, 952, 1110, 360, 700, 1020, 1200, 390, 728, 1050, 1260, 420, 784, 1140, 1350, 450, 812, 1200, 1440, 480, 868, 1290, 1530, 510, 924, 1350, 1620, 540, 980, 1440, 1710, 570, 1036, 1530, 1800, 570, 1064, 1590, 1890, 600, 1120, 1680, 1980, 630, 1204, 1770, 2100, 660, 1260, 1860, 2220, 720, 1316, 1950, 2310, 750, 1372, 2040, 2430];
            e.getBlocksCount = function(t, e) {
                switch (e) {
                    case i.L:
                        return n[4 * (t - 1) + 0];
                    case i.M:
                        return n[4 * (t - 1) + 1];
                    case i.Q:
                        return n[4 * (t - 1) + 2];
                    case i.H:
                        return n[4 * (t - 1) + 3];
                    default:
                        return
                }
            }, e.getTotalCodewordsCount = function(t, e) {
                switch (e) {
                    case i.L:
                        return r[4 * (t - 1) + 0];
                    case i.M:
                        return r[4 * (t - 1) + 1];
                    case i.Q:
                        return r[4 * (t - 1) + 2];
                    case i.H:
                        return r[4 * (t - 1) + 3];
                    default:
                        return
                }
            }
        },
        4908: (t, e) => {
            e.L = {
                bit: 1
            }, e.M = {
                bit: 0
            }, e.Q = {
                bit: 3
            }, e.H = {
                bit: 2
            }, e.isValid = function(t) {
                return t && void 0 !== t.bit && t.bit >= 0 && t.bit < 4
            }, e.from = function(t, o) {
                if (e.isValid(t)) return t;
                try {
                    return function(t) {
                        if ("string" != typeof t) throw new Error("Param is not a string");
                        switch (t.toLowerCase()) {
                            case "l":
                            case "low":
                                return e.L;
                            case "m":
                            case "medium":
                                return e.M;
                            case "q":
                            case "quartile":
                                return e.Q;
                            case "h":
                            case "high":
                                return e.H;
                            default:
                                throw new Error("Unknown EC Level: " + t)
                        }
                    }(t)
                } catch (t) {
                    return o
                }
            }
        },
        6526: (t, e, o) => {
            const i = o(242).getSymbolSize;
            e.getPositions = function(t) {
                const e = i(t);
                return [
                    [0, 0],
                    [e - 7, 0],
                    [0, e - 7]
                ]
            }
        },
        1642: (t, e, o) => {
            const i = o(242),
                n = i.getBCHDigit(1335);
            e.getEncodedBits = function(t, e) {
                const o = t.bit << 3 | e;
                let r = o << 10;
                for (; i.getBCHDigit(r) - n >= 0;) r ^= 1335 << i.getBCHDigit(r) - n;
                return 21522 ^ (o << 10 | r)
            }
        },
        9729: (t, e) => {
            const o = new Uint8Array(512),
                i = new Uint8Array(256);
            ! function() {
                let t = 1;
                for (let e = 0; e < 255; e++) o[e] = t, i[t] = e, t <<= 1, 256 & t && (t ^= 285);
                for (let t = 255; t < 512; t++) o[t] = o[t - 255]
            }(), e.log = function(t) {
                if (t < 1) throw new Error("log(" + t + ")");
                return i[t]
            }, e.exp = function(t) {
                return o[t]
            }, e.mul = function(t, e) {
                return 0 === t || 0 === e ? 0 : o[i[t] + i[e]]
            }
        },
        5442: (t, e, o) => {
            const i = o(6910),
                n = o(242);

            function r(t) {
                this.mode = i.KANJI, this.data = t
            }
            r.getBitsLength = function(t) {
                return 13 * t
            }, r.prototype.getLength = function() {
                return this.data.length
            }, r.prototype.getBitsLength = function() {
                return r.getBitsLength(this.data.length)
            }, r.prototype.write = function(t) {
                let e;
                for (e = 0; e < this.data.length; e++) {
                    let o = n.toSJIS(this.data[e]);
                    if (o >= 33088 && o <= 40956) o -= 33088;
                    else {
                        if (!(o >= 57408 && o <= 60351)) throw new Error("Invalid SJIS character: " + this.data[e] + "\nMake sure your charset is UTF-8");
                        o -= 49472
                    }
                    o = 192 * (o >>> 8 & 255) + (255 & o), t.put(o, 13)
                }
            }, t.exports = r
        },
        7126: (t, e) => {
            e.Patterns = {
                PATTERN000: 0,
                PATTERN001: 1,
                PATTERN010: 2,
                PATTERN011: 3,
                PATTERN100: 4,
                PATTERN101: 5,
                PATTERN110: 6,
                PATTERN111: 7
            };

            function o(t, o, i) {
                switch (t) {
                    case e.Patterns.PATTERN000:
                        return (o + i) % 2 == 0;
                    case e.Patterns.PATTERN001:
                        return o % 2 == 0;
                    case e.Patterns.PATTERN010:
                        return i % 3 == 0;
                    case e.Patterns.PATTERN011:
                        return (o + i) % 3 == 0;
                    case e.Patterns.PATTERN100:
                        return (Math.floor(o / 2) + Math.floor(i / 3)) % 2 == 0;
                    case e.Patterns.PATTERN101:
                        return o * i % 2 + o * i % 3 == 0;
                    case e.Patterns.PATTERN110:
                        return (o * i % 2 + o * i % 3) % 2 == 0;
                    case e.Patterns.PATTERN111:
                        return (o * i % 3 + (o + i) % 2) % 2 == 0;
                    default:
                        throw new Error("bad maskPattern:" + t)
                }
            }
            e.isValid = function(t) {
                return null != t && "" !== t && !isNaN(t) && t >= 0 && t <= 7
            }, e.from = function(t) {
                return e.isValid(t) ? parseInt(t, 10) : void 0
            }, e.getPenaltyN1 = function(t) {
                const e = t.size;
                let o = 0,
                    i = 0,
                    n = 0,
                    r = null,
                    a = null;
                for (let s = 0; s < e; s++) {
                    i = n = 0, r = a = null;
                    for (let l = 0; l < e; l++) {
                        let e = t.get(s, l);
                        e === r ? i++ : (i >= 5 && (o += i - 5 + 3), r = e, i = 1), e = t.get(l, s), e === a ? n++ : (n >= 5 && (o += n - 5 + 3), a = e, n = 1)
                    }
                    i >= 5 && (o += i - 5 + 3), n >= 5 && (o += n - 5 + 3)
                }
                return o
            }, e.getPenaltyN2 = function(t) {
                const e = t.size;
                let o = 0;
                for (let i = 0; i < e - 1; i++)
                    for (let n = 0; n < e - 1; n++) {
                        const e = t.get(i, n) + t.get(i, n + 1) + t.get(i + 1, n) + t.get(i + 1, n + 1);
                        4 !== e && 0 !== e || o++
                    }
                return 3 * o
            }, e.getPenaltyN3 = function(t) {
                const e = t.size;
                let o = 0,
                    i = 0,
                    n = 0;
                for (let r = 0; r < e; r++) {
                    i = n = 0;
                    for (let a = 0; a < e; a++) i = i << 1 & 2047 | t.get(r, a), a >= 10 && (1488 === i || 93 === i) && o++, n = n << 1 & 2047 | t.get(a, r), a >= 10 && (1488 === n || 93 === n) && o++
                }
                return 40 * o
            }, e.getPenaltyN4 = function(t) {
                let e = 0;
                const o = t.data.length;
                for (let i = 0; i < o; i++) e += t.data[i];
                return 10 * Math.abs(Math.ceil(100 * e / o / 5) - 10)
            }, e.applyMask = function(t, e) {
                const i = e.size;
                for (let n = 0; n < i; n++)
                    for (let r = 0; r < i; r++) e.isReserved(r, n) || e.xor(r, n, o(t, r, n))
            }, e.getBestMask = function(t, o) {
                const i = Object.keys(e.Patterns).length;
                let n = 0,
                    r = 1 / 0;
                for (let a = 0; a < i; a++) {
                    o(a), e.applyMask(a, t);
                    const i = e.getPenaltyN1(t) + e.getPenaltyN2(t) + e.getPenaltyN3(t) + e.getPenaltyN4(t);
                    e.applyMask(a, t), i < r && (r = i, n = a)
                }
                return n
            }
        },
        6910: (t, e, o) => {
            const i = o(3114),
                n = o(7007);
            e.NUMERIC = {
                id: "Numeric",
                bit: 1,
                ccBits: [10, 12, 14]
            }, e.ALPHANUMERIC = {
                id: "Alphanumeric",
                bit: 2,
                ccBits: [9, 11, 13]
            }, e.BYTE = {
                id: "Byte",
                bit: 4,
                ccBits: [8, 16, 16]
            }, e.KANJI = {
                id: "Kanji",
                bit: 8,
                ccBits: [8, 10, 12]
            }, e.MIXED = {
                bit: -1
            }, e.getCharCountIndicator = function(t, e) {
                if (!t.ccBits) throw new Error("Invalid mode: " + t);
                if (!i.isValid(e)) throw new Error("Invalid version: " + e);
                return e >= 1 && e < 10 ? t.ccBits[0] : e < 27 ? t.ccBits[1] : t.ccBits[2]
            }, e.getBestModeForData = function(t) {
                return n.testNumeric(t) ? e.NUMERIC : n.testAlphanumeric(t) ? e.ALPHANUMERIC : n.testKanji(t) ? e.KANJI : e.BYTE
            }, e.toString = function(t) {
                if (t && t.id) return t.id;
                throw new Error("Invalid mode")
            }, e.isValid = function(t) {
                return t && t.bit && t.ccBits
            }, e.from = function(t, o) {
                if (e.isValid(t)) return t;
                try {
                    return function(t) {
                        if ("string" != typeof t) throw new Error("Param is not a string");
                        switch (t.toLowerCase()) {
                            case "numeric":
                                return e.NUMERIC;
                            case "alphanumeric":
                                return e.ALPHANUMERIC;
                            case "kanji":
                                return e.KANJI;
                            case "byte":
                                return e.BYTE;
                            default:
                                throw new Error("Unknown mode: " + t)
                        }
                    }(t)
                } catch (t) {
                    return o
                }
            }
        },
        1085: (t, e, o) => {
            const i = o(6910);

            function n(t) {
                this.mode = i.NUMERIC, this.data = t.toString()
            }
            n.getBitsLength = function(t) {
                return 10 * Math.floor(t / 3) + (t % 3 ? t % 3 * 3 + 1 : 0)
            }, n.prototype.getLength = function() {
                return this.data.length
            }, n.prototype.getBitsLength = function() {
                return n.getBitsLength(this.data.length)
            }, n.prototype.write = function(t) {
                let e, o, i;
                for (e = 0; e + 3 <= this.data.length; e += 3) o = this.data.substr(e, 3), i = parseInt(o, 10), t.put(i, 10);
                const n = this.data.length - e;
                n > 0 && (o = this.data.substr(e), i = parseInt(o, 10), t.put(i, 3 * n + 1))
            }, t.exports = n
        },
        6143: (t, e, o) => {
            const i = o(9729);
            e.mul = function(t, e) {
                const o = new Uint8Array(t.length + e.length - 1);
                for (let n = 0; n < t.length; n++)
                    for (let r = 0; r < e.length; r++) o[n + r] ^= i.mul(t[n], e[r]);
                return o
            }, e.mod = function(t, e) {
                let o = new Uint8Array(t);
                for (; o.length - e.length >= 0;) {
                    const t = o[0];
                    for (let n = 0; n < e.length; n++) o[n] ^= i.mul(e[n], t);
                    let n = 0;
                    for (; n < o.length && 0 === o[n];) n++;
                    o = o.slice(n)
                }
                return o
            }, e.generateECPolynomial = function(t) {
                let o = new Uint8Array([1]);
                for (let n = 0; n < t; n++) o = e.mul(o, new Uint8Array([1, i.exp(n)]));
                return o
            }
        },
        5115: (t, e, o) => {
            const i = o(242),
                n = o(4908),
                r = o(7245),
                a = o(3280),
                s = o(1845),
                l = o(6526),
                d = o(7126),
                c = o(5393),
                h = o(2882),
                p = o(3103),
                u = o(1642),
                m = o(6910),
                C = o(6130);

            function b(t, e, o) {
                const i = t.size,
                    n = u.getEncodedBits(e, o);
                let r, a;
                for (r = 0; r < 15; r++) a = 1 == (n >> r & 1), r < 6 ? t.set(r, 8, a, !0) : r < 8 ? t.set(r + 1, 8, a, !0) : t.set(i - 15 + r, 8, a, !0), r < 8 ? t.set(8, i - r - 1, a, !0) : r < 9 ? t.set(8, 15 - r - 1 + 1, a, !0) : t.set(8, 15 - r - 1, a, !0);
                t.set(i - 8, 8, 1, !0)
            }

            function f(t, e, o, n) {
                let u;
                if (Array.isArray(t)) u = C.fromArray(t);
                else {
                    if ("string" != typeof t) throw new Error("Invalid data");
                    {
                        let i = e;
                        if (!i) {
                            const e = C.rawSplit(t);
                            i = p.getBestVersionForData(e, o)
                        }
                        u = C.fromString(t, i || 40)
                    }
                }
                const f = p.getBestVersionForData(u, o);
                if (!f) throw new Error("The amount of data is too big to be stored in a QR Code");
                if (e) {
                    if (e < f) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + f + ".\n")
                } else e = f;
                const g = function(t, e, o) {
                        const n = new r;
                        o.forEach((function(e) {
                            n.put(e.mode.bit, 4), n.put(e.getLength(), m.getCharCountIndicator(e.mode, t)), e.write(n)
                        }));
                        const a = 8 * (i.getSymbolTotalCodewords(t) - c.getTotalCodewordsCount(t, e));
                        for (n.getLengthInBits() + 4 <= a && n.put(0, 4); n.getLengthInBits() % 8 != 0;) n.putBit(0);
                        const s = (a - n.getLengthInBits()) / 8;
                        for (let t = 0; t < s; t++) n.put(t % 2 ? 17 : 236, 8);
                        return function(t, e, o) {
                            const n = i.getSymbolTotalCodewords(e),
                                r = n - c.getTotalCodewordsCount(e, o),
                                a = c.getBlocksCount(e, o),
                                s = a - n % a,
                                l = Math.floor(n / a),
                                d = Math.floor(r / a),
                                p = d + 1,
                                u = l - d,
                                m = new h(u);
                            let C = 0;
                            const b = new Array(a),
                                f = new Array(a);
                            let g = 0;
                            const v = new Uint8Array(t.buffer);
                            for (let t = 0; t < a; t++) {
                                const e = t < s ? d : p;
                                b[t] = v.slice(C, C + e), f[t] = m.encode(b[t]), C += e, g = Math.max(g, e)
                            }
                            const y = new Uint8Array(n);
                            let w, x, _ = 0;
                            for (w = 0; w < g; w++)
                                for (x = 0; x < a; x++) w < b[x].length && (y[_++] = b[x][w]);
                            for (w = 0; w < u; w++)
                                for (x = 0; x < a; x++) y[_++] = f[x][w];
                            return y
                        }(n, t, e)
                    }(e, o, u),
                    v = i.getSymbolSize(e),
                    y = new a(v);
                return function(t, e) {
                        const o = t.size,
                            i = l.getPositions(e);
                        for (let e = 0; e < i.length; e++) {
                            const n = i[e][0],
                                r = i[e][1];
                            for (let e = -1; e <= 7; e++)
                                if (!(n + e <= -1 || o <= n + e))
                                    for (let i = -1; i <= 7; i++) r + i <= -1 || o <= r + i || (e >= 0 && e <= 6 && (0 === i || 6 === i) || i >= 0 && i <= 6 && (0 === e || 6 === e) || e >= 2 && e <= 4 && i >= 2 && i <= 4 ? t.set(n + e, r + i, !0, !0) : t.set(n + e, r + i, !1, !0))
                        }
                    }(y, e),
                    function(t) {
                        const e = t.size;
                        for (let o = 8; o < e - 8; o++) {
                            const e = o % 2 == 0;
                            t.set(o, 6, e, !0), t.set(6, o, e, !0)
                        }
                    }(y),
                    function(t, e) {
                        const o = s.getPositions(e);
                        for (let e = 0; e < o.length; e++) {
                            const i = o[e][0],
                                n = o[e][1];
                            for (let e = -2; e <= 2; e++)
                                for (let o = -2; o <= 2; o++) - 2 === e || 2 === e || -2 === o || 2 === o || 0 === e && 0 === o ? t.set(i + e, n + o, !0, !0) : t.set(i + e, n + o, !1, !0)
                        }
                    }(y, e), b(y, o, 0), e >= 7 && function(t, e) {
                        const o = t.size,
                            i = p.getEncodedBits(e);
                        let n, r, a;
                        for (let e = 0; e < 18; e++) n = Math.floor(e / 3), r = e % 3 + o - 8 - 3, a = 1 == (i >> e & 1), t.set(n, r, a, !0), t.set(r, n, a, !0)
                    }(y, e),
                    function(t, e) {
                        const o = t.size;
                        let i = -1,
                            n = o - 1,
                            r = 7,
                            a = 0;
                        for (let s = o - 1; s > 0; s -= 2)
                            for (6 === s && s--;;) {
                                for (let o = 0; o < 2; o++)
                                    if (!t.isReserved(n, s - o)) {
                                        let i = !1;
                                        a < e.length && (i = 1 == (e[a] >>> r & 1)), t.set(n, s - o, i), r--, -1 === r && (a++, r = 7)
                                    } if (n += i, n < 0 || o <= n) {
                                    n -= i, i = -i;
                                    break
                                }
                            }
                    }(y, g), isNaN(n) && (n = d.getBestMask(y, b.bind(null, y, o))), d.applyMask(n, y), b(y, o, n), {
                        modules: y,
                        version: e,
                        errorCorrectionLevel: o,
                        maskPattern: n,
                        segments: u
                    }
            }
            e.create = function(t, e) {
                if (void 0 === t || "" === t) throw new Error("No input text");
                let o, r, a = n.M;
                return void 0 !== e && (a = n.from(e.errorCorrectionLevel, n.M), o = p.from(e.version), r = d.from(e.maskPattern), e.toSJISFunc && i.setToSJISFunction(e.toSJISFunc)), f(t, o, a, r)
            }
        },
        2882: (t, e, o) => {
            const i = o(6143);

            function n(t) {
                this.genPoly = void 0, this.degree = t, this.degree && this.initialize(this.degree)
            }
            n.prototype.initialize = function(t) {
                this.degree = t, this.genPoly = i.generateECPolynomial(this.degree)
            }, n.prototype.encode = function(t) {
                if (!this.genPoly) throw new Error("Encoder not initialized");
                const e = new Uint8Array(t.length + this.degree);
                e.set(t);
                const o = i.mod(e, this.genPoly),
                    n = this.degree - o.length;
                if (n > 0) {
                    const t = new Uint8Array(this.degree);
                    return t.set(o, n), t
                }
                return o
            }, t.exports = n
        },
        7007: (t, e) => {
            const o = "[0-9]+";
            let i = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
            i = i.replace(/u/g, "\\u");
            const n = "(?:(?![A-Z0-9 $%*+\\-./:]|" + i + ")(?:.|[\r\n]))+";
            e.KANJI = new RegExp(i, "g"), e.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g"), e.BYTE = new RegExp(n, "g"), e.NUMERIC = new RegExp(o, "g"), e.ALPHANUMERIC = new RegExp("[A-Z $%*+\\-./:]+", "g");
            const r = new RegExp("^" + i + "$"),
                a = new RegExp("^" + o + "$"),
                s = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
            e.testKanji = function(t) {
                return r.test(t)
            }, e.testNumeric = function(t) {
                return a.test(t)
            }, e.testAlphanumeric = function(t) {
                return s.test(t)
            }
        },
        6130: (t, e, o) => {
            const i = o(6910),
                n = o(1085),
                r = o(8260),
                a = o(3424),
                s = o(5442),
                l = o(7007),
                d = o(242),
                c = o(5987);

            function h(t) {
                return unescape(encodeURIComponent(t)).length
            }

            function p(t, e, o) {
                const i = [];
                let n;
                for (; null !== (n = t.exec(o));) i.push({
                    data: n[0],
                    index: n.index,
                    mode: e,
                    length: n[0].length
                });
                return i
            }

            function u(t) {
                const e = p(l.NUMERIC, i.NUMERIC, t),
                    o = p(l.ALPHANUMERIC, i.ALPHANUMERIC, t);
                let n, r;
                return d.isKanjiModeEnabled() ? (n = p(l.BYTE, i.BYTE, t), r = p(l.KANJI, i.KANJI, t)) : (n = p(l.BYTE_KANJI, i.BYTE, t), r = []), e.concat(o, n, r).sort((function(t, e) {
                    return t.index - e.index
                })).map((function(t) {
                    return {
                        data: t.data,
                        mode: t.mode,
                        length: t.length
                    }
                }))
            }

            function m(t, e) {
                switch (e) {
                    case i.NUMERIC:
                        return n.getBitsLength(t);
                    case i.ALPHANUMERIC:
                        return r.getBitsLength(t);
                    case i.KANJI:
                        return s.getBitsLength(t);
                    case i.BYTE:
                        return a.getBitsLength(t)
                }
            }

            function C(t, e) {
                let o;
                const l = i.getBestModeForData(t);
                if (o = i.from(e, l), o !== i.BYTE && o.bit < l.bit) throw new Error('"' + t + '" cannot be encoded with mode ' + i.toString(o) + ".\n Suggested mode is: " + i.toString(l));
                switch (o !== i.KANJI || d.isKanjiModeEnabled() || (o = i.BYTE), o) {
                    case i.NUMERIC:
                        return new n(t);
                    case i.ALPHANUMERIC:
                        return new r(t);
                    case i.KANJI:
                        return new s(t);
                    case i.BYTE:
                        return new a(t)
                }
            }
            e.fromArray = function(t) {
                return t.reduce((function(t, e) {
                    return "string" == typeof e ? t.push(C(e, null)) : e.data && t.push(C(e.data, e.mode)), t
                }), [])
            }, e.fromString = function(t, o) {
                const n = function(t) {
                        const e = [];
                        for (let o = 0; o < t.length; o++) {
                            const n = t[o];
                            switch (n.mode) {
                                case i.NUMERIC:
                                    e.push([n, {
                                        data: n.data,
                                        mode: i.ALPHANUMERIC,
                                        length: n.length
                                    }, {
                                        data: n.data,
                                        mode: i.BYTE,
                                        length: n.length
                                    }]);
                                    break;
                                case i.ALPHANUMERIC:
                                    e.push([n, {
                                        data: n.data,
                                        mode: i.BYTE,
                                        length: n.length
                                    }]);
                                    break;
                                case i.KANJI:
                                    e.push([n, {
                                        data: n.data,
                                        mode: i.BYTE,
                                        length: h(n.data)
                                    }]);
                                    break;
                                case i.BYTE:
                                    e.push([{
                                        data: n.data,
                                        mode: i.BYTE,
                                        length: h(n.data)
                                    }])
                            }
                        }
                        return e
                    }(u(t, d.isKanjiModeEnabled())),
                    r = function(t, e) {
                        const o = {},
                            n = {
                                start: {}
                            };
                        let r = ["start"];
                        for (let a = 0; a < t.length; a++) {
                            const s = t[a],
                                l = [];
                            for (let t = 0; t < s.length; t++) {
                                const d = s[t],
                                    c = "" + a + t;
                                l.push(c), o[c] = {
                                    node: d,
                                    lastCount: 0
                                }, n[c] = {};
                                for (let t = 0; t < r.length; t++) {
                                    const a = r[t];
                                    o[a] && o[a].node.mode === d.mode ? (n[a][c] = m(o[a].lastCount + d.length, d.mode) - m(o[a].lastCount, d.mode), o[a].lastCount += d.length) : (o[a] && (o[a].lastCount = d.length), n[a][c] = m(d.length, d.mode) + 4 + i.getCharCountIndicator(d.mode, e))
                                }
                            }
                            r = l
                        }
                        for (let t = 0; t < r.length; t++) n[r[t]].end = 0;
                        return {
                            map: n,
                            table: o
                        }
                    }(n, o),
                    a = c.find_path(r.map, "start", "end"),
                    s = [];
                for (let t = 1; t < a.length - 1; t++) s.push(r.table[a[t]].node);
                return e.fromArray(s.reduce((function(t, e) {
                    const o = t.length - 1 >= 0 ? t[t.length - 1] : null;
                    return o && o.mode === e.mode ? (t[t.length - 1].data += e.data, t) : (t.push(e), t)
                }), []))
            }, e.rawSplit = function(t) {
                return e.fromArray(u(t, d.isKanjiModeEnabled()))
            }
        },
        242: (t, e) => {
            let o;
            const i = [0, 26, 44, 70, 100, 134, 172, 196, 242, 292, 346, 404, 466, 532, 581, 655, 733, 815, 901, 991, 1085, 1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185, 2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706];
            e.getSymbolSize = function(t) {
                if (!t) throw new Error('"version" cannot be null or undefined');
                if (t < 1 || t > 40) throw new Error('"version" should be in range from 1 to 40');
                return 4 * t + 17
            }, e.getSymbolTotalCodewords = function(t) {
                return i[t]
            }, e.getBCHDigit = function(t) {
                let e = 0;
                for (; 0 !== t;) e++, t >>>= 1;
                return e
            }, e.setToSJISFunction = function(t) {
                if ("function" != typeof t) throw new Error('"toSJISFunc" is not a valid function.');
                o = t
            }, e.isKanjiModeEnabled = function() {
                return void 0 !== o
            }, e.toSJIS = function(t) {
                return o(t)
            }
        },
        3114: (t, e) => {
            e.isValid = function(t) {
                return !isNaN(t) && t >= 1 && t <= 40
            }
        },
        3103: (t, e, o) => {
            const i = o(242),
                n = o(5393),
                r = o(4908),
                a = o(6910),
                s = o(3114),
                l = i.getBCHDigit(7973);

            function d(t, e) {
                return a.getCharCountIndicator(t, e) + 4
            }

            function c(t, e) {
                let o = 0;
                return t.forEach((function(t) {
                    const i = d(t.mode, e);
                    o += i + t.getBitsLength()
                })), o
            }
            e.from = function(t, e) {
                return s.isValid(t) ? parseInt(t, 10) : e
            }, e.getCapacity = function(t, e, o) {
                if (!s.isValid(t)) throw new Error("Invalid QR Code version");
                void 0 === o && (o = a.BYTE);
                const r = 8 * (i.getSymbolTotalCodewords(t) - n.getTotalCodewordsCount(t, e));
                if (o === a.MIXED) return r;
                const l = r - d(o, t);
                switch (o) {
                    case a.NUMERIC:
                        return Math.floor(l / 10 * 3);
                    case a.ALPHANUMERIC:
                        return Math.floor(l / 11 * 2);
                    case a.KANJI:
                        return Math.floor(l / 13);
                    case a.BYTE:
                    default:
                        return Math.floor(l / 8)
                }
            }, e.getBestVersionForData = function(t, o) {
                let i;
                const n = r.from(o, r.M);
                if (Array.isArray(t)) {
                    if (t.length > 1) return function(t, o) {
                        for (let i = 1; i <= 40; i++)
                            if (c(t, i) <= e.getCapacity(i, o, a.MIXED)) return i
                    }(t, n);
                    if (0 === t.length) return 1;
                    i = t[0]
                } else i = t;
                return function(t, o, i) {
                    for (let n = 1; n <= 40; n++)
                        if (o <= e.getCapacity(n, i, t)) return n
                }(i.mode, i.getLength(), n)
            }, e.getEncodedBits = function(t) {
                if (!s.isValid(t) || t < 7) throw new Error("Invalid QR Code version");
                let e = t << 12;
                for (; i.getBCHDigit(e) - l >= 0;) e ^= 7973 << i.getBCHDigit(e) - l;
                return t << 12 | e
            }
        },
        6907: (t, e, o) => {
            const i = o(9653);
            e.render = function(t, e, o) {
                let n = o,
                    r = e;
                void 0 !== n || e && e.getContext || (n = e, e = void 0), e || (r = function() {
                    try {
                        return document.createElement("canvas")
                    } catch (t) {
                        throw new Error("You need to specify a canvas element")
                    }
                }()), n = i.getOptions(n);
                const a = i.getImageWidth(t.modules.size, n),
                    s = r.getContext("2d"),
                    l = s.createImageData(a, a);
                return i.qrToImageData(l.data, t, n),
                    function(t, e, o) {
                        t.clearRect(0, 0, e.width, e.height), e.style || (e.style = {}), e.height = o, e.width = o, e.style.height = o + "px", e.style.width = o + "px"
                    }(s, r, a), s.putImageData(l, 0, 0), r
            }, e.renderToDataURL = function(t, o, i) {
                let n = i;
                void 0 !== n || o && o.getContext || (n = o, o = void 0), n || (n = {});
                const r = e.render(t, o, n),
                    a = n.type || "image/png",
                    s = n.rendererOpts || {};
                return r.toDataURL(a, s.quality)
            }
        },
        3776: (t, e, o) => {
            const i = o(9653);

            function n(t, e) {
                const o = t.a / 255,
                    i = e + '="' + t.hex + '"';
                return o < 1 ? i + " " + e + '-opacity="' + o.toFixed(2).slice(1) + '"' : i
            }

            function r(t, e, o) {
                let i = t + e;
                return void 0 !== o && (i += " " + o), i
            }
            e.render = function(t, e, o) {
                const a = i.getOptions(e),
                    s = t.modules.size,
                    l = t.modules.data,
                    d = s + 2 * a.margin,
                    c = a.color.light.a ? "<path " + n(a.color.light, "fill") + ' d="M0 0h' + d + "v" + d + 'H0z"/>' : "",
                    h = "<path " + n(a.color.dark, "stroke") + ' d="' + function(t, e, o) {
                        let i = "",
                            n = 0,
                            a = !1,
                            s = 0;
                        for (let l = 0; l < t.length; l++) {
                            const d = Math.floor(l % e),
                                c = Math.floor(l / e);
                            d || a || (a = !0), t[l] ? (s++, l > 0 && d > 0 && t[l - 1] || (i += a ? r("M", d + o, .5 + c + o) : r("m", n, 0), n = 0, a = !1), d + 1 < e && t[l + 1] || (i += r("h", s), s = 0)) : n++
                        }
                        return i
                    }(l, s, a.margin) + '"/>',
                    p = 'viewBox="0 0 ' + d + " " + d + '"',
                    u = '<svg xmlns="http://www.w3.org/2000/svg" ' + (a.width ? 'width="' + a.width + '" height="' + a.width + '" ' : "") + p + ' shape-rendering="crispEdges">' + c + h + "</svg>\n";
                return "function" == typeof o && o(null, u), u
            }
        },
        9653: (t, e) => {
            function o(t) {
                if ("number" == typeof t && (t = t.toString()), "string" != typeof t) throw new Error("Color should be defined as hex string");
                let e = t.slice().replace("#", "").split("");
                if (e.length < 3 || 5 === e.length || e.length > 8) throw new Error("Invalid hex color: " + t);
                3 !== e.length && 4 !== e.length || (e = Array.prototype.concat.apply([], e.map((function(t) {
                    return [t, t]
                })))), 6 === e.length && e.push("F", "F");
                const o = parseInt(e.join(""), 16);
                return {
                    r: o >> 24 & 255,
                    g: o >> 16 & 255,
                    b: o >> 8 & 255,
                    a: 255 & o,
                    hex: "#" + e.slice(0, 6).join("")
                }
            }
            e.getOptions = function(t) {
                t || (t = {}), t.color || (t.color = {});
                const e = void 0 === t.margin || null === t.margin || t.margin < 0 ? 4 : t.margin,
                    i = t.width && t.width >= 21 ? t.width : void 0,
                    n = t.scale || 4;
                return {
                    width: i,
                    scale: i ? 4 : n,
                    margin: e,
                    color: {
                        dark: o(t.color.dark || "#000000ff"),
                        light: o(t.color.light || "#ffffffff")
                    },
                    type: t.type,
                    rendererOpts: t.rendererOpts || {}
                }
            }, e.getScale = function(t, e) {
                return e.width && e.width >= t + 2 * e.margin ? e.width / (t + 2 * e.margin) : e.scale
            }, e.getImageWidth = function(t, o) {
                const i = e.getScale(t, o);
                return Math.floor((t + 2 * o.margin) * i)
            }, e.qrToImageData = function(t, o, i) {
                const n = o.modules.size,
                    r = o.modules.data,
                    a = e.getScale(n, i),
                    s = Math.floor((n + 2 * i.margin) * a),
                    l = i.margin * a,
                    d = [i.color.light, i.color.dark];
                for (let e = 0; e < s; e++)
                    for (let o = 0; o < s; o++) {
                        let c = 4 * (e * s + o),
                            h = i.color.light;
                        e >= l && o >= l && e < s - l && o < s - l && (h = d[r[Math.floor((e - l) / a) * n + Math.floor((o - l) / a)] ? 1 : 0]), t[c++] = h.r, t[c++] = h.g, t[c++] = h.b, t[c] = h.a
                    }
            }
        },
        7390: (t, e, o) => {
            o.d(e, {
                Z: () => s
            });
            var i = o(781),
                n = o(4427),
                r = o(1673);
            const a = (0, n.lv)(`<template><style>${i.Z.toString()}</style><x-fibbl-close-button></x-fibbl-close-button><slot></slot></template>`);
            class s extends r.Z {
                constructor() {
                    super(), this.shadowRoot.append(a.content.cloneNode(!0)), this.shadowRoot.querySelector("x-fibbl-close-button").onclick = this.onClose, this.shadowRoot.addEventListener("x-fibbl-close", this.onClose)
                }
                onClose = () => {
                    this.remove(), this.dispatchEvent(new CustomEvent("x-fibbl-close"))
                }
            }(0, n.MW)("x-fibbl-closable-modal-window", s)
        },
        8369: (t, e, o) => {
            var i = o(4285),
                n = o(9485);
            (0, o(628).vF)("x-fibbl-close-button", n.Z, i.Z, {
                role: "button",
                "aria-label": "Close"
            })
        },
        8649: (t, e, o) => {
            o.d(e, {
                Z: () => r
            }), o(1673);
            var i = o(608),
                n = (o(8369), o(1061));
            (0, o(628).vF)("x-fibbl-expand-button", '<svg viewBox="0 0 18 18" stroke-linecap="round" stroke-linejoin="round"> <path d="M6.09091 11.9091L1 17"/> <path d="M17.0001 1L11.9092 6.09091"/> <path d="M11.9092 11.9091L17.0001 17"/> <path d="M1 1L6.09091 6.09091"/> <path d="M12.6367 1H17.0004V5.36364"/> <path d="M5.36364 17H1V12.6364"/> <path d="M1 5.36364V1H5.36364"/> <path d="M17.0004 12.6364V17H12.6367"/> </svg> ', n.Z, {
                role: "button",
                "aria-label": "Expand"
            });
            class r extends i.Z {
                shadowRoot = this.attachShadow({
                    mode: "open"
                });
                currentRoot = this.shadowRoot;
                modalWindow = document.createElement("x-fibbl-modal-window");
                modalWindowStyle = document.createElement("style");
                constructor(t) {
                    super(), t && this.currentRoot.append(t.content.cloneNode(!0))
                }
                async startTransition(t) {
                    t.classList.add("in-transition"), await new Promise((e => t.addEventListener("animationend", e, {
                        once: !0
                    }))), t.classList.remove("in-transition")
                }
                get isExpanded() {
                    return this.modalWindow.shadowRoot === this.currentRoot
                }
                async onExpand(t) {
                    await this.startTransition(t), t.classList.add("expanded-root");
                    const e = getComputedStyle(this),
                        o = /^rgb\(/.test(e.backgroundColor) ? "" : "background-color: white;";
                    this.modalWindowStyle.innerHTML = `:host(x-fibbl-modal-window) {\n           color: black;\n           background: ${getComputedStyle(this).background};${o}\n        }`, this.modalWindow.shadowRoot.append(...this.currentRoot.children, this.modalWindowStyle), this.currentRoot = this.modalWindow.shadowRoot, document.body.append(this.modalWindow)
                }
                async onClose(t) {
                    await this.startTransition(t), t.classList.remove("expanded-root"), this.currentRoot = this.shadowRoot, this.modalWindowStyle.remove(), this.currentRoot.append(...this.modalWindow.shadowRoot.children), this.modalWindow.remove(), await this.endClose(t)
                }
                async endClose(t) {
                    t.classList.add("minified"), await new Promise((e => t.addEventListener("animationend", e, {
                        once: !0
                    }))), t.classList.remove("minified")
                }
                hideDisabledControls() {
                    this.getControls().has("expand") || (this.currentRoot.querySelector("#expand-button").style.display = "none")
                }
                getControls() {
                    const t = this.dataset.controls || "expand";
                    return "none" === t ? new Set : new Set(t.trim().split(/\s+/))
                }
            }
        },
        2525: (t, e, o) => {
            var i = o(628),
                n = o(7623),
                r = o(3687);
            o(544), o(1730), o(9666);
            const a = document.createElement("template");
            a.innerHTML = `<style>${n.Z.toString()}</style>${r.Z}`;
            const s = ["Preparing virtual try-on...", "Loading shoes...", "Adding last strokes..."];
            class l extends HTMLElement {
                static get observedAttributes() {
                    return ["data-simple-spinner", "data-with-vyking", "data-with-art-labs"]
                }
                shadowRoot = this.attachShadow({
                    mode: "open"
                });
                loadingPhraseInterval;
                root;
                resizeObserver;
                constructor() {
                    super(), this.shadowRoot.appendChild(a.content.cloneNode(!0)), this.root = this.shadowRoot.getElementById("root"), this.resizeObserver = new ResizeObserver((([t]) => {
                        this.root.style.setProperty("--container-size", Math.min(t.contentRect.width, t.contentRect.height) + "px")
                    }))
                }
                updateSpinner(t) {
                    t ? this.root.querySelector("x-fibbl-spinner")?.replaceWith(document.createElement("x-fibbl-simple-spinner")) : this.root.querySelector("x-fibbl-simple-spinner")?.replaceWith(document.createElement("x-fibbl-spinner"))
                }
                attributeChangedCallback() {
                    this.update()
                }
                connectedCallback() {
                    this.resizeObserver.observe(this), this.update()
                }
                update() {
                    const t = this.root.querySelector(".loading-phrase");
                    this.dataset.noPhrase && (t.style.visibility = "hidden");
                    const e = this.root.querySelector("x-fibbl-powered-by");
                    if (e.dataset.withVyking = this.dataset.withVyking || "", e.dataset.withArtLabs = this.dataset.withArtLabs || "", this.dataset.withVyking) {
                        let e = 0;
                        t.innerText = s[e++], this.loadingPhraseInterval = setInterval((() => {
                            e < s.length ? t.innerText = s[e++] : clearInterval(this.loadingPhraseInterval)
                        }), 2e3)
                    } else t.innerText = "Loading awesome content...", clearInterval(this.loadingPhraseInterval);
                    this.updateSpinner("true" === this.dataset.simpleSpinner)
                }
                disconnectedCallback() {
                    clearInterval(this.loadingPhraseInterval), this.resizeObserver.disconnect()
                }
            }(0, i.MW)("x-fibbl-loading-cube", l)
        },
        1673: (t, e, o) => {
            o.d(e, {
                Z: () => l
            });
            var i = o(628),
                n = o(652),
                r = o(7837);
            const a = (0, i.lv)(`<style>${r.Z.toString()}${n.Z.toString()}</style>`),
                s = (0, i.lv)(`<style>${n.Z.toString()}</style>`);
            class l extends HTMLElement {
                globalStyleTag;
                constructor(t = !1) {
                    super(), this.attachShadow({
                        mode: "open"
                    }), this.globalStyleTag = (t ? s : a).cloneNode(!0)
                }
                connectedCallback() {
                    this.classList.add("x-fibbl-modal-window"), document.head.append(this.globalStyleTag)
                }
                disconnectedCallback() {
                    document.head.removeChild(this.globalStyleTag)
                }
            }(0, i.MW)("x-fibbl-modal-window", l)
        },
        544: (t, e, o) => {
            var i = o(7875),
                n = o(3588),
                r = o(5701),
                a = o(2195),
                s = o(4044),
                l = o(628);
            (0, l.vF)("x-fibbl-logo", r.Z, l.v$), (0, l.vF)("x-fibbl-and", a.Z, l.v$), (0, l.vF)("x-fibbl-powered-by-phrase", s.Z, l.v$), (0, l.vF)("x-fibbl-powered-by", i.Z, n.Z)
        },
        608: (t, e, o) => {
            o.d(e, {
                Z: () => a
            });
            var i = o(4427),
                n = o(2258),
                r = o(9200);
            class a extends HTMLElement {
                #t = null;
                #e = !1;
                #o = !1;
                #i = !1;
                #n = new IntersectionObserver((([t]) => {
                    this.#o = t.isIntersecting, this.sendDisplayEventIfRequired()
                }), {
                    root: null,
                    rootMargin: "0px",
                    threshold: 0
                });
                root;
                _noAnalytics;
                sendDisplayEventIfRequired() {
                    !this.#i && this.#o && this.#e && (this.sendAnalyticsAndStatistics("fibbl_display"), this.#i = !0, this.removeIntersectionObserver())
                }
                removeIntersectionObserver() {
                    this.#n?.disconnect(), this.#n = null
                }
                sendAnalyticsAndStatistics(t, e) {
                    this.sendAnalytics(t, e), this.sendStatistics(t, e)
                }
                sendAnalytics(t, e) {
                    if (this._noAnalytics || this.dataset._noAnalytics) return;
                    const o = e ? [e] : (0, i.X5)(this);
                    for (const e of o)(0, n._)(t, {
                        feature: e,
                        productId: this.dataset.productId
                    }, this.product)
                }
                sendStatistics(t, e) {
                    if (this._noAnalytics || this.dataset._noAnalytics) return;
                    const o = e ? [e] : (0, i.X5)(this);
                    (0, r.L1)(t, this.dataset.productId, {
                        elementName: this.tagName.toLowerCase(),
                        features: o
                    })
                }
                get product() {
                    if (!this.#t) throw new Error("A product has not been loaded yet");
                    return this.#t
                }
                setProduct(t) {
                    this.#t = t
                }
                async getProduct(t) {
                    return this.#t || (this.#t = await (0, i.PD)(t)), this.#t
                }
                async connectedCallback() {
                    if (this.#n?.observe(this), !this.#e) try {
                        await this.init(), (0, i.G4)(this.root), this._noAnalytics || this.dataset._noAnalytics ? this.removeIntersectionObserver() : queueMicrotask((() => this.sendDisplayEventIfRequired()))
                    } catch (t) {
                        this.handleError(t, "Caught in base class", !0)
                    } finally {
                        this.#e = !0
                    }
                }
                disconnectedCallback() {
                    this.#n?.disconnect()
                }
                handleError(t, e = "***", o = !1) {
                    t.noError || (console.error(t), (0, i.H)(this.tagName.toLowerCase(), e, t)), o && this.hide()
                }
                init() {
                    throw new Error("Fibbl: all product elements must implement init() method")
                }
                hide() {
                    this.dataset.fibblComment = "Hidden, because the product cannot be shown", this.style.display = "none", this.removeIntersectionObserver(), this.#o = !1
                }
                showRoot() {
                    this.root && (this.root.style.opacity = "")
                }
            }
        },
        2149: (t, e, o) => {
            o.d(e, {
                Z: () => a
            });
            var i = o(5741),
                n = o(726);
            const r = document.createElement("template");
            r.innerHTML = `<style>${n.Z}</style>${i.Z}`;
            const a = class extends HTMLElement {
                root;
                wrapper;
                resizeObserver;
                firstIterationPromise;
                constructor() {
                    super(), this.attachShadow({
                        mode: "open"
                    }), this.shadowRoot.append(r.content.cloneNode(!0)), this.root = this.shadowRoot.querySelector(".root"), this.wrapper = this.root.querySelector(".wrapper"), this.resizeObserver = new ResizeObserver((([t]) => {
                        this.root.style.setProperty("--root-size", Math.min(t.contentRect.width, t.contentRect.height) + "px")
                    }))
                }
                waitForAnimationIteration() {
                    return this.firstIterationPromise
                }
                connectedCallback() {
                    this.firstIterationPromise = new Promise((t => {
                        this.wrapper.addEventListener("animationend", (() => {
                            this.wrapper.style.animationIterationCount = "infinite", t()
                        }), {
                            once: !0
                        })
                    })), this.resizeObserver.observe(this)
                }
                disconnectedCallback() {
                    this.resizeObserver.disconnect(), this.wrapper.style.animationIterationCount = ""
                }
            }
        },
        5125: (t, e, o) => {
            o.d(e, {
                Z: () => r
            });
            var i = o(20);
            const n = document.createElement("template");
            n.innerHTML = i.Z;
            const r = class extends HTMLElement {
                #r = null;
                #a = 2e3;
                #s = 0;
                #l = !1;
                iterationPromise;
                iterationPromiseResolve;
                constructor() {
                    super(), this.attachShadow({
                        mode: "open"
                    }), this.shadowRoot.append(n.content.cloneNode(!0)), this.iterationPromise = new Promise((t => this.iterationPromiseResolve = t))
                }
                waitForAnimationIteration() {
                    return this.iterationPromise
                }
                async connectedCallback() {
                    if (this.#l = !1, this.dataset.static) return;
                    if (await new Promise((t => setTimeout(t, 100))), this.#l) return;
                    setTimeout(this.iterationPromiseResolve, this.#a);
                    const t = this.shadowRoot.querySelectorAll("svg > path"),
                        e = t.length,
                        o = this.#a,
                        i = this.#s,
                        n = o + i,
                        r = o / e;
                    let a = 0,
                        s = 0;
                    const l = e => {
                        this.#r = requestAnimationFrame(l);
                        const i = (e - a) % n;
                        if (i > o) return;
                        const d = Math.floor(i / r);
                        d !== s && (t[s].style.display = "none", s = d, t[s].style.display = "block")
                    };
                    this.#r = requestAnimationFrame((t => {
                        a = t, l(t)
                    }))
                }
                disconnectedCallback() {
                    this.#l = !0, this.#r && (cancelAnimationFrame(this.#r), this.#r = null)
                }
            }
        },
        9666: (t, e, o) => {
            var i = o(4427),
                n = o(7229);
            (0, i.vF)("x-fibbl-simple-spinner", n.Z)
        },
        1730: (t, e, o) => {
            var i = o(5125),
                n = o(2149),
                r = o(4427);
            (0, r.MW)("x-fibbl-spinner", (0, r.gO)() || r.s$ ? i.Z : n.Z)
        },
        8245: (t, e, o) => {
            o.d(e, {
                Z: () => f
            });
            var i = o(5058),
                n = o(9059),
                r = o(648),
                a = o(1444),
                s = o(7577),
                l = o(1797),
                d = o(429),
                c = o(9710),
                h = o(9667),
                p = o(9778),
                u = o(1247),
                m = o(5545);
            const C = {
                    default: i.Z,
                    en: i.Z,
                    ru: n.Z,
                    lv: r.Z,
                    et: a.Z,
                    fi: s.Z,
                    lt: l.Z,
                    sv: d.Z,
                    da: c.Z,
                    de: h.Z,
                    nl: p.Z,
                    fr: u.Z
                },
                b = function(t) {
                    const e = t.toLowerCase();
                    return "default" === e || C[e] ? e : e.substring(0, 2)
                }(m.Z.locale),
                f = (t, e = b) => (C[e] || i.Z)[t] || i.Z[t]
        },
        2258: (t, e, o) => {
            o.d(e, {
                _: () => a
            });
            var i = o(5545),
                n = o(3575);
            const r = function() {
                if (i.Z.analyticsEventHandler) {
                    const t = window[i.Z.analyticsEventHandler];
                    return t || console.warn(`Fibbl: Cannot send analytics, because there is no global function with the name "${i.Z.analyticsEventHandler}"`), t
                }
                const t = function() {
                    if ("google" !== i.Z.analyticsType) return null;
                    if (i.Z.analyticsId) {
                        if (window.gtag) return window.gtag;
                        window.dataLayer = window.dataLayer || [];
                        const t = window.gtag = function() {
                            dataLayer.push(arguments), t.comment = "Created by Fibbl"
                        };
                        return t("js", new Date), t("config", i.Z.analyticsId), t
                    }
                    return window.dataLayer ? null : void 0
                }();
                if (t) return "google" !== i.Z.analyticsType || t || console.warn("Fibbl: Google Analytics will not work. Add the analytics id."), (e, o) => t("event", e, o)
            }();
            async function a(t, e, o) {
                try {
                    if (!r || n.$P) return;
                    const i = await o.getProductInfo(),
                        a = {
                            ...i?.analyticsProductId ? {
                                analyticsProductId: i.analyticsProductId
                            } : null,
                            ...e
                        };
                    r(t, a)
                } catch (t) {
                    console.error("Fibbl: cannot send analytics", t)
                }
            }
        },
        3575: (t, e, o) => {
            o.d(e, {
                $P: () => u,
                AJ: () => l,
                Jy: () => d,
                UI: () => a,
                YZ: () => m,
                _t: () => C,
                cI: () => n,
                ib: () => h,
                lt: () => s,
                ny: () => c,
                o4: () => p,
                uE: () => b
            }), o(9999);
            const i = {
                    scriptBaseUrl: "https://cdn.fibbl.com/",
                    imageBaseUrl: "https://i.cdn.fibblar.com/",
                    modelBaseUrl: "https://m.cdn.fibblar.com/",
                    apiBaseUrl: "https://api.fibbl.com/",
                    productBaseUrl: "https://42nsz8ox8i.execute-api.eu-north-1.amazonaws.com/prod",
                    arBaseUrl: "https://g3b6mimyftsy4qotrynvanrata0wzyzx.lambda-url.eu-north-1.on.aws/"
                },
                n = i.modelBaseUrl,
                r = i.scriptBaseUrl,
                a = new URL(r + "vto.html", location.origin).toString(),
                s = new URL(r + "ar.html", location.origin).toString(),
                {
                    imageBaseUrl: l,
                    modelBaseUrl: d,
                    apiBaseUrl: c,
                    productBaseUrl: h,
                    arBaseUrl: p
                } = i,
                u = "true" === new URLSearchParams(location.search).get("x-fibbl-iframe"),
                m = "4",
                C = "1",
                b = "3"
        },
        6673: (t, e, o) => {
            o.d(e, {
                $l: () => f,
                DO: () => l,
                Fi: () => d,
                P0: () => g,
                _J: () => c,
                gO: () => s,
                gt: () => C,
                ic: () => r,
                s$: () => b,
                wY: () => m
            });
            var i = o(3575),
                n = o(5545);
            const r = () => {
                let t = !1;
                var e;
                return e = navigator.userAgent || navigator.vendor || window.opera, (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4))) && (t = !0), t
            };
            let a;

            function s() {
                return void 0 === a && (a = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document || !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent)), a
            }
            const l = (t, e, o, r) => {
                const a = new URL("ar" === e ? i.lt : i.UI);
                return a.searchParams.set("product-id", t), o && a.searchParams.set("company-product-id", o), r && a.searchParams.set("company-id", r), a.searchParams.set("back-to", location.href), "google" === n.Z.analyticsType && n.Z.analyticsId && (a.searchParams.set("analytics-type", n.Z.analyticsType), a.searchParams.set("analytics-id", n.Z.analyticsId)), "default" !== n.Z.locale && a.searchParams.set("locale", n.Z.locale), a.toString()
            };

            function d() {
                let t;
                const e = document.createElement("canvas");
                if (e) {
                    const o = e.getContext("webgl") || e.getContext("experimental-webgl");
                    if (o) {
                        const e = o.getExtension("WEBGL_debug_renderer_info");
                        e && (t = o.getParameter(e.UNMASKED_RENDERER_WEBGL))
                    }
                }
                if (window.screen.height / window.screen.width == 736 / 414 && 3 === window.devicePixelRatio) switch (t) {
                    default:
                        return "iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus";
                    case "Apple A8 GPU":
                        return "iPhone 6 Plus";
                    case "Apple A9 GPU":
                        return "iPhone 6s Plus";
                    case "Apple A10 GPU":
                        return "iPhone 7 Plus";
                    case "Apple A11 GPU":
                        return "iPhone 8 Plus"
                } else if (window.screen.height / window.screen.width == 667 / 375 && 3 === window.devicePixelRatio) switch (t) {
                    default:
                        return "iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus (display zoom)";
                    case "Apple A8 GPU":
                        return "iPhone 6 Plus (display zoom)";
                    case "Apple A9 GPU":
                        return "iPhone 6s Plus (display zoom)";
                    case "Apple A10 GPU":
                        return "iPhone 7 Plus (display zoom)";
                    case "Apple A11 GPU":
                        return "iPhone 8 Plus (display zoom)"
                } else if (window.screen.height / window.screen.width == 667 / 375 && 2 === window.devicePixelRatio) switch (t) {
                    default:
                        return "iPhone 6, 6s, 7 or 8";
                    case "Apple A8 GPU":
                        return "iPhone 6";
                    case "Apple A9 GPU":
                        return "iPhone 6s";
                    case "Apple A10 GPU":
                        return "iPhone 7";
                    case "Apple A11 GPU":
                        return "iPhone 8"
                } else if (window.screen.height / window.screen.width == 1.775 && 2 === window.devicePixelRatio) switch (t) {
                    default:
                        return "iPhone 5, 5C, 5S, SE or 6, 6s, 7 and 8 (display zoom)";
                    case "PowerVR SGX 543":
                        return "iPhone 5 or 5c";
                    case "Apple A7 GPU":
                        return "iPhone 5s";
                    case "Apple A8 GPU":
                        return "iPhone 6 (display zoom)";
                    case "Apple A9 GPU":
                        return "iPhone SE or 6s (display zoom)";
                    case "Apple A10 GPU":
                        return "iPhone 7 (display zoom)";
                    case "Apple A11 GPU":
                        return "iPhone 8 (display zoom)"
                } else if (window.screen.height / window.screen.width == 1.5 && 2 === window.devicePixelRatio) switch (t) {
                    default:
                        return "iPhone 4 or 4s";
                    case "PowerVR SGX 535":
                        return "iPhone 4";
                    case "PowerVR SGX 543":
                        return "iPhone 4s"
                } else {
                    if (window.screen.height / window.screen.width != 1.5 || 1 !== window.devicePixelRatio) return !1;
                    switch (t) {
                        default:
                            return "iPhone 1, 3G or 3GS";
                        case "ALP0298C05":
                            return "iPhone 3GS";
                        case "S5L8900":
                            return "iPhone 1, 3G"
                    }
                }
            }
            const c = s() && !/Safari/i.test(navigator.userAgent),
                h = /firefox/i.test(navigator.userAgent),
                p = /FxiOS/i.test(navigator.userAgent),
                u = /OculusBrowser/.test(navigator.userAgent),
                m = /android/i.test(navigator.userAgent) && !h && !u,
                C = /CriOS\//.test(navigator.userAgent),
                b = "Apple Computer, Inc." === navigator.vendor && !C && !p,
                f = /\bOPT\//.test(navigator.userAgent),
                g = /Edg/.test(navigator.userAgent)
        },
        5545: (t, e, o) => {
            o.d(e, {
                Z: () => r
            });
            const i = {
                    api: "company",
                    token: "",
                    secret: "",
                    analyticsType: "",
                    analyticsId: "",
                    analyticsEventHandler: "",
                    readUrlParams: "",
                    locale: "default"
                },
                n = document.querySelector("script[data-fibbl-config]");
            if (n) {
                if (Object.assign(i, n.dataset), i.readUrlParams) {
                    const t = new URLSearchParams(location.search);
                    t.get("locale") && (i.locale = t.get("locale"))
                }
                "default" === i.locale || /^[a-z]{2}-[A-Z]{2}$/i.test(i.locale) || (console.warn(`Fibbl: incorrect locale code: "${i.locale}".\nIt should be a 5 characters IETF BCP 47 language tag with a language and a country,\ne.g. "sv-SE", "ru-RU", "fi-FI", "et-EE", "lv-LV", "lt-LT" etc.\nComponents will use the default locale as a fallback.`), i.locale = "default"), i.locale = i.locale.toLowerCase()
            }
            const r = i
        },
        9999: (t, e, o) => {
            o.d(e, {
                Z: () => r
            });
            const i = {
                    lastUpdatedAt: "2023-11-07T12:37:40.048Z",
                    comment: "Global Fibbl Object"
                },
                n = window.Fibbl;
            try {
                (() => {
                    if (n) {
                        if (n.comment !== i.comment) console.warn('Fibbl: a global "Fibbl" var already exists, it will be overwritten');
                        else {
                            if (n.lastUpdatedAt === i.lastUpdatedAt) return;
                            console.warn("Fibbl: this page contains different versions of Fibbl scripts, they may be incompatible")
                        }
                        i.previousGlobalObject = n
                    }
                    window.Fibbl = i
                })()
            } catch (t) {
                console.error("Fibbl global object error", t)
            }
            const r = i
        },
        4427: (t, e, o) => {
            o.d(e, {
                DO: () => n.DO,
                Fi: () => n.Fi,
                G4: () => i.G4,
                H: () => i.H,
                MW: () => i.MW,
                P0: () => n.P0,
                PD: () => i.PD,
                R1: () => i.R1,
                X5: () => i.X5,
                _J: () => n._J,
                eL: () => i.eL,
                gO: () => n.gO,
                gt: () => n.gt,
                ic: () => n.ic,
                lv: () => i.lv,
                s$: () => n.s$,
                v$: () => i.v$,
                vF: () => i.vF
            });
            var i = o(628),
                n = o(6673)
        },
        3957: (t, e, o) => {
            o.d(e, {
                r: () => c
            });
            var i = o(3575),
                n = o(5545);
            const r = `${i.ny}models/raw/v1/`,
                a = `${i.ny}models/v1/`,
                s = {};
            n.Z.token && (s.token = n.Z.token), n.Z.secret && (s.secret = n.Z.secret);
            const l = {
                    method: "get",
                    ...Object.keys(s).length ? {
                        headers: s
                    } : null
                },
                d = "generic" === n.Z.api ? r : a,
                c = (t, e) => {
                    let o = (t.startsWith("@demo-") ? r : d) + t;
                    if (e && "generic" === n.Z.api) {
                        const t = new URL(o);
                        t.searchParams.set("company-id", e), o = t.toString()
                    }
                    return fetch(o, l)
                }
        },
        9200: (t, e, o) => {
            o.d(e, {
                L1: () => a
            });
            var i = o(3575);
            const n = "fibbl_cookie_id",
                r = function() {
                    let t;
                    try {
                        t = localStorage.getItem(n), t || (t = crypto.randomUUID ? crypto.randomUUID() : ("x-" + Date.now().toString(36) + "-" + Math.floor(1e3 * performance.now()).toString(36) + "-" + Array.prototype.map.call(crypto.getRandomValues(new Uint32Array(5)), (t => t.toString(36))).join("")).substring(0, 36).padEnd(36, "0"), localStorage.setItem(n, t))
                    } catch (t) {
                        return !1
                    }
                    return t
                }();

            function a(t, e, o) {
                if (!r || i.$P) return;
                const n = (a = location.href, /^https?:\/\/(localhost|\d+\.\d+\.\d+\.\d+)/i.test(a));
                var a;
                try {
                    const i = JSON.stringify({
                        v: 0,
                        cookieId: r,
                        eventType: t,
                        productId: e,
                        url: location.href,
                        userAgent: navigator.userAgent,
                        platform: navigator.platform,
                        ...o
                    });
                    if (n) return;
                    navigator.sendBeacon("https://zsxmalaze0.execute-api.eu-north-1.amazonaws.com/dev/v1/events", i)
                } catch (t) {
                    n && console.error("Cannot send statistics", t)
                }
            }
        },
        628: (t, e, o) => {
            o.d(e, {
                G4: () => k,
                H: () => g,
                MW: () => c,
                Mn: () => w,
                PD: () => u,
                R1: () => C,
                X5: () => y,
                eL: () => b,
                j$: () => x,
                lv: () => f,
                v$: () => M,
                vF: () => z
            });
            var i = o(3957),
                n = o(8245),
                r = o(9200),
                a = o(6673),
                s = o(2258),
                l = o(3575),
                d = o(5545);
            const c = (t, e) => {
                customElements.get(t) || customElements.define(t, e)
            };
            class h extends Error {
                noError = !0
            }
            const p = window.fibbl__RequestCache = window.fibbl__RequestCache || {},
                u = (t, e, o) => (p[t] || (p[t] = (async () => {
                    const i = await m(t, e);
                    i.types || (i.types = {}), i.company || (i.company = o?.companyId || void 0);
                    const n = o?.companyId || i.company,
                        a = async function(t, e) {
                            try {
                                if (!t || !e || "default" === d.Z.locale) return;
                                const o = new URL(l.ib + "/product-info");
                                o.searchParams.append("product-id", e), o.searchParams.append("company-id", t), o.searchParams.append("locale", d.Z.locale);
                                const i = await fetch(o.toString());
                                if (!i.ok) return;
                                return await i.json()
                            } catch (t) {
                                console.error(t)
                            }
                        }(n, o?.productId || t).then((t => {
                            if (t) return {
                                ...t,
                                companyId: n
                            }
                        }));
                    return i.getProductInfo = () => a, (0, s._)("fibbl_load", {
                        productId: t
                    }, i), (0, r.L1)("fibbl_load", t), i
                })()), p[t]),
                m = async (t, e) => {
                    let o;
                    try {
                        o = await (0, i.r)(t, e)
                    } catch (e) {
                        throw new Error(`Fibbl: there was an error fetching the product ${t}: ${e}`)
                    }
                    if (!o.ok) {
                        let e = "";
                        try {
                            e = await o.text()
                        } finally {}
                        if (404 === o.status) throw new h(e);
                        throw new Error(`Fibbl: the product ${t} request failed with status code ${o.status}. ${502===o.status?"Check if the product exists on Fibbl databases.":""} ${e?`\n\nResponse text: \n\n ${e} \n`:""}`)
                    }
                    try {
                        return await o.json()
                    } catch (t) {
                        throw new Error("Fibbl: cannot parse response as JSON. " + t)
                    }
                };

            function C(t) {
                if (!a.wY) return alert(_("browser_not_supported")), !1;
                const e = `intent://arvr.google.com/scene-viewer/1.0?mode=ar_preferred&file=${encodeURIComponent(l.o4+t)}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(location.toString())};end;`,
                    o = document.createElement("a");
                return o.setAttribute("href", e), o.click(), !0
            }

            function b(t, e) {
                if (a.$l) return alert(_("browser_not_supported")), !1;
                if (a._J) return alert("This in-app browser doesn't support Augmented Reality. Use a standalone browser (Safari is recommended)."), !1;
                const o = document.createElement("a");
                return o.setAttribute("rel", "ar"), o.appendChild(document.createElement("img")), o.setAttribute("href", t), async function(t, e, o) {
                    try {
                        const i = await o.getProductInfo();
                        if (!i) return;
                        t.addEventListener("message", (e => {
                            "_apple_ar_quicklook_button_tapped" === e.data && (location.href = i.link, t.remove())
                        }), {
                            once: !0
                        });
                        const n = "___x-fibbl-ar-link";
                        document.querySelector("." + n)?.remove(), t.style.display = "none", t.classList.add(n), document.documentElement.append(t);
                        const r = encodeURIComponent,
                            a = new URLSearchParams({
                                custom: l.ib + `/ios-banner/${r(i.companyId)}/${r(d.Z.locale)}/${r(i.productId)}`,
                                customHeight: "small"
                            });
                        t.setAttribute("href", e + "#" + a.toString())
                    } catch (t) {
                        console.error(t)
                    }
                }(o, t, e).then((() => o.click())), !0
            }

            function f(t) {
                const e = document.createElement("div");
                e.innerHTML = t;
                const o = e.children[0];
                return o.remove(), o
            }

            function g(t, e, o) {
                try {
                    const n = "https://zsxmalaze0.execute-api.eu-north-1.amazonaws.com/dev/v1/analytics";
                    if (i = location.href, /^https?:\/\/(localhost|\d+\.\d+\.\d+\.\d+)/i.test(i)) return;
                    const r = JSON.stringify({
                        date: new Date,
                        element: t,
                        location: location.href,
                        platform: navigator.platform,
                        deviceMemory: navigator.deviceMemory,
                        userAgent: navigator.userAgent,
                        errorComment: e,
                        errorMessage: o.message,
                        errorStack: o.stack
                    });
                    navigator.sendBeacon(n, r)
                } catch (o) {
                    console.error("Cannot send error", o)
                }
                var i
            }

            function v(t, e) {
                switch (t) {
                    case "fibbl-model-viewer":
                        return "3d";
                    case "fibbl-carousel":
                        return "images";
                    case "fibbl-qr-code":
                        return "ar" === e.type ? "ar" : "vto";
                    case "fibbl-video":
                        return "video";
                    default:
                        throw new Error("Unsupported element " + t)
                }
            }

            function y(t) {
                const e = t.tagName.toLowerCase();
                switch (e) {
                    case "fibbl-model-viewer":
                    case "fibbl-carousel":
                    case "fibbl-qr-code":
                    case "fibbl-video":
                        return [v(e, t.dataset)];
                    case "fibbl-bar":
                        return [...t.features.values()];
                    default:
                        throw new Error("Unsupported element")
                }
            }

            function w(t, e) {
                const o = document.createElement("template");
                return o.innerHTML = `${e?`<style>${e.toString()}</style>`:""}${t||""}`, o
            }

            function x(t, e) {
                const o = t.attachShadow({
                    mode: "open"
                });
                return o.appendChild(e.content.cloneNode(!0)), o
            }

            function _(t) {
                return t ? (0, n.Z)(t) : null
            }

            function k(t) {
                const e = t => {
                    const e = _(t.dataset.t);
                    e && (t.innerText = e)
                };
                t?.querySelectorAll("[data-t]").forEach(e), t?.dataset.t && e(t)
            }

            function z(t, e, o, i) {
                const n = document.createElement("template");
                n.innerHTML = `${o?`<style>${o.toString()}</style>`:""}${e}`, c(t, class extends HTMLElement {
                    constructor() {
                        super(), this.attachShadow({
                            mode: "open"
                        }), this.shadowRoot.append(n.content.cloneNode(!0))
                    }
                    connectedCallback() {
                        if (i)
                            for (const [t, e] of Object.entries(i)) this.setAttribute(t, e)
                    }
                })
            }
            const M = ":host {display: inline-block} svg {display: block}"
        },
        4955: (t, e, o) => {
            o.d({}, {}), o(2525);
            var i = o(5342),
                n = o(3575),
                r = o(628),
                a = o(6673),
                s = o(8649);
            o(1119), o(7390);
            var l = o(4427);
            (0, l.vF)("x-fibbl-icon-try", '<svg part="svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="1em" height="1em" fill="currentColor"> <path d="M163.73,151H106.27L81,176.27V219H189V176.27ZM171,201H99V183.73L113.73,169h42.54L171,183.73Z"/> <polygon points="141.65 120.96 128.42 120.96 116.61 109.16 103.89 121.88 120.97 138.96 149.1 138.96 169 119.07 169 90.93 149.1 71.04 124.34 71.04 124.34 89.04 141.65 89.04 151 98.39 151 111.61 141.65 120.96"/> <polygon points="40 109 100 109 109 100 109 40 91 40 91 78.27 36.36 23.64 23.64 36.36 78.27 91 40 91 40 109"/> </svg> ', l.v$), (0, l.vF)("x-fibbl-icon-ar", '<svg part="svg" width="1em" height="1em" viewBox="0 0 240 240" fill="currentColor" xmlns="http://www.w3.org/2000/svg"> <path d="M68.28 39.2 24 64.77v47.71h18V85.56L66.96 100l9.01-15.58-24.98-14.45 26.29-15.18-9-15.59zM110.54 156.12h18v-30.93l26.67-15.42-9.01-15.58-26.66 15.41-24.29-14.04-9.01 15.58 24.3 14.05v30.93zM128.54 204.41v-25.2h-18v25.2l-24.02-13.87-9 15.59 42.02 24.26 44.08-25.45-9-15.59-26.08 15.06zM197.09 164.84l-22.82 13.17 9 15.59 31.82-18.37V131h-18v33.84zM175.65 42l-9 15.59 21.44 12.38-22.84 13.21 9.01 15.58 22.83-13.2v26.92h18V64.77L175.65 42zM119.54 30.39l24.65 14.23 9-15.59-33.65-19.42-31.88 18.41 9 15.58 22.88-13.21zM42 136.65H24v38.58l31.81 18.37 9-15.59L42 164.84v-28.19z"/> </svg> ', l.v$), (0, l.vF)("x-fibbl-icon-sun", '<svg width="1em" height="1em" part="svg" viewBox="0 0 24 24" stroke="currentColor"> <g stroke="#000000" stroke-width="1.5" stroke-miterlimit="10"> <path d="M5 12H1M23 12h-4M7.05 7.05 4.222 4.222M19.778 19.778 16.95 16.95M7.05 16.95l-2.828 2.828M19.778 4.222 16.95 7.05" stroke-linecap="round"/> <path d="M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" fill="none"/> <path d="M12 19v4M12 1v4" stroke-linecap="round"/> </g> </svg> ', l.v$), (0, l.vF)("x-fibbl-icon-reset", '<svg width="1em" height="1em" viewBox="0 0 21 21" part="svg" stroke="currentColor"> <g fill="none" fill-rule="evenodd" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"/> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"/> </g> </svg> ', l.v$);
            const d = document.createElement("template");
            d.innerHTML = `<style>${i.Z.toString()}</style><div id="root" class="root" style="opacity:0"> <x-fibbl-loading-cube></x-fibbl-loading-cube> <div id="progress-bar"></div> <x-fibbl-expand-button id="expand-button"></x-fibbl-expand-button> <x-fibbl-close-button></x-fibbl-close-button> <div id="top-block"> <div id="light-controls"> <div id="minus-button" class="light-button" role="button" aria-label="Reduce light"> <span></span> </div> <x-fibbl-icon-reset style="display:none"></x-fibbl-icon-reset> <x-fibbl-icon-sun></x-fibbl-icon-sun> <div id="plus-button" class="light-button" role="button" aria-label="Add light"> <span></span> <span></span> </div> </div> <div id="hint" data-t="touch_and_drag"></div> </div> <div id="more" class="open"> <button class="action-button" id="vto-button"> <span class="inner-button-wrapper"> <x-fibbl-icon-try class="icon"></x-fibbl-icon-try> <span data-t="try_on_yourself"></span> </span> </button> <button class="action-button" id="ar-button"> <span class="inner-button-wrapper"> <x-fibbl-icon-ar class="icon"></x-fibbl-icon-ar> <span data-t="see_in_your_space"></span> </span> </button> <button id="more-button" role="button" aria-label="Show more"> <span id="horizontal"></span> <span id="vertical"></span> </button> </div> </div> `;
            class c extends s.Z {
                modelViewer;
                isDisposed = !1;
                root = this.currentRoot.querySelector("#root");
                moreBlock = this.root.querySelector("#more");
                #d = 0;
                lightControls = this.root.querySelector("#light-controls");
                minusLightButton = this.lightControls.querySelector("#minus-button");
                plusLightButton = this.lightControls.querySelector("#plus-button");
                sunIcon = this.lightControls.querySelector("x-fibbl-icon-sun");
                resetIcon = this.lightControls.querySelector("x-fibbl-icon-reset");
                constructor() {
                    super(d), this.currentRoot.querySelector("#expand-button").onclick = this.onExpand, this.currentRoot.querySelector("x-fibbl-close-button").onclick = this.onClose, this.minusLightButton.onclick = () => this.lightIntensity -= 10, this.plusLightButton.onclick = () => this.lightIntensity += 10, this.resetIcon.onclick = () => this.lightIntensity = 0
                }
                set lightIntensity(t) {
                    this.#d = Math.max(-100, Math.min(t, 100)), this.modelViewer && (this.modelViewer.dataset.lightIntensity = this.lightIntensity.toString()), this.minusLightButton.classList[-100 === this.#d ? "add" : "remove"]("disabled"), this.plusLightButton.classList[100 === this.#d ? "add" : "remove"]("disabled"), this.sunIcon.style.display = this.#d ? "none" : "", this.resetIcon.style.display = this.#d ? "" : "none"
                }
                get lightIntensity() {
                    return this.#d
                }
                onExpand = async () => {
                    this.modelViewer && (this.modelViewer.dataset.touchAction = "none"), await super.onExpand(this.root)
                };
                onClose = async () => {
                    this.modelViewer && (this.modelViewer.dataset.touchAction = ""), await super.onClose(this.root), this.lightIntensity = 0
                };
                dispose() {
                    this.modelViewer?.dispose(), this.isDisposed = !0
                }
                disconnectedCallback() {
                    super.disconnectedCallback(), "false" !== this.dataset.autoDisposal && this.dispose()
                }
                activateButton(t, e) {
                    const o = this.currentRoot.querySelector(`#${t}-button`);
                    e ? o.querySelector(".inner-button-wrapper").onclick = () => this.showQrCode(t) : o.remove()
                }
                async init() {
                    const t = this.dataset.productId;
                    if (!t) return this.hide();
                    this.hideDisabledControls();
                    const {
                        models: e,
                        types: o
                    } = await this.getProduct(t);
                    if (!e || !o?.d3) return this.hide();
                    const i = `${n.Jy}${e.fblSource}`;
                    this.configureModelViewer(i), this.dataset._noTextHint && this.root.querySelector("#hint")?.remove(), this.activateButton("vto", o.vto || o.browserVto), this.activateButton("ar", o.ar), this.showRoot(), this.setUseEventListeners()
                }
                setUseEventListeners() {
                    const t = ["pointerdown", "wheel"],
                        e = () => {
                            this.sendAnalyticsAndStatistics("fibbl_use"), t.forEach((t => this.removeEventListener(t, e)))
                        };
                    t.forEach((t => this.addEventListener(t, e)))
                }
                getHDRIFileName() {
                    switch (this.product.category) {
                        case "1":
                            return "HDRI_for_shoes.hdr";
                        case "4":
                            return "HDRI_for_glasses.hdr";
                        case "5":
                            return "HDRI_for_bags.hdr";
                        default:
                            return "HDRI_default.hdr"
                    }
                }
                configureModelViewer(t) {
                    if (this.isDisposed) return;
                    const e = this.modelViewer = document.createElement("x-fibbl-model-viewer");
                    e.dataset.modelUrl = t, e.dataset.hdriUrl = n.cI + this.getHDRIFileName(), e.dataset.autoActivation = "false", e.dataset.autoDisposal = "false", e.dataset.showLoadingProgress = "false", e.dataset.lightIntensity = this.lightIntensity.toString(), this.dataset.initialZoom && (e.dataset.initialZoom = this.dataset.initialZoom), (this.isExpanded || this.dataset._isExpanded) && (e.dataset.touchAction = "none"), this.product.category === n.YZ && (e.dataset.initialRotationX = "0"), this.product.category === n._t && this.product.shadowTexture && (e.dataset.shadowTextureUrl = `${n.Jy}${this.product.shadowTexture.source}`, e.dataset.shadowTextureSize = this.product.shadowTexture.size.toString(), e.dataset.shadowTextureVerticalPosition = this.product.shadowTexture.verticalPosition.toString()), this.product.renderConfig && e.setRenderConfig(this.product.renderConfig);
                    const o = this.root.querySelector("#progress-bar");
                    e.addEventListener("x-fibbl-progress", (({
                        detail: t
                    }) => {
                        o.style.setProperty("--progress", 100 * t + "%")
                    })), e.addEventListener("x-fibbl-loaded", (async () => {
                        o.style.opacity = "0", this.root.classList.add("loaded"), this.root.classList.add("shown"), e.activate(), this.dispatchEvent(new CustomEvent("x-fibbl-loaded"))
                    })), e.addEventListener("x-fibbl-error", (({
                        detail: t
                    }) => {
                        this.handleError(t.error, t.comment, t.isFatal)
                    })), e.addEventListener("x-fibbl-hint-animation-stop", (() => {
                        this.root.querySelector("#hint")?.remove()
                    }), {
                        once: !0
                    });
                    const i = () => {
                        (this.dataset._showMore || this.isExpanded) && this.moreBlock.classList.remove("open")
                    };
                    e.addEventListener("x-fibbl-user-interaction", i), this.currentRoot.querySelector("#more-button").onclick = () => {
                        this.moreBlock.classList.contains("open") ? e.removeEventListener("x-fibbl-user-interaction", i) : e.addEventListener("x-fibbl-user-interaction", i), this.moreBlock.classList.toggle("open")
                    }, this.appendModelViewer(e)
                }
                async appendModelViewer(t) {
                    a._J && "complete" !== document.readyState && (await new Promise((t => window.addEventListener("load", t))), await new Promise((t => setTimeout(t, 3e3)))), this.root.append(t)
                }
                showQrCode(t) {
                    const e = document.createElement("fibbl-qr-code");
                    if (e.setProduct(this.product), Object.assign(e.dataset, {
                            productId: this.dataset.productId,
                            type: t,
                            _noAnalytics: !0
                        }), (0, a.ic)()) return e.onClick();
                    const o = document.createElement("x-fibbl-closable-modal-window");
                    o.shadowRoot.append(e), document.body.append(o)
                }
            }(0, r.MW)("fibbl-model-viewer", c)
        },
        1119: (t, e, o) => {
            var i = o(4427),
                n = o(5794),
                r = o(3575),
                a = o(608),
                s = o(628),
                l = o(2592);
            const d = document.createElement("template");
            d.innerHTML = "<style>:host{display:block;width:100%;height:100%;box-sizing:border-box}canvas{display:block;object-fit:contain;width:100%!important;height:100%!important}</style> <canvas></canvas> ", (0, s.MW)("x-fibbl-qr-code", class extends HTMLElement {
                static get observedAttributes() {
                    return ["data-url", "data-foreground", "data-background"]
                }
                canvas;
                observer;
                constructor() {
                    super(), this.attachShadow({
                        mode: "open"
                    }), this.shadowRoot.append(d.content.cloneNode(!0)), this.canvas = this.shadowRoot.querySelector("canvas"), this.observer = new ResizeObserver((() => this.updateCanvas()))
                }
                connectedCallback() {
                    this.observer.observe(this.canvas), this.updateCanvas()
                }
                disconnectedCallback() {
                    this.observer.disconnect()
                }
                attributeChangedCallback() {
                    this.updateCanvas()
                }
                updateCanvas() {
                    this.dataset.url && l.toCanvas(this.canvas, this.dataset.url, {
                        color: {
                            dark: this.dataset.foreground || "#000000ff",
                            light: this.dataset.background || "#00000000"
                        },
                        errorCorrectionLevel: "M"
                    })
                }
            });
            var c = o(1673),
                h = (o(2525), o(3955)),
                p = o(9247);
            const u = document.createElement("template");
            u.innerHTML = `<style>${p.Z.toString()}</style><div id="root"> <div id="track"> <div id="thumb"></div> </div> </div> `;
            class m extends HTMLElement {
                shadowRoot = this.attachShadow({
                    mode: "open"
                });
                min = 0;
                max = 100;
                value = 0;
                track;
                thumb;
                root;
                constructor() {
                    super(), this.shadowRoot.appendChild(u.content.cloneNode(!0)), this.track = this.shadowRoot.querySelector("#track"), this.thumb = this.shadowRoot.querySelector("#thumb"), this.root = this.shadowRoot.querySelector("#root");
                    const t = t => {
                            const e = this.track.getBoundingClientRect(),
                                o = 100 - Math.round((t.clientY - e.top) / e.height * 100);
                            this.value = Math.max(this.min, Math.min(this.max, o)), this.thumb.style.bottom = this.value + "%", this.dispatchEvent(new CustomEvent("change", {
                                detail: {
                                    value: this.value
                                }
                            }))
                        },
                        e = ["pointerup", "pointercancel", "pointerleave"];
                    this.track.onpointerdown = o => {
                        const i = o.pointerId;
                        this.root.classList.add("active"), t(o);
                        const n = e => t(e),
                            r = t => {
                                t.pointerId === i && (this.root.classList.remove("active"), document.body.removeEventListener("pointermove", n), e.forEach((t => {
                                    document.body.removeEventListener(t, r)
                                })))
                            };
                        document.body.addEventListener("pointermove", n), e.forEach((t => {
                            document.body.addEventListener(t, r, {
                                once: !0
                            })
                        }))
                    }
                }
                connectedCallback() {
                    this.thumb.style.bottom = this.value + "%"
                }
                setValue(t) {
                    this.value = t, this.thumb.style.bottom = t + "%"
                }
            }(0, s.MW)("x-fibbl-slider", m), o(8369), (0, i.vF)("x-fibbl-sun-icon", '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em" viewBox="0 0 375 374.999991" preserveAspectRatio="xMidYMid meet"> <path d="M 187.46875 70.308594 C 122.871094 70.308594 70.308594 122.871094 70.308594 187.46875 C 70.308594 252.070312 122.871094 304.691406 187.46875 304.691406 C 252.070312 304.691406 304.691406 252.070312 304.691406 187.46875 C 304.691406 122.871094 252.070312 70.308594 187.46875 70.308594 Z M 187.46875 281.234375 C 135.777344 281.234375 93.703125 239.160156 93.703125 187.46875 C 93.703125 135.777344 135.777344 93.703125 187.46875 93.703125 C 239.160156 93.703125 281.234375 135.777344 281.234375 187.46875 C 281.234375 239.160156 239.160156 281.234375 187.46875 281.234375 Z M 187.46875 281.234375 " fill-rule="nonzero"/> <path d="M 187.46875 46.851562 C 193.921875 46.851562 199.199219 41.578125 199.199219 35.125 L 199.199219 11.726562 C 199.199219 5.273438 193.984375 0 187.46875 0 C 180.953125 0 175.742188 5.273438 175.742188 11.726562 L 175.742188 35.183594 C 175.742188 41.640625 181.015625 46.851562 187.46875 46.851562 Z M 187.46875 46.851562 " fill-rule="nonzero"/> <path d="M 101.148438 61.433594 C 103.320312 65.21875 107.230469 67.269531 111.328125 67.269531 C 113.3125 67.269531 115.359375 66.769531 117.160156 65.714844 C 122.746094 62.488281 124.667969 55.292969 121.441406 49.707031 L 109.714844 29.414062 C 106.488281 23.828125 99.289062 21.90625 93.703125 25.132812 C 88.117188 28.359375 86.195312 35.558594 89.421875 41.144531 Z M 101.148438 61.433594 " fill-rule="nonzero"/> <path d="M 61.433594 101.148438 L 41.144531 89.421875 C 35.558594 86.195312 28.359375 88.117188 25.132812 93.703125 C 21.90625 99.289062 23.828125 106.488281 29.414062 109.714844 L 49.707031 121.441406 C 51.566406 122.496094 53.554688 122.992188 55.539062 122.992188 C 59.574219 122.992188 63.542969 120.882812 65.714844 117.160156 C 68.945312 111.574219 67.019531 104.378906 61.433594 101.148438 Z M 61.433594 101.148438 " fill-rule="nonzero"/> <path d="M 46.851562 187.46875 C 46.851562 181.015625 41.578125 175.742188 35.125 175.742188 L 11.726562 175.742188 C 5.273438 175.742188 0 181.015625 0 187.46875 C 0 193.921875 5.273438 199.199219 11.726562 199.199219 L 35.183594 199.199219 C 41.640625 199.199219 46.851562 193.984375 46.851562 187.46875 Z M 46.851562 187.46875 " fill-rule="nonzero"/> <path d="M 49.707031 253.496094 L 29.414062 265.222656 C 23.828125 268.449219 21.90625 275.648438 25.132812 281.234375 C 27.304688 285.019531 31.214844 287.066406 35.308594 287.066406 C 37.296875 287.066406 39.34375 286.570312 41.144531 285.515625 L 61.433594 273.789062 C 67.019531 270.5625 68.945312 263.363281 65.714844 257.777344 C 62.488281 252.191406 55.292969 250.269531 49.707031 253.496094 Z M 49.707031 253.496094 " fill-rule="nonzero"/> <path d="M 117.160156 309.285156 C 111.574219 306.054688 104.378906 307.980469 101.148438 313.566406 L 89.484375 333.855469 C 86.257812 339.441406 88.179688 346.640625 93.765625 349.867188 C 95.628906 350.921875 97.613281 351.417969 99.597656 351.417969 C 103.632812 351.417969 107.605469 349.308594 109.777344 345.585938 L 121.503906 325.292969 C 124.730469 319.648438 122.808594 312.511719 117.160156 309.285156 Z M 117.160156 309.285156 " fill-rule="nonzero"/> <path d="M 187.46875 328.085938 C 181.015625 328.085938 175.742188 333.359375 175.742188 339.816406 L 175.742188 363.273438 C 175.742188 369.726562 181.015625 375 187.46875 375 C 193.921875 375 199.199219 369.726562 199.199219 363.273438 L 199.199219 339.816406 C 199.199219 333.359375 193.984375 328.085938 187.46875 328.085938 Z M 187.46875 328.085938 " fill-rule="nonzero"/> <path d="M 273.789062 313.566406 C 270.5625 307.980469 263.363281 306.054688 257.777344 309.285156 C 252.191406 312.511719 250.269531 319.707031 253.496094 325.292969 L 265.222656 345.585938 C 267.394531 349.371094 271.304688 351.417969 275.402344 351.417969 C 277.386719 351.417969 279.433594 350.921875 281.234375 349.867188 C 286.820312 346.640625 288.742188 339.441406 285.515625 333.855469 Z M 273.789062 313.566406 " fill-rule="nonzero"/> <path d="M 345.585938 265.222656 L 325.292969 253.496094 C 319.707031 250.269531 312.511719 252.191406 309.285156 257.777344 C 306.054688 263.363281 307.980469 270.5625 313.566406 273.789062 L 333.855469 285.515625 C 335.71875 286.570312 337.703125 287.066406 339.691406 287.066406 C 343.722656 287.066406 347.695312 284.957031 349.867188 281.234375 C 353.09375 275.648438 351.171875 268.449219 345.585938 265.222656 Z M 345.585938 265.222656 " fill-rule="nonzero"/> <path d="M 363.273438 175.742188 L 339.816406 175.742188 C 333.359375 175.742188 328.085938 181.015625 328.085938 187.46875 C 328.085938 193.921875 333.359375 199.199219 339.816406 199.199219 L 363.273438 199.199219 C 369.726562 199.199219 375 193.921875 375 187.46875 C 375 181.015625 369.726562 175.742188 363.273438 175.742188 Z M 363.273438 175.742188 " fill-rule="nonzero"/> <path d="M 319.398438 123.054688 C 321.382812 123.054688 323.433594 122.558594 325.230469 121.503906 L 345.523438 109.777344 C 351.109375 106.550781 353.03125 99.351562 349.804688 93.765625 C 346.578125 88.179688 339.378906 86.257812 333.796875 89.484375 L 313.566406 101.148438 C 307.980469 104.378906 306.054688 111.574219 309.285156 117.160156 C 311.457031 120.945312 315.363281 123.054688 319.398438 123.054688 Z M 319.398438 123.054688 " fill-rule="nonzero"/> <path d="M 257.777344 65.714844 C 259.640625 66.769531 261.625 67.269531 263.609375 67.269531 C 267.644531 67.269531 271.617188 65.15625 273.789062 61.433594 L 285.515625 41.144531 C 288.742188 35.558594 286.820312 28.359375 281.234375 25.132812 C 275.648438 21.90625 268.449219 23.828125 265.222656 29.414062 L 253.496094 49.707031 C 250.269531 55.292969 252.191406 62.488281 257.777344 65.714844 Z M 257.777344 65.714844 " fill-rule="nonzero"/> </svg> ', i.v$), (0, i.vF)("x-fibbl-swipe-icon", '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em" viewBox="0 0 375 374.999991" preserveAspectRatio="xMidYMid meet"> <path d="M 138.558594 200.890625 C 134.882812 218.910156 136.792969 236.71875 146.539062 250.144531 L 158.410156 266.46875 C 171.621094 284.632812 212.734375 300.390625 220.082031 303.429688 C 232.019531 308.304688 250.882812 314.878906 265.644531 319.328125 C 269.25 320.390625 272.992188 318.339844 274.054688 314.738281 C 275.113281 311.132812 273.0625 307.386719 269.460938 306.328125 C 257.804688 302.792969 235.269531 294.878906 225.097656 290.78125 C 218.03125 287.953125 179.882812 272.902344 169.429688 258.484375 L 157.5625 242.160156 C 150.355469 232.335938 148.941406 218.910156 151.910156 203.433594 C 152.402344 200.675781 153.535156 196.4375 154.804688 192.195312 L 179.320312 225.976562 C 181.578125 229.085938 185.820312 229.652344 188.785156 227.53125 C 191.894531 225.269531 192.953125 221.59375 190.339844 217.992188 L 98.644531 91.777344 C 94.265625 85.699219 95.605469 77.21875 101.609375 72.835938 C 107.6875 68.386719 116.164062 69.726562 120.613281 75.804688 L 188.363281 169.089844 C 190.550781 172.125 194.789062 172.832031 197.828125 170.644531 C 200.867188 168.453125 201.5 164.210938 199.3125 161.171875 L 179.390625 133.683594 C 175.011719 127.675781 176.351562 119.125 182.355469 114.742188 C 188.433594 110.363281 196.910156 111.707031 201.359375 117.78125 L 221.28125 145.203125 C 223.472656 148.242188 227.710938 148.875 230.75 146.6875 C 233.785156 144.496094 234.421875 140.253906 232.230469 137.214844 L 220.292969 120.75 C 215.914062 114.671875 217.253906 106.191406 223.261719 101.8125 C 229.335938 97.429688 237.8125 98.773438 242.261719 104.78125 L 262.183594 132.269531 C 264.375 135.308594 268.613281 135.945312 271.652344 133.753906 C 274.6875 131.5625 275.324219 127.324219 273.132812 124.285156 L 261.195312 107.816406 C 256.746094 101.742188 258.085938 93.261719 264.164062 88.878906 C 270.238281 84.425781 278.714844 85.769531 283.09375 91.847656 L 311 130.289062 C 337.136719 166.191406 340.035156 216.4375 360.804688 244.988281 C 363.066406 248.023438 367.304688 248.730469 370.269531 246.542969 C 373.308594 244.351562 374.015625 240.109375 371.824219 237.070312 C 353.882812 212.40625 348.230469 158.417969 322.019531 122.304688 L 294.117188 83.863281 C 285.285156 71.777344 268.332031 69.09375 256.179688 77.855469 C 251.660156 81.175781 248.480469 85.558594 246.714844 90.433594 C 237.460938 84.074219 224.886719 83.863281 215.277344 90.859375 C 210.828125 94.109375 207.578125 98.5625 205.8125 103.4375 C 196.554688 97.007812 183.980469 96.792969 174.445312 103.789062 C 170.417969 106.6875 167.453125 110.503906 165.542969 114.671875 L 131.5625 67.820312 C 122.734375 55.734375 105.777344 53.050781 93.628906 61.8125 C 81.546875 70.648438 78.863281 87.605469 87.695312 99.761719 L 145.128906 178.910156 C 142.089844 186.121094 139.898438 194.527344 138.558594 200.890625 Z M 138.558594 200.890625 " fill-rule="nonzero"/> <path d="M 57.457031 101.105469 C 60.144531 103.789062 64.382812 103.789062 67.066406 101.105469 C 69.679688 98.488281 69.679688 94.179688 67.066406 91.492188 L 39.9375 64.355469 C 37.253906 61.742188 33.015625 61.742188 30.332031 64.355469 L 3.203125 91.492188 C 0.589844 94.179688 0.589844 98.488281 3.203125 101.105469 C 5.886719 103.789062 10.125 103.789062 12.8125 101.105469 L 28.351562 85.558594 L 28.351562 204.847656 C 28.351562 208.59375 31.390625 211.628906 35.136719 211.628906 C 38.878906 211.628906 41.917969 208.59375 41.917969 204.847656 L 41.917969 85.488281 Z M 57.457031 101.105469 " fill-rule="nonzero"/> </svg> ', i.v$);
            class C {
                #c = "https://d1ux9mupljc68q.cloudfront.net";
                #h = this.#c + "/1/index.html";
                #p = !1;
                #u;
                #m;
                #C = new Promise((t => this.#m = t));
                modelUrl;
                container;
                configUrl;
                configKey;
                onReady;
                onError;
                frame;
                constructor({
                    container: t,
                    modelUrl: e,
                    configUrl: o,
                    configKey: i,
                    onReady: n,
                    onError: r
                }) {
                    this.modelUrl = e, this.container = t, this.configUrl = o, this.configKey = i, this.onReady = n, this.onError = r
                }
                waitUntilReady() {
                    return this.#C
                }
                async loadConfig() {
                    const t = await fetch(encodeURI(this.configUrl));
                    if (!t.ok) throw new Error(`Failed to load configuration from ${this.configUrl}. Status: ${t.status}`);
                    return await t.arrayBuffer()
                }
                messageEventHandler = t => {
                    if (this.frame.contentWindow !== t.source) return;
                    const e = t.data?.type;
                    switch (e) {
                        case "VYKING_SNEAKER_WINDOW_WAITING_FOR_CONFIG":
                            this.frame.contentWindow.postMessage({
                                type: "VYKING_SNEAKER_WINDOW_CONFIG",
                                config: this.#u,
                                key: this.configKey,
                                cameraWidth: window.innerWidth * window.devicePixelRatio,
                                cameraHeight: window.innerHeight * window.devicePixelRatio,
                                autoPlay: !0,
                                accessoryDescriptionUrl: this.modelUrl
                            }, this.#c);
                            break;
                        case "VYKING_SNEAKER_WINDOW_READY":
                            this.#p = !0, this.onReady?.(), this.#m();
                            break;
                        case "VYKING_SNEAKER_WINDOW_ERROR":
                            console.error("Vyking error", t.data?.requestType, t.data?.value), this.onError?.(t.data?.value)
                    }
                };
                createFrame() {
                    const t = document.createElement("iframe");
                    return t.allow = "camera", t.src = this.#h, t.classList.add("footwear-vto"), window.addEventListener("message", this.messageEventHandler), t
                }
                async start() {
                    this.#u = await this.loadConfig(), this.frame ??= this.createFrame(), this.container.append(this.frame)
                }
                stop() {
                    this.frame?.remove(), delete this.frame, this.#p = !1, window.removeEventListener("message", this.messageEventHandler)
                }
            }
            class b {
                canvas;
                deepAr;
                config;
                constructor(t) {
                    this.config = t
                }
                async start() {
                    this.canvas = document.createElement("canvas"), this.canvas.classList.add("footwear-vto"), this.config.container.append(this.canvas);
                    const {
                        initialize: t
                    } = await import("https://cdn.jsdelivr.net/npm/deepar@5/js/deepar.esm.js");
                    this.deepAr = await t({
                        licenseKey: "983fdab403d5d3356877674118fd61a890c730407a059ff58a1858a9a61efced93c497baa8792d28",
                        canvas: this.canvas,
                        effect: this.config.effectUrl,
                        additionalOptions: {
                            cameraConfig: {
                                disableDefaultCamera: !0
                            }
                        }
                    });
                    const e = document.createElement("video");
                    e.muted = !0, e.playsInline = !0, e.srcObject = this.config.camera.videoStream, await e.play(), this.canvas.width = e.videoWidth, this.canvas.height = e.videoHeight, this.deepAr.setVideoElement(e, "user" === this.config.camera.videoConstraints.facingMode)
                }
                async changeModel(t) {
                    await (this.deepAr?.switchEffect(t))
                }
                stop() {
                    this.canvas?.remove(), delete this.canvas, this.deepAr?.shutdown(), delete this.deepAr
                }
            }
            var f = o(9999);
            const g = "i3Ea3fYmZZPyurhDdj6vKKFbcy5DMfqa7Z4vrCgomW",
                v = "O0Dldf1x69jHQPF0WAMHPejtc1zFbDjAc8WMf9j2Tc",
                y = Object.freeze({
                    nubikk: "UjXkE1qov4HfktNgE32sGjuB5oqBZqia0r7W9AWa7R",
                    bjornborg: "wqYJZ2igXIVSzYjgqjxUs1XrJfDdF2QMTYxhQjduOd",
                    sportland: "ts1wZmZsS8A1rv1SIHIDjUFsZSpv0V5rK6Zw7gu8lC",
                    "elten-store": "sFGcd0xXFrznSj2v82E7yjZ3M5aLWTCm5ugxga3w5F",
                    vibae: "fosZJjRs97GmqfUKhY0ByJtBChS2SORZv7Jo0bYVUE",
                    gastonmille: "2h2RjvpjQz1xswLiSOn7rXFiMccg26zxyv3jZhTpDG",
                    skechers: "39EEkzV1ZrRYbrb9WynELqtX5hNKy9d5zHtwEzROkD",
                    lociwear: "a7gkqhz8C0QY7AiFptMRtgpJg0RFt8TbMPqzLAFvlx",
                    bute: "GZSI7EYhcHS7uc6cMJuHbwCo833vV9P6Vqxn1BRKSB",
                    polyversweden: "NY4EsvtuLDbg7YFdSIjBcvQByC8Rn3W0ne09peFZ4I",
                    joyashoes: "wzNoNAr2cjjwyF6BV7mNZGgqohdUjayuU9zM5wTpKf",
                    atoms: v,
                    _dev: g,
                    _prod: g
                });

            function w(t, e, o) {
                if ("134" === e) return "0PsAbnXCyGoPnoYdBun0S5csMc6ZsUOXQvvonstPwZ";
                if ("@demo-atoms" === o) return v;
                if (!t) return g;
                const i = y[t];
                if (!i) throw new Error("No token for the company");
                return i
            }
            let x = null;
            class _ {
                container;
                model;
                onError;
                #C;
                #b;
                #f = {};
                #g;
                constructor({
                    container: t,
                    model: e,
                    onError: o
                }) {
                    this.container = t, this.model = e, this.onError = o
                }
                #v(t, e) {
                    this.#g.addEventListener(t, e), this.#f[t] || (this.#f[t] = new Set), this.#f[t].add(e)
                }
                #y(t, e) {
                    if (e) this.#g.removeEventListener(t, e), this.#f[t]?.delete(e);
                    else if (this.#f[t]) {
                        for (const e of this.#f[t]) this.#g.removeEventListener(t, e);
                        delete this.#f[t]
                    }
                }
                #w() {
                    for (const [t, e] of Object.entries(this.#f))
                        for (const o of e) this.#g.removeEventListener(t, o);
                    this.#f = {}
                }
                async start(t) {
                    window.define?.amd && (x = window.define.amd, window.define.amd = null), await import("https://unpkg.com/meshkraft-vto@2.2.4/dist/index.min.js"), this.#g = window.meshkraftVTO, this.#g.init({
                        token: w(this.model.company, this.model.brand, this.model.key),
                        config: {
                            disableUI: !0
                        }
                    }), this.#b = f.Z.artLabsContainer || document.createElement("div"), f.Z.artLabsContainer = this.#b, this.#b.style.cssText = "width: 100%; height: 100%;", this.container.append(this.#b), this.#v("vto-error", (t => {
                        console.error("Fibbl VTO Error: ", t), this.onError(t.detail.message)
                    })), this.#x(), this.#g.startVTO(t, {
                        container: this.#b
                    })
                }
                #x() {
                    this.#y("load"), this.#C = new Promise((t => this.#v("load", t)))
                }
                changeModel(t) {
                    this.#x(), this.#g.changeProduct(t)
                }
                waitUntilReady() {
                    return this.#C
                }
                async stop() {
                    await this.#g.stopVTO(), this.#w(), this.#b?.remove(), this.#b = void 0, x && (window.define.amd = x, x = null)
                }
            }
            const k = document.createElement("template");
            k.innerHTML = `<style>${h.Z.toString()}</style><div id="root" class="root"> <div id="dark_layer"></div> <div id="content"> <div id="no-camera-message" class="error" style="display:none"> <h2 id="no-access" data-t="cannot_access_camera">Cannot access the camera to start the Virtual Try On</h2> <h2 id="denied" style="display:none" data-t="camera_access_denied"> The access to the camera is denied. Change your browser settings and reload the page. </h2> <p data-t="scan_qr_below">Scan the code below to try it on your phone</p> <x-fibbl-qr-code></x-fibbl-qr-code> <x-fibbl-powered-by></x-fibbl-powered-by> </div> <div id="unexpected-error" class="error" style="display:none"> <h2>Unexpected error</h2> <x-fibbl-powered-by></x-fibbl-powered-by> </div> <x-fibbl-close-button id="main-close-button"></x-fibbl-close-button> <x-fibbl-slider></x-fibbl-slider> <div id="tips"> <x-fibbl-close-button></x-fibbl-close-button> <div id="tips__content"> <div> <x-fibbl-sun-icon></x-fibbl-sun-icon> <span data-t="room_well_lit"></span> </div> <div> <x-fibbl-swipe-icon></x-fibbl-swipe-icon> <span data-t="swipe_to_move_glasses"></span> </div> </div> <x-fibbl-powered-by></x-fibbl-powered-by> </div> <div id="product-block"> <div id="product-switcher" style="display:none"></div> <div id="product-info" style="display:none"> <img alt="Product image" src="#"/> <div id="text"> <span id="product-title"></span> <span> <span id="sale-price"></span> <span id="product-price"></span> </span> </div> <a> <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" width="1em" stroke="currentColor"> <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"/> </svg> </a> </div> </div> <x-fibbl-spinner id="switching-spinner" style="display:none"></x-fibbl-spinner> <x-fibbl-loading-cube></x-fibbl-loading-cube> </div> </div> `;
            const z = Object.freeze({
                    facingMode: "user"
                }),
                M = Object.freeze({
                    facingMode: "environment"
                });

            function E(t) {
                if (t.category === r._t || t.category === r.uE) {
                    if (t.models.artLabsId) return "ArtLabs";
                    if (t.models.deepArSource) return "DeepAR";
                    if (t.models.vykingSource) return "Vyking"
                }
                return "glasses"
            }
            class L extends a.Z {
                adjustment = 0;
                camera;
                _noAnalytics = !0;
                modalWindow;
                slider;
                close;
                vto;
                outerExitHandler = null;
                tips;
                productBlock;
                constructor() {
                    super(), this.createModalWindow(), this.tips = this.root.querySelector("#tips"), this.tips.querySelector("x-fibbl-close-button").onclick = () => this.tips.remove(), this.productBlock = this.root.querySelector("#product-block")
                }
                createModalWindow() {
                    this.modalWindow = document.createElement("x-fibbl-modal-window"), this.modalWindow.shadowRoot.append(k.content.cloneNode(!0)), this.root = this.modalWindow.shadowRoot.getElementById("root"), this.slider = this.root.querySelector("x-fibbl-slider"), this.slider.addEventListener("change", (({
                        detail: t
                    }) => {
                        this.vto && this.setAdjustment(t.value)
                    })), this.close = this.root.querySelector("x-fibbl-close-button")
                }
                addGestureAdjustment(t) {
                    const e = {};
                    t.style.userSelect = "none", t.style.touchAction = "none", t.onpointerdown = o => {
                        e[o.pointerId] = {
                            adjustment: this.getAdjustment(),
                            y: o.clientY
                        }, t.onpointermove = o => {
                            const i = e[o.pointerId];
                            if (!i) return;
                            const n = Math.round((i.y - o.clientY) / (.5 * t.getBoundingClientRect().height) * 100);
                            this.setAdjustment(i.adjustment + n)
                        }
                    }, ["pointerup", "pointerleave", "pointercancel"].forEach((o => {
                        t.addEventListener(o, (t => {
                            delete e[t.pointerId]
                        }))
                    }))
                }
                setAdjustment(t) {
                    const e = Math.max(0, Math.min(100, t));
                    this.vto.setGlassesAdjustmentY(e / 100), this.adjustment = e, this.slider.setValue(e)
                }
                getAdjustment() {
                    return this.adjustment
                }
                syncAdjustment() {
                    this.setAdjustment(100 * this.vto.getGlassesAdjustmentY()), this.slider.setValue(this.getAdjustment())
                }
                hide() {
                    this.remove()
                }
                async init() {
                    const t = this.dataset.productId;
                    if (!t) return this.remove();
                    const {
                        models: e,
                        types: o,
                        renderConfig: i
                    } = await this.getProduct(t);
                    if (!o.browserVto || !e?.fblSource) return this.remove();
                    this.loadProductInfo();
                    try {
                        await this.render(`${r.Jy}${e.fblSource}`, i)
                    } catch (t) {
                        console.error(t), this.showUnexpectedError()
                    }
                }
                async showUnexpectedError() {
                    try {
                        await (this.vto?.stop())
                    } catch (t) {
                        console.error(t)
                    }
                    this.root.querySelector("#unexpected-error").style.display = ""
                }
                updateProductInfo(t) {
                    const e = this.root.querySelector("#product-info");
                    e.querySelector("#product-title").innerText = t.title, e.querySelector("img").src = t.imageLink;
                    const o = e.querySelector("a");
                    o.href = t.link, r.$P && (o.onclick = e => {
                        e.preventDefault(), window.parent.postMessage({
                            type: "x-fibbl-change-location",
                            payload: t.link
                        }, new URLSearchParams(location.search).get("parent-origin") || "")
                    }), e.querySelector("#product-price").innerText = t.price;
                    const i = e.querySelector("#sale-price");
                    t.salePrice ? (i.innerText = t.salePrice, e.classList.add("sale")) : e.classList.remove("sale"), e.style.display = ""
                }
                async loadProductInfo() {
                    try {
                        const t = await this.product.getProductInfo();
                        if (!t) return;
                        this.updateProductInfo(t);
                        const e = E(this.product);
                        "glasses" !== e && "ArtLabs" !== e && "DeepAR" !== e || this.loadAdditionalModels(t)
                    } catch (t) {
                        console.error(t)
                    }
                }
                filterAdditionalModels(t) {
                    const e = E(this.product),
                        o = "ArtLabs" === e ? "artLabsId" : "DeepAR" === e ? "deepArSource" : null;
                    return o ? t.filter((t => t.model.models[o])) : t
                }
                async loadAdditionalModels(t) {
                    try {
                        if (!t.catalogId || !t.groupLabel) return;
                        const e = new URL(r.ib + "/additional-models");
                        e.searchParams.set("company-id", t.companyId), e.searchParams.set("catalog-id", t.catalogId), e.searchParams.set("product-id", t.productId), e.searchParams.set("group-label", t.groupLabel);
                        let o = await fetch(e).then((t => t.json()));
                        if (o = this.filterAdditionalModels(o), !o.length) return;
                        const i = this.root.querySelector("#product-switcher");
                        i.style.display = "";
                        const n = (t, e, o) => {
                            const n = document.createElement("img");
                            n.src = e.imageLink, n.alt = "Product image", n.onclick = () => {
                                i.querySelectorAll(".selected").forEach((t => t.classList.remove("selected"))), n.classList.add("selected"), this.switchModel(t, e)
                            }, i.append(n), o && n.classList.add("selected")
                        };
                        n(this.product, t, !0);
                        for (const {
                                model: t,
                                productInfo: e
                            }
                            of o) n(t, e)
                    } catch (t) {
                        console.error(t)
                    }
                }
                async switchModel(t, e) {
                    const o = this.root.querySelector("#switching-spinner");
                    try {
                        this.productBlock.classList.remove("switching"), this.updateProductInfo(e), o.style.display = "", "glasses" === E(this.product) ? (await this.vto.start(`${r.Jy}${t.models.fblSource}`, t.renderConfig), await this.vto.waitUntilReady(), this.syncAdjustment()) : this.vto instanceof _ ? (await this.vto.changeModel(t.models.artLabsId), await this.vto.waitUntilReady()) : this.vto instanceof b && await this.vto.changeModel(r.Jy + t.models.deepArSource)
                    } finally {
                        o.style.display = "none"
                    }
                }
                async getCamera(t = z) {
                    try {
                        const e = await navigator.mediaDevices.getUserMedia({
                                video: t
                            }),
                            o = e.getTracks()[0].getSettings();
                        return {
                            width: o.width,
                            height: o.height,
                            videoStream: e,
                            videoConstraints: t
                        }
                    } catch (t) {
                        throw t
                    }
                }
                onExit() {
                    try {
                        if (this.outerExitHandler?.()) return
                    } catch (t) {
                        console.error(t)
                    }
                    this.vto?.stop(), delete this.vto, this.modalWindow.remove(), this.camera?.videoStream.getTracks().forEach((t => t.stop())), delete this.camera, this.remove()
                }
                onNoCamera(t = !1) {
                    this.root.querySelector("#no-camera-message").style.display = "", t && (this.root.querySelector("#no-access").style.display = "none", this.root.querySelector("#denied").style.display = ""), this.root.querySelector("x-fibbl-qr-code").dataset.url = (0, i.DO)(this.product.key, "vto", this.dataset.productId)
                }
                onResize = (t, e) => {
                    this.root.style.setProperty("--video-height", e + "px"), this.root.style.setProperty("--video-width", t + "px"), this.root.style.setProperty("--video-aspect-ratio", t + " / " + e), this.root.style.setProperty("--video-aspect-ratio-value", (t / e).toString())
                };
                async render(t, e) {
                    this.dataset._noCloseButton && this.root.querySelector("#main-close-button").remove();
                    const o = this.root.querySelector("#content");
                    (0, i.ic)() && (o.classList.add("mobile"), this.tips.remove());
                    const n = E(this.product);
                    if ("glasses" !== n && o.classList.add("third-party"), this.product.category === r._t) {
                        o.classList.add("mobile");
                        const t = this.root.querySelector("x-fibbl-loading-cube");
                        "Vyking" === n && (t.dataset.simpleSpinner = "true", t.dataset.withVyking = "true"), "ArtLabs" === n && (t.dataset.withArtLabs = "true")
                    }
                    document.body.append(this.modalWindow);
                    let a = !1;
                    this.root.querySelector("#dark_layer").onclick = () => {
                        a = !0, this.onExit()
                    }, this.close.onclick = () => {
                        a = !0, this.onExit()
                    };
                    let s = Date.now();
                    try {
                        "glasses" !== n && "DeepAR" !== n || (this.camera = await this.getCamera(this.product.category === r._t ? M : void 0), s = Date.now() - s, this.onResize(this.camera.width, this.camera.height))
                    } catch (t) {
                        console.error(t);
                        const e = "NotAllowedError" === t.name;
                        return e && Date.now() - s > 700 ? this.onExit() : this.onNoCamera(e)
                    }
                    await new Promise((t => setTimeout(t, 300)));
                    let l, d = !1;
                    if ("DeepAR" === n) {
                        if (this.vto = new b({
                                container: o,
                                camera: this.camera,
                                effectUrl: r.Jy + this.product.models.deepArSource
                            }), await this.vto.start(), a) return
                    } else if ("Vyking" === n) {
                        if (this.vto = new C({
                                container: o,
                                configKey: "com.fibbl",
                                configUrl: r.Jy + "vyking/vyking_config.bin?v=1",
                                modelUrl: r.Jy + this.product.models.vykingSource,
                                onError: t => {
                                    d = !0, clearTimeout(l), this.vto?.stop(), this.root.classList.add("ready", "error-root"), t?.includes?.("NotAllowedError") ? this.onNoCamera() : this.showUnexpectedError()
                                }
                            }), await this.vto.start(), a) return;
                        if (await this.vto.waitUntilReady(), a) return
                    } else if ("ArtLabs" === n) {
                        if (this.vto = new _({
                                container: o,
                                model: this.product,
                                onError: t => {
                                    d = !0, this.vto?.stop(), this.root.classList.add("ready", "error-root"), t.includes("Camera Error") ? this.onNoCamera() : this.showUnexpectedError()
                                }
                            }), await this.vto.start(this.product.models.artLabsId), a) return;
                        if (await this.vto.waitUntilReady(), a) return
                    } else {
                        const {
                            default: i
                        } = await import("https://d3rf4gp7bfp9l9.cloudfront.net/dist/glasses-vto.js");
                        if (a) return;
                        if (this.vto = new i({
                                container: o,
                                videoStream: this.camera.videoStream,
                                onResize: this.onResize
                            }), await this.vto.start(t, e), a) return;
                        if (await this.vto.waitUntilReady(), a) return;
                        this.syncAdjustment(), this.addGestureAdjustment(this.root.querySelector("x-fibbl-glasses-vto"))
                    }
                    this.root.classList.add("ready");
                    const c = () => this.dispatchEvent(new CustomEvent("x-fibbl-ready"));
                    d || ("Vyking" === n ? l = window.setTimeout(c, 1e3) : c())
                }
            }(0, i.MW)("x-fibbl-browser-vto", L);
            var S = o(998);
            o(1730);
            const P = document.createElement("template");
            P.innerHTML = `<style>${S.Z.toString()}</style><div id="root" class="root" style="opacity:0"> <x-fibbl-close-button></x-fibbl-close-button> <x-fibbl-spinner></x-fibbl-spinner> <slot class="slot">Loading...</slot> </div> `, (0, i.MW)("x-fibbl-ar-loading-indicator", class extends c.Z {
                root;
                removeSelf = () => this.remove();
                constructor() {
                    super(i.gt || i.P0), this.shadowRoot.append(P.content.cloneNode(!0)), this.root = this.shadowRoot.querySelector("#root"), this.root.querySelector("x-fibbl-close-button").onclick = this.removeSelf
                }
                async connectedCallback() {
                    super.connectedCallback(), document.addEventListener("visibilitychange", this.removeSelf, {
                        once: !0
                    }), this.dataset.delay && (this.root.style.transitionDelay = this.dataset.delay), setTimeout((() => this.root.style.opacity = ""), 0), (0, i.G4)(this)
                }
                disconnectedCallback() {
                    super.disconnectedCallback(), document.removeEventListener("visibilitychange", this.removeSelf)
                }
            });
            const R = i.gt && (0, i.gO)(),
                A = i.P0 && (0, i.gO)();

            function I(t = "vto") {
                const e = document.createElement("x-fibbl-ar-loading-indicator");
                e.dataset.delay = R || A ? "0ms" : "1000ms", e.dataset.t = "vto" === t ? "preparing_vto" : "preparing_ar", document.body.append(e)
            }
            var Z = o(7390),
                T = o(7670);
            const V = (0, s.Mn)('<iframe allow="camera"></iframe>', T.Z);
            class U extends Z.Z {
                iframe;
                constructor() {
                    super(), this.shadowRoot.append(V.content.cloneNode(!0)), this.iframe = this.shadowRoot.querySelector("iframe")
                }
                windowMessageHandler = t => {
                    switch (t.data.type) {
                        case "x-fibbl-change-close-button-color":
                            return this.shadowRoot.querySelector("x-fibbl-close-button").classList.add("white");
                        case "x-fibbl-use-message":
                            return this.dispatchEvent(new CustomEvent("x-fibbl-use"));
                        case "x-fibbl-change-location":
                            return void(location.href = t.data.payload)
                    }
                };
                connectedCallback() {
                    super.connectedCallback(), this.iframe.src = this.dataset.src, window.addEventListener("message", this.windowMessageHandler)
                }
                disconnectedCallback() {
                    super.disconnectedCallback(), window.removeEventListener("message", this.windowMessageHandler)
                }
            }(0, s.MW)("x-fibbl-iframe-window", U);
            const q = document.createElement("template");
            q.innerHTML = `<style>${n.Z.toString()}</style><div class="root" id="root" style="opacity:0"> <div class="background"></div> <button id="see-button"></button> <div id="overlay"> <h3 data-t="scan_qr">Scan the QR code</h3> <div class="message"></div> <x-fibbl-qr-code data-foreground="#ffffffff"></x-fibbl-qr-code> <div id="bvto" style="display:none"> <p data-t="if_have_camera">or if you have a camera on your computer</p> <button data-t="try_on_now">Try on now</button> </div> </div> </div> `;
            class B extends a.Z {
                shadowRoot = this.attachShadow({
                    mode: "open"
                });
                #_ = !1;
                resizeObserver;
                imageUrl;
                _autostart = !1;
                constructor() {
                    super(), this.shadowRoot.appendChild(q.content.cloneNode(!0)), this.root = this.shadowRoot.getElementById("root"), this.resizeObserver = new ResizeObserver((([t]) => {
                        this.updateSize()
                    })), (0, i.G4)(this.root)
                }
                get type() {
                    return this.dataset.type || "ar"
                }
                async connectedCallback() {
                    this.resizeObserver.observe(this), await super.connectedCallback()
                }
                disconnectedCallback() {
                    super.disconnectedCallback(), this.resizeObserver.disconnect()
                }
                checkSupport() {
                    return "ar" === this.type ? this.canUseAR() : this.canUseVTO() || this.canUseBVTO()
                }
                async init() {
                    const t = this.dataset.productId;
                    if (!t) return this.hide();
                    const {
                        gallery: e
                    } = await this.getProduct(t);
                    if (!this.checkSupport()) return console.warn(`Fibbl: Product ${this.dataset.productId} doesn't support "${this.dataset.type}" mode`), this.hide();
                    this.render(), this.showRoot(), e?.length && (this.imageUrl = r.AJ + e[0], this.shadowRoot.querySelector(".background").style.backgroundImage = `url("${this.imageUrl}")`, this._autostart && (0, i.ic)() && ("vto" === this.type || (0, i.gO)()) && this.onClick())
                }
                canUseAR() {
                    return this.product.types.ar && this.product.models.fblSource
                }
                canUseVTO() {
                    return this.product.types.vto && this.product.models.reality
                }
                canUseBVTO() {
                    return this.product.types.browserVto && this.product.models.fblSource
                }
                updateSize() {
                    const t = Math.min(this.root.offsetWidth, this.root.offsetHeight);
                    this.root.style.setProperty("--size", t + "px")
                }
                getUrl() {
                    return (0, i.DO)(this.product.key, this.type, this.dataset.productId, this.product.company)
                }
                openBrowserVto = () => {
                    switch (E(this.product)) {
                        case "DeepAR": {
                            const t = new URL(this.getUrl());
                            t.searchParams.set("x-fibbl-close-on-close", "true"), window.open(t.toString(), "_blank");
                            break
                        }
                        case "Vyking": {
                            const t = document.createElement("x-fibbl-iframe-window");
                            t.addEventListener("x-fibbl-use", (() => this.sendUseEvent()), {
                                once: !0
                            });
                            const e = new URL(this.getUrl());
                            e.searchParams.set("x-fibbl-iframe", "true"), e.searchParams.set("parent-origin", location.origin), t.dataset.src = e.toString(), document.body.append(t);
                            break
                        }
                        case "ArtLabs":
                        case "glasses": {
                            const t = document.createElement("x-fibbl-browser-vto");
                            t.addEventListener("x-fibbl-ready", (() => this.sendUseEvent()), {
                                once: !0
                            }), t.dataset.productId = this.dataset.productId, t.setProduct(this.product), document.body.append(t);
                            break
                        }
                    }
                    this.dispatchEvent(new CustomEvent("x-fibbl-close", {
                        bubbles: !0
                    }))
                };
                onClick = () => {
                    if ("ar" === this.dataset.type) return this.startAR();
                    const {
                        vto: t,
                        browserVto: e
                    } = this.product.types, o = t && (0, i.gO)() && !(0, i.Fi)() && !i._J;
                    if (!o && !e) return alert("Virtual Try On currently supports only iPhone X or newer");
                    o ? this.startVTO() : this.openBrowserVto()
                };
                sendUseEvent() {
                    this.#_ || (this.sendAnalyticsAndStatistics("fibbl_use"), this.#_ = !0, this.dispatchEvent(new CustomEvent("x-fibbl-use")))
                }
                startAR() {
                    ((0, i.gO)() ? (0, i.eL)(r.Jy + this.product.models.iosSource, this.product) : (0, i.R1)(this.product.key)) && (I(this.dataset.type), this.sendUseEvent())
                }
                startVTO() {
                    (0, i.eL)(r.Jy + this.product.models.reality, this.product) && (I(this.dataset.type), this.sendUseEvent())
                }
                render() {
                    const {
                        type: t
                    } = this.dataset, {
                        browserVto: e
                    } = this.product.types;
                    this.shadowRoot.querySelector(".message").dataset.t = "vto" === this.type ? "point_device_vto" : "point_device_ar", this.root.querySelector("x-fibbl-qr-code").dataset.url = this.getUrl(), this.shadowRoot.querySelector("#see-button").dataset.t = "vto" === this.type ? "try_on" : "see_in_ar", "vto" === t && e && this.product.category === r.YZ && (this.root.querySelector("#bvto").style.display = ""), this.root.querySelector("#bvto button").onclick = this.openBrowserVto, (0, i.ic)() && (this.root.classList.add("mobile"), this.addEventListener("click", this.onClick)), this.updateSize()
                }
            }(0, i.MW)("fibbl-qr-code", B)
        },
        9710: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = {
                scan_qr: "Scan QR-koden",
                try_on_now: "PrÃ¸v nu",
                try_on: "PrÃ¸v",
                see_in_ar: "Vis i dine omgivelser",
                back_to_store: "Tilbage til butikken",
                point_device_vto: "Ret mobilens kamera mod QR-koden for at prÃ¸ve produktet",
                point_device_ar: "Ret mobilens kamera mod QR-koden for at se produktet i dine omgivelser",
                if_have_camera: "Eller hvis din computer har et kamera",
                camera_access_denied: "Adgang til dit kamera blev nÃ¦gtet. Skift dine browserindstillinger og genindlÃ¦s siden.",
                scan_qr_below: "Scan QR-koden nedenfor for at teste pÃ¥ din mobil",
                preparing_vto: "IndlÃ¦ser Virtual Try On...",
                preparing_ar: "IndlÃ¦ser Augmented Reality...",
                no_ar_support: "Produktet er ikke kompatibelt med Augmented Reality.",
                browser_not_supported: "Denne browser og/eller enhed er ikke understÃ¸ttet. Chrome pÃ¥ Android eller Safari pÃ¥ iOS anbefales.",
                no_vto_support: "Produktet er ikke kompatibelt med Virtual Try On.",
                cannot_access_camera: "Kan ikke starte Virtual Try On, da adgang til kameraet blev nÃ¦gtet.",
                see_in_your_space: "Se i dit rum",
                try_on_yourself: "PrÃ¸v det selv",
                touch_and_drag: "TrÃ¦k for at rotere, knib for at zoome",
                quick_vto_tips: "Tips",
                room_well_lit: "SÃ¸rg for, at rummet er godt oplyst",
                swipe_to_move_glasses: "Stryg op eller ned for at flytte brillerne"
            }
        },
        9667: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = {
                scan_qr: "Scannen Sie den QR-Code",
                try_on_now: "Jetzt ausprobieren",
                try_on: "Anprobieren",
                see_in_ar: "In der Augmented Reality ansehen",
                back_to_store: "ZurÃ¼ck zum GeschÃ¤ft",
                point_device_vto: "Richten Sie die Kamera Ihres MobilgerÃ¤ts auf den unten stehenden QR-Code, um es anzuprobieren",
                point_device_ar: "Richten Sie die Kamera Ihres MobilgerÃ¤ts auf den unten stehenden QR-Code, um das Produkt in der erweiterten RealitÃ¤t zu sehen",
                if_have_camera: "Oder wenn Sie eine Kamera auf Ihrem Computer haben",
                camera_access_denied: "Der Kamerazugriff wurde verweigert. Ã„ndern Sie Ihre Browsereinstellungen und laden Sie die Seite neu.",
                scan_qr_below: "Scannen Sie den unten stehenden Code, um es auf Ihrem Telefon auszuprobieren",
                preparing_vto: "Virtuelles Anprobieren wird vorbereitet...",
                preparing_ar: "Erweiterte RealitÃ¤t wird vorbereitet...",
                no_ar_support: "Das Produkt unterstÃ¼tzt die erweiterte RealitÃ¤t nicht",
                browser_not_supported: "Dieser Browser/dieses GerÃ¤t wird nicht unterstÃ¼tzt. Versuchen Sie es mit einem anderen (Chrome auf Android und Safari auf iOS werden empfohlen).",
                no_vto_support: "Das Produkt unterstÃ¼tzt das virtuelle Anprobieren nicht",
                cannot_access_camera: "Es ist nicht mÃ¶glich, auf die Kamera zuzugreifen, um das virtuelle Anprobieren zu starten",
                see_in_your_space: "In Ihrem Raum ansehen",
                try_on_yourself: "Probieren Sie es selbst aus",
                touch_and_drag: "Zum Drehen ziehen, zum VergrÃ¶ÃŸern/Verkleinern kneifen",
                quick_vto_tips: "Tipps",
                room_well_lit: "Stellen Sie sicher, dass der Raum gut beleuchtet ist",
                swipe_to_move_glasses: "Wischen Sie nach oben oder unten, um die Brille zu bewegen"
            }
        },
        5058: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = {
                scan_qr: "Scan the QR Code",
                try_on_now: "Try On Now",
                try_on: "Try on",
                see_in_ar: "See in AR",
                back_to_store: "Back to Store",
                point_device_vto: "Point your mobile device camera at the QR code below to try it on",
                point_device_ar: "Point your mobile device camera at the QR code below to see the product in Augmented Reality",
                if_have_camera: "Or if you have a camera on your computer",
                camera_access_denied: "The access to the camera is denied. Change your browser settings and reload the page.",
                scan_qr_below: "Scan the code below to try it on your phone",
                preparing_vto: "Preparing Virtual Try On...",
                preparing_ar: "Preparing Augmented Reality...",
                no_ar_support: "The product doesn't support the Augmented Reality",
                browser_not_supported: "This browser/device isn't supported. Try another one (Chrome on Android and Safari on iOS are recommended).",
                no_vto_support: "The product doesn't support the Virtual Try On",
                cannot_access_camera: "Cannot access the camera to start the Virtual Try On",
                see_in_your_space: "See in your space",
                try_on_yourself: "Try it on yourself",
                touch_and_drag: "Drag to rotate, pinch to zoom",
                quick_vto_tips: "Tips",
                room_well_lit: "Make sure that the room is well-lit",
                swipe_to_move_glasses: "Swipe up or down to move the glasses",
                no_ar_support_in_browser: "The browser doesn't support the augmented reality.",
                only_iphone_x: "Virtual Try On currently supports only iPhone X or newer",
                no_product_key_in_url: "No product key in the URL search params"
            }
        },
        1444: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = {
                scan_qr: "Skanneeri QR koodi",
                try_on_now: "Proovi toodet kohe",
                try_on: "Proovi",
                see_in_ar: "AR tootevaade",
                back_to_store: "Tagasi e-poodi",
                point_device_vto: "Proovimiseks suuna mobiiltelefoni kaamera allolevale QR-koodile",
                point_device_ar: "Suunaake mobiili kaamera allolevale QR-kooodile, et nÃ¤ha toodet augumenteeritud realsuses",
                if_have_camera: "VÃµi kui teil on arvutis kaamera",
                camera_access_denied: "JuurdepÃ¤Ã¤s kaamerale on keelatud. Muutke brauseri seadeid ja laadige leht uuesti.",
                scan_qr_below: "Skanneerige QR koodi, et proovida toodet telefonis",
                preparing_vto: "Virtuaalse proovimise ettevalmistamine...",
                preparing_ar: "Augumenteeritud reaalsuse ettevalmistamine...",
                no_ar_support: "Toode ei toeta augumenteeritud reaalsust",
                browser_not_supported: "Seda brauserit/seadet ei toetata. Proovige mÃµnda muud (soovitatav on Chrome Androidis ja Safari iOS-is).",
                no_vto_support: "Toode ei toeta virtuaalset proovimist",
                cannot_access_camera: "Virtuaalne proovimine ei ole vÃµimalik, puudub ligipÃ¤Ã¤s kaamerale",
                see_in_your_space: "Vaata toodet virtuaalselt enda keskkonnas",
                try_on_yourself: "Proovige seda enda peal",
                touch_and_drag: "Lohista pÃ¶Ã¶ramiseks, suureenda et nÃ¤ha lÃ¤hemalt",
                quick_vto_tips: "NÃµuanded",
                room_well_lit: "Veendu, et ruum oleks hÃ¤sti valgustatud",
                swipe_to_move_glasses: "Prillide liigutamiseks pÃ¼hkige Ã¼les vÃµi alla"
            }
        },
        7577: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = {
                scan_qr: "Skannaa QR koodi",
                try_on_now: "Sovita yllesi nyt",
                try_on: "Sovita yllesi",
                see_in_ar: "NÃ¤hdÃ¤ LT",
                back_to_store: "Takaisin kauppaan",
                point_device_vto: "Osoita mobiililaitteesi kameralla kohti QR koodia sovittaaksesi tuotetta yllÃ¤si",
                point_device_ar: "Osoita mobiililaitteesi kameralla kohti QR koodia nÃ¤hdÃ¤ksesi tuotteesi virtuaalikuvassa",
                if_have_camera: "Vai onko sinulla kamera tietokoneessa?",
                camera_access_denied: "Kameraan ei saada yhteyttÃ¤. Vaihda selain asetuksia ja lataa sivu uudelleen.",
                scan_qr_below: "Skannaa alla oleva koodi ja sovita puhelimessasi.",
                preparing_vto: "Valmistelee virtuaalista sovitusta...",
                preparing_ar: "Valmistelee lisÃ¤ttyÃ¤ todellisuutta...",
                no_ar_support: "Tuote ei tue lisÃ¤ttyÃ¤ todellisuutta",
                browser_not_supported: "Selain tai laite ei ole tuettu. Kokeile jotain toista (Chrome Androidissa ja Safari iOS:ssa ovat suositeltuja selaimia).",
                no_vto_support: "TÃ¤mÃ¤ tuote ei tue Virtuaalista sovitusta.",
                cannot_access_camera: "Kameraan ei saada yhteyttÃ¤ jotta Virtuaalinen sovitus voitaisiin aloittaa",
                see_in_your_space: "Esikatselu tuotteesta omassa ympÃ¤ristÃ¶ssÃ¤si",
                try_on_yourself: "Kokeile itse",
                touch_and_drag: "VetÃ¤Ã¤ kÃ¤Ã¤ntÃ¤miseksi,  zoomaa nipistÃ¤mÃ¤llÃ¤",
                quick_vto_tips: "VinkkejÃ¤",
                room_well_lit: "Varmista, ettÃ¤ huone on hyvin valaistu",
                swipe_to_move_glasses: "PyyhkÃ¤ise ylÃ¶s tai alas siirtÃ¤Ã¤ksesi laseja"
            }
        },
        1247: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = {
                scan_qr: "Scannez le code QR",
                try_on_now: "Essayez maintenant",
                try_on: "Essayez",
                see_in_ar: "Voir en rÃ©alitÃ© augmentÃ©e",
                back_to_store: "Retour Ã  la boutique",
                point_device_vto: "Pointez la camÃ©ra de votre appareil mobile sur le code QR ci-dessous pour l'essayer",
                point_device_ar: "Pointez la camÃ©ra de votre appareil mobile sur le code QR ci-dessous pour voir le produit en rÃ©alitÃ© augmentÃ©e",
                if_have_camera: "Ou si vous avez une camÃ©ra sur votre ordinateur",
                camera_access_denied: "L'accÃ¨s Ã  la camÃ©ra est refusÃ©. Modifiez les paramÃ¨tres de votre navigateur et rechargez la page.",
                scan_qr_below: "Scannez le code ci-dessous pour l'essayer sur votre tÃ©lÃ©phone",
                preparing_vto: "PrÃ©paration de l'essayage virtuel...",
                preparing_ar: "PrÃ©paration de la rÃ©alitÃ© augmentÃ©e...",
                no_ar_support: "Le produit ne prend pas en charge la rÃ©alitÃ© augmentÃ©e",
                browser_not_supported: "Ce navigateur/appareil n'est pas pris en charge. Essayez-en un autre (Chrome sur Android et Safari sur iOS sont recommandÃ©s).",
                no_vto_support: "Le produit ne prend pas en charge l'essayage virtuel",
                cannot_access_camera: "Impossible d'accÃ©der Ã  la camÃ©ra pour commencer l'essayage virtuel",
                see_in_your_space: "Voir dans votre espace",
                try_on_yourself: "Essayez-le vous-mÃªme",
                touch_and_drag: "Faites glisser pour faire tourner, pincez pour zoomer",
                quick_vto_tips: "Conseils",
                room_well_lit: "Assurez-vous que la piÃ¨ce est bien Ã©clairÃ©e",
                swipe_to_move_glasses: "Faites glisser vers le haut ou vers le bas pour dÃ©placer les lunettes"
            }
        },
        1797: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = {
                scan_qr: "Skenuokite QR kodÄ…",
                try_on_now: "Pasimatuok Dabar",
                try_on: "Pasimatuok",
                see_in_ar: "Pamatyti PR",
                back_to_store: "Atgal Ä¯ ParduotuvÄ™",
                point_device_vto: "Nukreipkite savo Ä¯renginio kamerÄ… Ä¯ QR kodÄ… apaÄioje ir iÅ¡mÄ—ginkite",
                point_device_ar: "Nukreipkite savo Ä¯renginio kamerÄ… Ä¯ QR kodÄ… apaÄioje ir pamatykite prekÄ™ Papildytoje RealybÄ—je",
                if_have_camera: "Arba jei turite kamerÄ… savo kompiuteryje",
                camera_access_denied: "Prieiga prie kameros yra uÅ¾drausta. Pakeiskite savo narÅ¡yklÄ—s nustatymus ir perkraukite puslapÄ¯.",
                scan_qr_below: "Skenuokite kodÄ… apaÄioje iÅ¡ iÅ¡mÄ—ginkite savo telefone",
                preparing_vto: "RuoÅ¡iamas Virtualus Pasimatavimas",
                preparing_ar: "RuoÅ¡iama Papildytoji RealybÄ—",
                no_ar_support: "Å i prekÄ— nepalaiko Papildytosios RealybÄ—s",
                browser_not_supported: "Å i narÅ¡yklÄ—/Ä¯renginys yra nepalaikomi. PamÄ—ginkite kitÄ… (rekomenduojame Chrome narÅ¡yklÄ™ Android operacinÄ—je sistemoje ir Safari narÅ¡yklÄ™ iOS operacinÄ—je sistemoje)",
                no_vto_support: "Å i prekÄ— nepalaiko Virtualaus Pasimatavimo",
                cannot_access_camera: "Kamera yra nepasiekiama ir mes negalime pradÄ—ti Virtualiojo Pasimatavimo",
                see_in_your_space: "Pamatyk savo aplinkoje",
                try_on_yourself: "IÅ¡bandykite patys",
                touch_and_drag: "Pasuk Ä¯ Å¡onÄ… ir prisiartink",
                quick_vto_tips: "Patarimai",
                room_well_lit: "Ä®sitikink, kad patalpa yra gerai apÅ¡viesta",
                swipe_to_move_glasses: "Braukite aukÅ¡tyn arba Å¾emyn, kad perkeltumÄ—te akinius"
            }
        },
        648: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = {
                scan_qr: "NoskenÄ“ QR kodu",
                try_on_now: "Uzlaiko tÅ«lÄ«t",
                try_on: "Uzlaiko",
                see_in_ar: "RedzÄ“t PR",
                back_to_store: "AtpakaÄ¼ uz veikalu",
                point_device_vto: "PavÄ“rs savas mobilÄs ierÄ«ces kameru pret zemÄk redzamo QR kodu un uzlaiko",
                point_device_ar: "PavÄ“rs savas mobilÄs ierÄ«ces kameru pret zemÄk redzamo QR kodu, lai preci apskatÄ«tu paplaÅ¡inÄtajÄ realitÄtÄ“",
                if_have_camera: "Vai ja tavam datoram ir kamera",
                camera_access_denied: "PiekÄ¼uve kamerai ir liegta. Nomaini sava pÄrlÅ«ka iestatÄ«jumus un pÄrlÄdÄ“ lapu.",
                scan_qr_below: "NoskenÄ“ zemÄk redzamo kodu, lai pielaikotu savÄ tÄlrunÄ«.",
                preparing_vto: "Sagatavo virtuÄlo uzlaikoÅ¡anu...",
                preparing_ar: "Sagatavo paplaÅ¡inÄto realitÄti...",
                no_ar_support: "Prece neatbalsta paplaÅ¡inÄto realitÄti",
                browser_not_supported: "PÄrlÅ«ks/ierÄ«ce nav atbalstÄ«ta. PamÄ“Ä£ini izmantot citu (Chrome on Android ieteicams lieto Chrome un is â€“ Safari).",
                no_vto_support: "Prece neatbalsta virtuÄlo pielaikoÅ¡anu",
                cannot_access_camera: "Nevar piekÄ¼Å«t kamerai, lai sÄktu virtuÄlo pielaikoÅ¡anu",
                see_in_your_space: "Apskatiet virtuÄli savÄ vidÄ“",
                try_on_yourself: "IzmÄ“Ä£iniet to pats",
                touch_and_drag: "Velciet, lai pagrieztu, tuviniet, lai apskatÄ«tu sÄ«kÄk",
                quick_vto_tips: "Padomi",
                room_well_lit: "PÄrliecinieties, ka telpÄ ir labs apgaismojums",
                swipe_to_move_glasses: "Velciet uz augÅ¡u vai uz leju, lai pÄrvietotu brilles"
            }
        },
        9778: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = {
                scan_qr: "Scan de QR-code",
                try_on_now: "Nu proberen",
                try_on: "Uitproberen",
                see_in_ar: "Bekijken in AR",
                back_to_store: "Terug naar de winkel",
                point_device_vto: "Richt de camera van je mobiele apparaat op de onderstaande QR-code om het te proberen",
                point_device_ar: "Richt de camera van je mobiele apparaat op de onderstaande QR-code om het product in Augmented Reality te bekijken",
                if_have_camera: "Of als je een camera op je computer hebt",
                camera_access_denied: "De toegang tot de camera is geweigerd. Wijzig je browserinstellingen en herlaad de pagina.",
                scan_qr_below: "Scan de code hieronder om het op je telefoon te proberen",
                preparing_vto: "Voorbereiden van virtueel passen...",
                preparing_ar: "Voorbereiden van Augmented Reality...",
                no_ar_support: "Het product ondersteunt Augmented Reality niet",
                browser_not_supported: "Deze browser/apparaat wordt niet ondersteund. Probeer een andere (Chrome op Android en Safari op iOS worden aanbevolen).",
                no_vto_support: "Het product ondersteunt virtueel passen niet",
                cannot_access_camera: "Kan geen toegang krijgen tot de camera om het virtueel passen te starten",
                see_in_your_space: "Bekijk het in jouw ruimte",
                try_on_yourself: "Probeer het zelf",
                touch_and_drag: "Sleep om te draaien, knijp om in te zoomen",
                quick_vto_tips: "Tips",
                room_well_lit: "Zorg ervoor dat de kamer goed verlicht is",
                swipe_to_move_glasses: "Veeg omhoog of omlaag om de bril te verplaatsen"
            }
        },
        9059: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = {
                scan_qr: "Ð¡ÐºÐ°Ð½Ð¸Ñ€ÑƒÐ¹Ñ‚Ðµ QR ÐºÐ¾Ð´",
                try_on_now: "ÐŸÑ€Ð¸Ð¼ÐµÑ€ÑŒÑ‚Ðµ Ñ‚Ð¾Ð²Ð°Ñ€ ÑÑ€Ð°Ð·Ñƒ",
                try_on: "ÐŸÑ€Ð¸Ð¼ÐµÑ€Ð¸Ñ‚ÑŒ",
                see_in_ar: "ÐŸÐ¾ÑÐ¼Ð¾Ñ‚Ñ€ÐµÑ‚ÑŒ Ð² Ð”Ð ",
                back_to_store: "ÐÐ°Ð·Ð°Ð´ Ð² Ð¼Ð°Ð³Ð°Ð·Ð¸Ð½",
                point_device_vto: "Ð”Ð»Ñ Ð¿Ñ€Ð¸Ð¼ÐµÑ€ÐºÐ¸ Ð½Ð°Ð¿Ñ€Ð°Ð²ÑŒÑ‚Ðµ ÐºÐ°Ð¼ÐµÑ€Ñƒ Ð¼Ð¾Ð±Ð¸Ð»ÑŒÐ½Ð¾Ð³Ð¾ Ñ‚ÐµÐ»ÐµÑ„Ð¾Ð½Ð° Ð½Ð° QR ÐºÐ¾Ð´",
                point_device_ar: "ÐÐ°Ð²ÐµÐ´Ð¸Ñ‚Ðµ ÐºÐ°Ð¼ÐµÑ€Ñƒ Ð½Ð° QR ÐºÐ¾Ð´, Ñ‡Ñ‚Ð¾Ð±Ñ‹ Ð¿Ð¾ÑÐ¼Ð¾Ñ‚Ñ€ÐµÑ‚ÑŒ Ñ‚Ð¾Ð²Ð°Ñ€ Ð² Ð´Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð½Ð¾Ð¹ Ñ€ÐµÐ°Ð»ÑŒÐ½Ð¾ÑÑ‚Ð¸",
                if_have_camera: "Ð˜Ð»Ð¸ ÐµÑÐ»Ð¸ Ñƒ Ð’Ð°Ñ ÐµÑÑ‚ÑŒ ÐºÐ°Ð¼ÐµÑ€Ð° Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑŒÑŽÑ‚ÐµÑ€Ðµ",
                camera_access_denied: "Ð”Ð¾ÑÑ‚ÑƒÐ¿ Ðº ÐºÐ°Ð¼ÐµÑ€Ðµ Ð·Ð°Ð¿Ñ€ÐµÑ‰ÐµÐ½. ÐŸÐ¾Ð¶Ð°Ð»ÑƒÐ¹ÑÑ‚Ð°, Ð¸Ð·Ð¼ÐµÐ½Ð¸Ñ‚Ðµ Ð½Ð°ÑÑ‚Ñ€Ð¾Ð¹ÐºÐ¸ Ð±Ñ€Ð°ÑƒÐ·ÐµÑ€Ð° Ð¸ Ð·Ð°Ð³Ñ€ÑƒÐ·Ð¸Ñ‚Ðµ Ð´Ð°Ð½Ð½ÑƒÑŽ ÑÑ‚Ñ€Ð°Ð½Ð¸Ñ†Ñƒ ÑÐ½Ð¾Ð²Ð°.",
                scan_qr_below: "Ð¡ÐºÐ°Ð½Ð¸Ñ€ÑƒÐ¹Ñ‚Ðµ QR ÐºÐ¾Ð´, Ñ‡Ñ‚Ð¾Ð±Ñ‹ Ð¿Ñ€Ð¸Ð¼ÐµÑ€Ð¸Ñ‚ÑŒ Ñ‚Ð¾Ð²Ð°Ñ€ Ð½Ð° Ñ‚ÐµÐ»ÐµÑ„Ð¾Ð½Ðµ",
                preparing_vto: "ÐŸÐ¾Ð´Ð³Ð¾Ñ‚Ð¾Ð²ÐºÐ° Ðº Ð²Ð¸Ñ€Ñ‚ÑƒÐ°Ð»ÑŒÐ½Ð¾Ð¹ Ð¿Ñ€Ð¸Ð¼ÐµÑ€ÐºÐµ...",
                preparing_ar: "ÐŸÐ¾Ð´Ð³Ð¾Ñ‚Ð¾Ð²ÐºÐ° Ð´Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð½Ð¾Ð¹ Ñ€ÐµÐ°Ð»ÑŒÐ½Ð¾ÑÑ‚Ð¸...",
                no_ar_support: "Ð”Ð°Ð½Ð½Ñ‹Ð¹ Ñ‚Ð¾Ð²Ð°Ñ€ Ð½Ðµ Ð¿Ð¾Ð´Ð´ÐµÑ€Ð¶Ð¸Ð²Ð°ÐµÑ‚ÑÑ Ð² Ð´Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð½Ð¾Ð¹ Ñ€ÐµÐ°Ð»ÑŒÐ½Ð¾ÑÑ‚Ð¸",
                browser_not_supported: "Ð”Ð°Ð½Ð½Ñ‹Ð¹ Ð±Ñ€Ð°ÑƒÐ·ÐµÑ€ Ð½Ðµ Ð¿Ð¾Ð´Ð´ÐµÑ€Ð¶Ð¸Ð²Ð°ÐµÑ‚ÑÑ. ÐŸÐ¾Ð¿Ñ€Ð¾Ð±ÑƒÐ¹Ñ‚Ðµ Ð·Ð°Ð¹Ñ‚Ð¸ Ñ‡ÐµÑ€ÐµÐ· Ð´Ñ€ÑƒÐ³Ð¾Ð¹ Ð±Ñ€Ð°ÑƒÐ·ÐµÑ€ (Ð¿Ñ€ÐµÐ´Ð¿Ð¾Ñ‡Ñ‚Ð¸Ñ‚ÐµÐ»ÑŒÐ½Ð¾ Chrome Ð½Ð° Android Ð¸ Safari Ð½Ð° iOS)",
                no_vto_support: "Ð”Ð°Ð½Ð½Ñ‹Ð¹ Ñ‚Ð¾Ð²Ð°Ñ€ Ð½Ðµ Ð¿Ð¾Ð´Ð´ÐµÑ€Ð¶Ð¸Ð²Ð°ÐµÑ‚ Ñ„ÑƒÐ½ÐºÑ†Ð¸ÑŽ Ð²Ð¸Ñ€Ñ‚ÑƒÐ°Ð»ÑŒÐ½Ð¾Ð¹ Ð¿Ñ€Ð¸Ð¼ÐµÑ€ÐºÐ¸",
                cannot_access_camera: "Ð’Ð¸Ñ€Ñ‚ÑƒÐ°Ð»ÑŒÐ½Ð°Ñ Ð¿Ñ€Ð¸Ð¼ÐµÑ€ÐºÐ° Ð½ÐµÐ´Ð¾ÑÑ‚ÑƒÐ¿Ð½Ð° - Ð¾Ñ‚ÑÑƒÑ‚ÑÑ‚Ð²ÑƒÐµÑ‚ Ð´Ð¾ÑÑ‚ÑƒÐ¿ Ðº ÐºÐ°Ð¼ÐµÑ€Ðµ",
                see_in_your_space: "ÐŸÐ¾ÑÐ¼Ð¾Ñ‚Ñ€ÐµÑ‚ÑŒ Ñ‚Ð¾Ð²Ð°Ñ€ Ð² Ð´Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð½Ð¾Ð¹ Ñ€ÐµÐ°Ð»ÑŒÐ½Ð¾ÑÑ‚Ð¸",
                try_on_yourself: "ÐŸÑ€Ð¸Ð¼ÐµÑ€Ð¸Ñ‚ÑŒ Ð½Ð° ÑÐµÐ±Ðµ",
                touch_and_drag: "ÐŸÐµÑ€ÐµÑ‚Ð°ÑÐºÐ¸Ð²Ð°Ð¹Ñ‚Ðµ, Ñ‡Ñ‚Ð¾Ð±Ñ‹ Ð´Ð²Ð¸Ð³Ð°Ñ‚ÑŒ, Ð¸ Ð¸ÑÐ¿Ð¾Ð»ÑŒÐ·ÑƒÐ¹Ñ‚Ðµ Ð¶ÐµÑÑ‚ Ñ€Ð°Ð·Ð²ÐµÐ´ÐµÐ½Ð¸Ñ Ð¿Ð°Ð»ÑŒÑ†ÐµÐ², Ñ‡Ñ‚Ð¾Ð±Ñ‹ Ð¿Ñ€Ð¸Ð±Ð»Ð¸Ð·Ð¸Ñ‚ÑŒ",
                quick_vto_tips: "ÐŸÐ¾Ð´ÑÐºÐ°Ð·ÐºÐ¸",
                room_well_lit: "Ð£Ð±ÐµÐ´Ð¸Ñ‚ÐµÑÑŒ, Ñ‡Ñ‚Ð¾ ÐºÐ¾Ð¼Ð½Ð°Ñ‚Ð° Ñ…Ð¾Ñ€Ð¾ÑˆÐ¾ Ð¾ÑÐ²ÐµÑ‰ÐµÐ½Ð°",
                swipe_to_move_glasses: "ÐŸÑ€Ð¾Ð²ÐµÐ´Ð¸Ñ‚Ðµ Ð¿Ð¾ ÑÐºÑ€Ð°Ð½Ñƒ Ð²Ð²ÐµÑ€Ñ… Ð¸Ð»Ð¸ Ð²Ð½Ð¸Ð·, Ñ‡Ñ‚Ð¾Ð±Ñ‹ Ð¿ÐµÑ€ÐµÐ¼ÐµÑÑ‚Ð¸Ñ‚ÑŒ Ð¾Ñ‡ÐºÐ¸"
            }
        },
        429: (t, e, o) => {
            o.d(e, {
                Z: () => i
            });
            const i = {
                scan_qr: "Skanna QR-koden",
                try_on_now: "Prova nu",
                try_on: "Prova",
                see_in_ar: "Visa i din miljÃ¶",
                back_to_store: "Tillbaka till butiken",
                point_device_vto: "Rikta telefonens kamera mot QR-koden fÃ¶r att prova produkten",
                point_device_ar: "Rikta telefonens kamera mot QR-koden fÃ¶r att se produkten i din miljÃ¶",
                if_have_camera: "Eller om din dator har en kamera",
                camera_access_denied: "Ã…tkomsten till kameran nekades. Ã„ndra dina webblÃ¤sarinstÃ¤llningar och ladda om sidan.",
                scan_qr_below: "Skanna QR-koden nedan fÃ¶r att testa pÃ¥ din telefon",
                preparing_vto: "Laddar Virtual Try On...",
                preparing_ar: "Laddar Augmented Reality...",
                no_ar_support: "Produkten Ã¤r inte kompatibel med Augmented Reality.",
                browser_not_supported: "Denna webblÃ¤sare och/eller enhet stÃ¶ds inte. Chrome pÃ¥ Android och Safari pÃ¥ iOS rekommenderas.",
                no_vto_support: "Produkten Ã¤r inte kompatibel med Virtual Try On.",
                cannot_access_camera: "Kan inte starta Virtual Try On dÃ¥ Ã¥tkomsten till kameran nekades.",
                see_in_your_space: "Visa i din miljÃ¶",
                try_on_yourself: "Prova pÃ¥ dig sjÃ¤lv",
                touch_and_drag: "Svep fÃ¶r att rotera, nyp fÃ¶r att zooma",
                quick_vto_tips: "Tips",
                room_well_lit: "Se till att rummet Ã¤r vÃ¤l upplyst",
                swipe_to_move_glasses: "Svep upp eller ner fÃ¶r att flytta glasÃ¶gonen"
            }
        },
        4266: (t, e, o) => {
            t.exports = o.p + "images/artlabs-logo.svg"
        },
        4224: (t, e, o) => {
            t.exports = o.p + "images/vyking-logo.svg"
        },
        3195: (t, e, o) => {
            t.exports = o.p + "images/spinner.gif"
        }
    },
    o = {};

function i(t) {
    var n = o[t];
    if (void 0 !== n) return n.exports;
    var r = o[t] = {
        id: t,
        exports: {}
    };
    return e[t](r, r.exports, i), r.exports
}
i.m = e, i.n = t => {
    var e = t && t.__esModule ? () => t.default : () => t;
    return i.d(e, {
        a: e
    }), e
}, i.d = (t, e) => {
    for (var o in e) i.o(e, o) && !i.o(t, o) && Object.defineProperty(t, o, {
        enumerable: !0,
        get: e[o]
    })
}, i.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), i.p = "https://cdn.fibbl.com/", i.b = document.baseURI || self.location.href, (() => {
    var t = i(628),
        e = i(4918),
        o = i(608),
        n = (i(4955), i(1730), i(4427)),
        r = i(2318);
    (0, n.vF)("x-fibbl-3d-layer-switcher", '<div id="root"> <button id="images" class="active">Kuvat</button> <button id="d3">3D</button> </div> ', r.Z);
    const a = (0, t.Mn)('<div id="root"> <div id="loading"> <x-fibbl-spinner></x-fibbl-spinner> <span>Loading 3D model...</span> </div> </div> ', e.Z);
    (0, t.MW)("fibbl-3d-layer", class extends o.Z {
        #k = (0, t.j$)(this, a);
        root = this.#k.querySelector("#root");
        switcher = document.createElement("x-fibbl-3d-layer-switcher");
        switcherRoot = this.switcher.shadowRoot;
        mv = document.createElement("fibbl-model-viewer");
        _noAnalytics = !0;
        #z = !0;
        #M = !1;
        constructor() {
            super(), this.switcher.onclick = t => t.stopPropagation(), this.switcherRoot.querySelector("#d3").onclick = () => this.switchState("3d"), this.switcherRoot.querySelector("#images").onclick = () => this.switchState("images"), this.mv.setAttribute("part", "viewer")
        }
        switchState(t) {
            this.switcherRoot.querySelectorAll(".active").forEach((t => t.classList.remove("active"))), "3d" === t ? (this.dataset.enabled = "true", this.#M = !1, this.switcherRoot.querySelector("#d3").classList.add("active"), this.mv.classList.remove("hidden")) : (this.#M = !0, this.switcherRoot.querySelector("#images").classList.add("active"), this.mv.classList.add("hidden"), this.#z || "0" === getComputedStyle(this.mv).opacity ? this.dataset.enabled = "" : this.mv.addEventListener("transitionend", (() => {
                this.#M && (this.dataset.enabled = "")
            }), {
                once: !0
            }))
        }
        checkParent() {
            return this.parentElement ? "static" !== getComputedStyle(this.parentElement).position || (console.error(`${this.tagName.toLowerCase()}: the parent element MUST have a non-static position,\ne.g. add style="position: relative" to the following element`, this.parentElement), !1) : (console.error(`${this.tagName.toLowerCase()}: fibbl-3d-layer: there is no parent element`), !1)
        }
        async init() {
            if (!this.checkParent()) return this.hide();
            const t = this.dataset.productId;
            if (!t) return this.hide();
            const {
                types: e
            } = await this.getProduct(t);
            if (!e.d3) return this.hide();
            this.mv.dataset.productId = this.dataset.productId, this.mv.dataset._noTextHint = "false", this.mv.addEventListener("x-fibbl-loaded", (() => {
                this.root.classList.add("loaded"), this.#z = !1
            })), this.root.append(this.mv), this.parentElement.append(this.switcher), this.dataset.enabled = "false", this.showRoot()
        }
        disconnectedCallback() {
            super.disconnectedCallback(), this.switcher.remove()
        }
    })
})();